webpackJsonp([34,57],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = React;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FICModalHtml = exports.FICModalContainer = exports.default = exports.FICModalRawFooter = exports.FICModalRawTitle = exports.FICModalRawHeader = exports.FICModalBody = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.FICModalHeader = FICModalHeader;
exports.FICModalFooter = FICModalFooter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(54);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Modal = __webpack_require__(55);

var _Modal2 = _interopRequireDefault(_Modal);

var _FIC = __webpack_require__(11);

var _FIC2 = _interopRequireDefault(_FIC);

var _FICUtils = __webpack_require__(9);

var _FICUtils2 = _interopRequireDefault(_FICUtils);

var _FICTextButton = __webpack_require__(21);

var _FICTextButton2 = _interopRequireDefault(_FICTextButton);

__webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICModalBody = exports.FICModalBody = _Modal2.default.Body;
var FICModalRawHeader = exports.FICModalRawHeader = _Modal2.default.Header;
var FICModalRawTitle = exports.FICModalRawTitle = _Modal2.default.Title;
var FICModalRawFooter = exports.FICModalRawFooter = _Modal2.default.Footer;

var FICModal = function (_Component) {
  _inherits(FICModal, _Component);

  function FICModal(props) {
    _classCallCheck(this, FICModal);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.hideInBG = function () {
      _this.setState({ _visible: 'hidden' });
    };

    _this.showFromBG = function () {
      if (_this.state._visible === 'hidden') {
        _this.setState({ _visible: 'visible' }, function () {
          _this.focus();
          if (_this.props.onShowFromBG) {
            _this.props.onShowFromBG();
          }
        });
      }
    };

    _this.hide = function () {
      // Sarebbe close
      var id = _this.props.id;
      _this.setState({ _visible: 'closed' }, function () {
        if (_this._container) {
          _this._container.remove(id);
        }
      });
    };

    _this.requestClose = function () {
      if (_this.props.requestClose) {
        _this.props.requestClose().then(function (res) {
          return res && _this.hide();
        });
      } else {
        _this.hide();
      }
    };

    _this.focus = function () {
      setTimeout(function () {
        $('.fic-modal-' + _this.props.id).focus();
      }, 10); // Delay necessario
    };

    _this.renderChildren = function (props) {
      if (!_this.props.children) return null;
      return _react2.default.Children.map(_this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          hide: _this.hide
        });
      });
    };

    _this.state = {
      _visible: 'pre-show'
    };
    _this._mounted = true;
    _this._container = props.container;
    return _this;
  }

  FICModal.prototype.componentDidCatch = function componentDidCatch(error, info) {
    if (_FIC2.default.browser.name === 'ie' && _FIC2.default.browser.version < '11') {
      alert('Si è verificato un errore. Aggiorna il browser alla versione più recente.');
    }
  };

  FICModal.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.setState({ _visible: 'visible' }, function () {
        _this2.focus();
      });
    }, 0);
  };

  FICModal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._mounted = false;
  };

  FICModal.prototype.render = function render() {
    var style = { content: {} };
    if (this.props.width) {
      style.content.width = this.props.width;
    }
    var className = 'fic-modal fic-modal-' + this.props.id;
    if (this.props.scrollable) {
      className += ' scrollable';
    }
    return _react2.default.createElement(
      _reactModal2.default,
      {
        id: this.props.id,
        className: className,
        overlayClassName: 'fic-modal-overlay fic-modal-' + this.state._visible,
        isOpen: true,
        contentLabel: 'Finestra di dialogo',
        onHide: this.hide,
        style: style,
        onRequestClose: this.props.allowClose ? this.requestClose : undefined,
        tabindex: '-1',
        ariaHideApp: false },
      this.renderChildren() || _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(FICModalHeader, { html: this.props.htmlTitle }),
        _react2.default.createElement(
          FICModalBody,
          null,
          this.props.htmlBody
        ),
        _react2.default.createElement(FICModalFooter, { modal: this, html: this.props.htmlFooter, buttons: this.props.footerButtons })
      )
    );
  };

  return FICModal;
}(_react.Component);

exports.default = FICModal;


FICModal.propTypes = {
  allowClose: _propTypes2.default.bool
};

FICModal.defaultProps = {
  allowClose: true
};

var FICModalContainer = exports.FICModalContainer = function (_Component2) {
  _inherits(FICModalContainer, _Component2);

  function FICModalContainer(props) {
    _classCallCheck(this, FICModalContainer);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.add = function (properties) {
      _this3.setState(function (prevState) {
        var newId = new Date().getTime() + '-' + _FICUtils2.default.randomBetween(0, 10000);
        var newStack = prevState.propsStack.slice();
        properties.id = newId;
        for (var key in _this3.modalRefs) {
          if (!_this3.modalRefs.hasOwnProperty(key)) continue;
          _this3.modalRefs[key].hideInBG();
        }
        newStack.push(properties);
        return { propsStack: newStack };
      });
    };

    _this3.remove = function (id) {
      delete _this3.modalRefs[id];
      setTimeout(function () {
        _this3.setState(function (prevState) {
          var newStack = prevState.propsStack.slice();
          newStack = newStack.filter(function (item) {
            return item.id != id;
          });
          return { propsStack: newStack };
        });
      }, 500);
      if (Object.keys(_this3.modalRefs).length > 0) {
        var lastKey = void 0;
        // do not change or you'll get fired
        // seriously
        for (lastKey in _this3.modalRefs) {
          // do nothing
        }
        _this3.modalRefs[lastKey].showFromBG();
      }
    };

    _this3.state = {
      propsStack: []
    };
    _this3.modalRefs = {};
    return _this3;
  }

  FICModalContainer.prototype.render = function render() {
    var _this4 = this;

    return _react2.default.createElement(
      'div',
      null,
      this.state.propsStack.map(function (item, idx) {
        return _react2.default.createElement(
          FICModal,
          _extends({
            id: item.id,
            key: item.id,
            container: _this4,
            ref: function ref(modal) {
              if (modal && modal.state._visible !== 'closed') {
                _this4.modalRefs[item.id] = modal;
              }
            }
          }, item.props),
          item.content
        );
      })
    );
  };

  return FICModalContainer;
}(_react.Component);

FICModal.init = function (container) {
  FICModal.container = ReactDOM.render(_react2.default.createElement(FICModalContainer, null), container);
};

/*

USAGE:

FICModal.show({
  title: "Ciao",
  body: "Miao",
  actions: [
    {text: "Conferma", color: "success", onClick: null},
    {text: "Chiudi", color: "gray", onClick: null},
  ]
})

*/

FICModal.show = function (options) {
  FICModal.container.add({
    content: null,
    props: {
      width: options.width,
      htmlTitle: options.title,
      htmlBody: options.body,
      htmlFooter: options.footer,
      footerButtons: options.actions,
      allowClose: options.allowClose
    }
  });
};

FICModal.showMessage = function (title, message, smallMessage) {
  var confirmText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Chiudi';
  var confirmColor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'gray';

  FICModal.show({
    title: title,
    body: _react2.default.createElement(
      'span',
      null,
      message,
      smallMessage && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { className: 'small-gray-message' },
          smallMessage
        )
      )
    ),
    actions: [{ text: confirmText, color: confirmColor, onClick: null }]
  });
};

/*

USAGE:

FICModal.showCustom(<Component/>, {propName: "Abc"})

*/

FICModal.showCustom = function (content) {
  FICModal.showCustom(content, null);
};

FICModal.showCustom = function (content, modalProps) {
  FICModal.container.add({ content: content, props: modalProps });
};

function FICModalHeader(props) {
  return _react2.default.createElement(
    FICModalRawHeader,
    null,
    _react2.default.createElement(
      FICModalRawTitle,
      null,
      props.html
    )
  );
}

function itemsWithType(items, type) {
  if (!items) return [];else return items.map(function (item) {
    return _extends(item, { type: type });
  });
}

function FICModalFooter(props) {
  var footer = props.html;
  var items = [].concat(_toConsumableArray(itemsWithType(props.leftItems, 'left')), _toConsumableArray(itemsWithType(props.centerItems, 'center')), _toConsumableArray(itemsWithType([].concat(_toConsumableArray(props.rightItems), _toConsumableArray(props.buttons)).reverse(), 'right')));
  if (items) {
    footer = items.map(function (_ref, idx) {
      var hide = _ref.hide,
          html = _ref.html,
          type = _ref.type,
          icon = _ref.icon,
          _onClick = _ref.onClick,
          keepOpen = _ref.keepOpen,
          item = _objectWithoutProperties(_ref, ['hide', 'html', 'type', 'icon', 'onClick', 'keepOpen']);

      if (hide) {
        return null;
      }
      if (html) {
        return _react2.default.createElement(
          'div',
          {
            className: 'footer-item ' + type,
            key: idx,
            style: { display: 'inline-block', height: '31px' } },
          html
        );
      }
      return _react2.default.createElement(_FICTextButton2.default, _extends({
        className: 'footer-item ' + type,
        key: idx,
        iconLeft: icon,
        onClick: function onClick() {
          if (_onClick != null) {
            _onClick();
          }
          if (props.modal && !keepOpen) {
            props.modal.hide();
          }
        }
      }, item));
    });
  }
  return _react2.default.createElement(
    FICModalRawFooter,
    null,
    footer
  );
}

FICModalFooter.propTypes = {
  leftItems: _propTypes2.default.array,
  centerItems: _propTypes2.default.array,
  rightItems: _propTypes2.default.array,
  buttons: _propTypes2.default.array
};

FICModalFooter.defaultProps = {
  leftItems: [],
  centerItems: [],
  rightItems: [],
  buttons: []

  /*
  Modal html sporco
   */

  /*
  modalUrl = (url, params = {}) => {
    $.get(url, (data) => {
      if (FICModalHtml.lastHideCallback)
        FICModalHtml.lastHideCallback()
  
      FICModal.showCustom(<FICModalHtml html={data}/>, params)
    })
  }
  */

};
var FICModalHtml = exports.FICModalHtml = function (_Component3) {
  _inherits(FICModalHtml, _Component3);

  function FICModalHtml(props) {
    _classCallCheck(this, FICModalHtml);

    var _this5 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this5.body = null;
    FICModalHtml.lastHideCallback = props.hide;
    return _this5;
  }

  FICModalHtml.prototype.componentDidMount = function componentDidMount() {
    var _this6 = this;

    $(this.body).html(this.props.html);
    $(this.body).find('a[data-dismiss=\'modal\']').click(function () {
      _this6.props.hide();
    });
  };

  FICModalHtml.prototype.render = function render() {
    var _this7 = this;

    return _react2.default.createElement('div', { ref: function ref(element) {
        return _this7.body = element;
      } });
  };

  return FICModalHtml;
}(_react.Component);

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICInputText.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICInputText.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "input.fic-input-text-input,textarea.fic-input-text-input{background-color:#fff;border-radius:4px;border:1px solid #dee3ea;padding-left:10px;padding-right:10px;font-size:13px;margin-bottom:0;outline:none}textarea.fic-input-text-input{resize:none}input.fic-input-text-input::placeholder,textarea.fic-input-text-input::placeholder{font-size:13px}input.fic-input-text-input:focus,textarea.fic-input-text-input:focus{border-color:#007ce4;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,124,228,.1)}input.fic-input-text-input.fic-input-invalid,textarea.fic-input-text-input.fic-input-invalid{border-color:#f46e65;box-shadow:inset 0 1px 1px rgba(240,65,52,.1),0 0 0 3px rgba(240,65,52,.1)}input.fic-input-text-input::-webkit-contacts-auto-fill-button{visibility:hidden;display:none!important;pointer-events:none;height:0;width:0;margin:0}input.fic-input-text-input::-ms-clear{display:none}input.fic-input-text-input::-webkit-search-cancel-button{display:none;-webkit-appearance:none}input.fic-input-text-input[disabled],textarea.fic-input-text-input[disabled]{background-color:#f9f9f9}.fic-advanced-input-text{display:inline;position:relative}.fic-advanced-input-text b.fa{position:absolute;bottom:0;top:auto;margin:auto;font-size:14px;color:#d1d1d1}.fic-advanced-input-text b.fa.icon-left{left:7px;right:auto}.fic-advanced-input-text b.fa.icon-right{right:7px;left:auto}.fic-advanced-input-text span.text-left,.fic-advanced-input-text span.text-right{position:absolute;bottom:0;top:auto;margin:auto;color:#d1d1d1;height:17px;font-size:13px}.fic-advanced-input-text span.text-left{left:9px;right:auto}.fic-advanced-input-text span.text-right{right:9px;left:auto}", ""]);

// exports


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(105);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICActionButton.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICActionButton.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a .fic-action-button{vertical-align:middle}.fic-action-button{cursor:pointer}.fic-action-button-disabled{pointer-events:none;opacity:.8}.fic-action-button.small{font-size:14px}.fic-action-button.medium{font-size:18px}.fic-action-button.large{font-size:22px}.fic-action-button.fic-gray{color:#d1d1d1}.fic-action-button.fic-gray:hover{color:#9a9a9a}.fic-action-button.fic-primary{color:#007ce4}.fic-action-button.fic-primary:hover{color:#005ba7}.fic-action-button.fic-danger{color:#e72500}.fic-action-button.fic-danger:hover{color:#c82333}.fic-action-button.fic-blue{color:#08c}.fic-action-button.fic-blue:hover{color:#005580}.fic-action-button.fic-yellow{color:#ffb800}.fic-action-button.fic-yellow:hover{color:#ff8a00}.fic-action-button a,.fic-action-button a:focus,.fic-action-button a:hover{text-decoration:none}", ""]);

// exports


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICLink.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICLink.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".FICLink{line-height:30px;height:auto}.FICLink a{cursor:pointer}.FICLink.FICLink-disabled a{pointer-events:none;cursor:not-allowed;color:#b1b1b1}", ""]);

// exports


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _detectBrowser = __webpack_require__(116);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(39);

var _FICModal = __webpack_require__(10);

var _FICModal2 = _interopRequireDefault(_FICModal);

var _FICModal3 = __webpack_require__(50);

var _FICModal4 = _interopRequireDefault(_FICModal3);

var _FICAlert = __webpack_require__(14);

var _FICAlert2 = _interopRequireDefault(_FICAlert);

var _FICForm = __webpack_require__(33);

var _FICForm2 = _interopRequireDefault(_FICForm);

var _config = __webpack_require__(73);

var _MixPanelTracker = __webpack_require__(79);

var _MixPanelTracker2 = _interopRequireDefault(_MixPanelTracker);

var _HotjarTracker = __webpack_require__(80);

var _HotjarTracker2 = _interopRequireDefault(_HotjarTracker);

var _TagManagerTracker = __webpack_require__(81);

var _TagManagerTracker2 = _interopRequireDefault(_TagManagerTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // import Popup from 'react-popup'


// import '../css/Popup.css'

var FIC = function FIC() {
  _classCallCheck(this, FIC);
};

FIC.init = function () {
  // ReactDOM.render(<Popup />, overlayContainer)
  FIC.globals = reactGlobalParams;
  FIC.browser = (0, _detectBrowser.detect)();
  _FICModal2.default.init(document.getElementById('react-overlay-modal-container'));
  _FICModal4.default.init(document.getElementById('react-overlay-modal2-container'));
  _FICAlert2.default.init(document.getElementById('react-overlay-alert-container'));
  _FICForm2.default.init(_FICForm2.default.createConfig(_config.config));
  _moment2.default.locale('it');
  window.FICAlert = _FICAlert2.default;
};

FIC.can = function (accessLevel, moduleName) {
  var submoduleName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var permissions = FIC.globals.permissions;
  var p = void 0;
  if (!['read', 'write'].includes(accessLevel)) {
    return false;
  }
  if (!permissions || !permissions.hasOwnProperty(moduleName)) {
    return false;
  }
  if (permissions[moduleName] === 'detailed') {
    if (!permissions[moduleName + '_detailed'].hasOwnProperty(submoduleName)) {
      return false;
    }
    p = permissions[moduleName + '_detailed'][submoduleName];
  } else {
    p = permissions[moduleName];
  }
  if (p === 'none') {
    return false;
  }
  if (accessLevel === 'read') {
    return true;
  }
  return p === 'write';
};

FIC.canRead = function (moduleName) {
  var submoduleName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return FIC.can('read', moduleName, submoduleName);
};

FIC.canWrite = function (moduleName) {
  var submoduleName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return FIC.can('write', moduleName, submoduleName);
};

FIC.tracker = new _MixPanelTracker2.default();
FIC.tracker.setConfig({
  debug: false
});

FIC.hj = new _HotjarTracker2.default();

FIC.gtm = new _TagManagerTracker2.default();

exports.default = FIC;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutocomplete = __webpack_require__(94);

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

__webpack_require__(136);

var _FICTooltip = __webpack_require__(18);

var _FICTooltip2 = _interopRequireDefault(_FICTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICAutocomplete = function (_Component) {
  _inherits(FICAutocomplete, _Component);

  function FICAutocomplete(props) {
    _classCallCheck(this, FICAutocomplete);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.autocompleteRef = null;
    _this.firstLoad = false;
    _this.filter = props.value;
    _this.scheduledChange = null;
    _this.scheduledLoadOptions = null;
    _this.lastOnChangeValue = props.value || undefined;
    _this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined
    };
    return _this;
  }

  FICAutocomplete.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.autoFocus) {
      setTimeout(function () {
        _this2.focus();
        setTimeout(function () {
          _this2.setState({ useInternalValue: false });
        }, 0);
      }, 100);
    }
  };

  FICAutocomplete.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        placeholder = _props.placeholder,
        options = _props.options,
        loadOptions = _props.loadOptions,
        value = _props.value,
        idKey = _props.idKey,
        valueKey = _props.valueKey,
        labelKey = _props.labelKey,
        triggerLength = _props.triggerLength,
        maxMenuHeight = _props.maxMenuHeight,
        renderMenuContent = _props.renderMenuContent,
        _renderItem = _props.renderItem,
        validator = _props.validator,
        _shouldItemRender = _props.shouldItemRender,
        props = _objectWithoutProperties(_props, ['placeholder', 'options', 'loadOptions', 'value', 'idKey', 'valueKey', 'labelKey', 'triggerLength', 'maxMenuHeight', 'renderMenuContent', 'renderItem', 'validator', 'shouldItemRender']);

    var className = 'fic-autocomplete';
    if (maxMenuHeight) {
      className += ' fic-height-' + maxMenuHeight;
    }
    if (props.className) {
      className += ' ' + props.className;
    }
    var inputClassName = 'fic-input-text-input';
    if (validator && !validator.valid) {
      inputClassName += ' fic-input-invalid';
    }
    if (props.disabled) {
      inputClassName += ' fic-input-disabled';
    }
    value = this.getDisplayValue();
    var result = _react2.default.createElement(_reactAutocomplete2.default, {
      ref: function ref(_ref) {
        _this3.autocompleteRef = _ref;
      },
      wrapperProps: { className: className },
      getItemValue: function getItemValue(item) {
        return item[valueKey || labelKey];
      },
      wrapperStyle: {
        position: 'relative'
      },
      renderMenu: function renderMenu(items, value, style) {
        if (renderMenuContent) {
          return renderMenuContent(items, value, style);
        }

        if (!items || items.length === 0) {
          return _react2.default.createElement('div', null);
        }
        style.minWidth = 0;
        if (maxMenuHeight) {
          style.maxHeight = 30 * maxMenuHeight;
        }
        var displayMenu = triggerLength > _this3.filter.length ? 'none' : 'block';
        return _react2.default.createElement(
          'div',
          { className: 'fic-autocomplete-menu-outer', style: { display: displayMenu } },
          _react2.default.createElement('div', { style: style, children: items, className: 'fic-autocomplete-menu' })
        );
      },
      menuStyle: {
        position: 'absolute',
        top: 30,
        left: 0
      },
      items: options,
      renderItem: function renderItem(item, isHighlighted, styles) {
        var className = 'fic-autocomplete-option';
        if (isHighlighted) {
          className += ' is-focused';
        }
        return _renderItem ? _renderItem(item, className, styles) : _react2.default.createElement(
          'div',
          { key: item[idKey || labelKey], className: className },
          item[labelKey]
        );
        /* <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
          {item.label}
        </div> */
      }
      // renderInput={(props) => <FICInputText {...props}/>}
      , shouldItemRender: function shouldItemRender(item, value) {
        return _shouldItemRender ? _shouldItemRender(item, value) : item[labelKey] && item[labelKey].toLowerCase().indexOf(value.toLowerCase()) > -1;
      },

      inputProps: {
        className: inputClassName,
        placeholder: placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: props.onKeyPress,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp,
        onClick: props.onClick,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut,
        autoComplete: 'new-password',
        disabled: props.disabled,
        maxLength: props.maxLength
      },
      value: value,
      onChange: this.handleChange
      /* onChange={(event) => {
        const value = event.target.value
        this.filter = value
        if (onChange) {
          onChange(name, value, null, 'autocomplete')
          if (loadOptions) {
            if (this.scheduledChange)
              clearTimeout(this.scheduledChange)
            if (triggerLength <= this.filter.length)
              this.scheduledChange = setTimeout(() => loadOptions(value), loadOptionsDelay)
          }
        }
      }} */
      , onSelect: this.handleSelect,
      onMenuVisibilityChange: function onMenuVisibilityChange(isOpen) {
        if (isOpen && !_this3.firstLoad && loadOptions && triggerLength <= _this3.filter.length) {
          _this3.firstLoad = true;
          loadOptions('');
        }
      }
      /*
      placeholder={this.props.placeholder}
      clearable={this.props.clearable ? this.props.clearable : false}
      backspaceRemoves={false}
      deleteRemoves={false}
      autosize={false}
      value={this.props.value}
      valueKey={this.valueKey}
      labelKey={this.labelKey}
      autoload={false}
      onChange={(val) => this.props.onChange(this.props.name, val ? val[this.valueKey] : null, val ? val[this.labelKey] : null, 'typeahead')}
      noResultsText="Nessuna corrispondenza trovata"
      promptTextCreator={(label) => { return 'Crea nuovo "' + label + '"'}}
      searchPromptText="Inizia a digitare"
      loadingPlaceholder="Caricamento..."
      {...options}
      */
    });
    return this.props.validator ? _react2.default.createElement(
      _FICTooltip2.default,
      {
        placement: 'top',
        text: this.props.validator.message,
        trigger: this.props.validator.valid ? [] : ['hover', 'focus'],
        enabled: !this.props.validator.valid },
      _react2.default.createElement(
        'div',
        null,
        result
      )
    ) : result;
  };

  return FICAutocomplete;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.focus = function () {
    if (_this4.autocompleteRef) {
      _this4.autocompleteRef.focus();
    }
  };

  this.blur = function () {
    if (_this4.autocompleteRef) {
      _this4.autocompleteRef.blur();
    }
  };

  this.shouldUseInternalValue = function () {
    return _this4.props.changeOnBlur || !_this4.props.uncontrolled && _this4.props.changeDelay;
  };

  this.getDisplayValue = function () {
    var props = _this4.props;
    var state = _this4.state;
    return _this4.shouldUseInternalValue() && state.useInternalValue ? state.internalValue || '' : props.value != null ? props.value : '';
  };

  this.handleChange = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    // Options
    _this4.filter = value;
    if (props.loadOptions) {
      _this4.cancelScheduledLoadOptions();
      if (props.triggerLength <= value.length) {
        _this4.scheduleLoadOptions(value);
      }
    }
    // General input
    if (props.clearable) {
      _this4.setState({ clearableVisible: value });
    }
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value });
    }
    if (props.changeDelay) {
      _this4.cancelScheduledChange();
      _this4.scheduleChange(value);
    } else {
      _this4.executeOnChange(value);
    }
  };

  this.executeOnChange = function (value) {
    var props = _this4.props;
    if (props.onChange && value !== _this4.lastOnChangeValue) {
      _this4.lastOnChangeValue = value;
      props.onChange(props.name, value, null, 'autocomplete');
    }
  };

  this.handleSelect = function (value, data) {
    var props = _this4.props;
    value = data[props.valueKey ? props.valueKey : props.labelKey];
    _this4.cancelScheduledChange();
    _this4.cancelScheduledLoadOptions();
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value });
    }
    if (!props.preventChangeOnSelect) {
      _this4.executeOnChange(value);
    }
    if (props.onSelect) {
      _this4.lastOnChangeValue = value;
      props.onSelect(value, data);
    }
  };

  this.handleFocus = function (e) {
    var props = _this4.props;
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({
        useInternalValue: true,
        internalValue: props.value
      });
    }
    if (props.onFocus) {
      props.onFocus(e);
    }
  };

  this.handleBlur = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    _this4.setState({ useInternalValue: false });
    if (props.changeOnBlur) {
      _this4.executeOnChange(value);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  this.scheduleChange = function (value) {
    _this4.scheduledChange = setTimeout(function () {
      _this4.executeOnChange(value);
    }, _this4.props.changeDelay);
  };

  this.cancelScheduledChange = function () {
    if (_this4.scheduledChange) {
      clearTimeout(_this4.scheduledChange);
    }
  };

  this.scheduleLoadOptions = function (value) {
    _this4.scheduledLoadOptions = setTimeout(function () {
      return _this4.props.loadOptions(value);
    }, _this4.props.loadOptionsDelay);
  };

  this.cancelScheduledLoadOptions = function () {
    if (_this4.scheduledLoadOptions) {
      clearTimeout(_this4.scheduledLoadOptions);
    }
  };
};

FICAutocomplete.propTypes = {
  className: _propTypes2.default.string,
  options: _propTypes2.default.array,
  loadOptions: _propTypes2.default.func,
  loadOptionsDelay: _propTypes2.default.number,
  triggerLength: _propTypes2.default.number,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  idKey: _propTypes2.default.string,
  valueKey: _propTypes2.default.string,
  labelKey: _propTypes2.default.string,
  emptyLabel: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  changeOnBlur: _propTypes2.default.bool,
  changeDelay: _propTypes2.default.number,
  clearable: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  maxMenuHeight: _propTypes2.default.number,
  preventChangeOnSelect: _propTypes2.default.bool,
  renderMenuContent: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  autoFocus: _propTypes2.default.bool,
  maxLength: _propTypes2.default.number
};

FICAutocomplete.defaultProps = {
  className: undefined,
  options: [],
  loadOptions: undefined,
  loadOptionsDelay: 0,
  triggerLength: 0,
  value: '',
  idKey: undefined,
  valueKey: undefined,
  labelKey: 'label',
  emptyLabel: '',
  placeholder: '',
  onSelect: undefined,
  onChange: undefined,
  changeOnBlur: true,
  changeDelay: 500,
  clearable: true,
  disabled: undefined,
  maxMenuHeight: undefined,
  preventChangeOnSelect: false,
  renderMenuContent: undefined,
  renderItem: undefined,
  autoFocus: false,
  maxLength: undefined
};

exports.default = FICAutocomplete;


function AutocompleteTooltipAdapter(props) {
  var newProps = _extends({}, props);
  if (newProps['aria-describedby']) {
    newProps.inputProps['aria-describedby'] = newProps['aria-describedby'];
  }
  return _react2.default.createElement(_reactAutocomplete2.default, newProps);
}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICColors = function FICColors() {
  _classCallCheck(this, FICColors);
};

FICColors.primary = '#007ce4';
FICColors.success = '#4cbe00';
FICColors.danger = '#e72500';
FICColors.warning = '#f57100';
FICColors.gray = '#7e91aa';
FICColors.yellow = '#ffb800';

FICColors.borderPrimary = '#007ce4';
FICColors.borderSuccess = '#36c200';
FICColors.borderDanger = '#cc0000';
FICColors.borderWarning = '#f57100';
FICColors.borderGray = '#888e97';

FICColors.hoverPrimary = '#005ba7';
FICColors.hoverSuccess = '#4cbe00'; // TODO
FICColors.hoverDanger = '#e72500'; // TODO
FICColors.hoverWarning = '#f57100'; // TODO
FICColors.hoverGray = '#7e91aa'; // TODO
FICColors.hoverYellow = '#ff8a00';

FICColors.textDefault = '#555';
FICColors.textDescription = '#aaaaaa';
FICColors.textGray = '#888';
FICColors.textLink = '#0088cc';
FICColors.textSuccess = '#00b600';
FICColors.textDanger = '#e70000';
FICColors.textDisabled = '#b1b1b1';

FICColors.white = '#fff';
FICColors.lightGray = '#fafafa';
FICColors.defaultBlue = '#0094D4';

FICColors.lightBorderColor = '#d5d5d563';
FICColors.shadowColor = 'rgba(0, 0, 0, 0.06)';

FICColors.messageTextSuccess = '#3c763d';
FICColors.messageTextInfo = '#31708f';
FICColors.messageTextWarning = '#8a6d3b';
FICColors.messageTextDanger = '#a94442';

FICColors.messageBorderSuccess = '#d6e9c6';
FICColors.messageBorderInfo = '#bce8f1';
FICColors.messageBorderWarning = '#faebcc';
FICColors.messageBorderDanger = '#ebccd1';

FICColors.messageBackgroundSuccess = '#dff0d8';
FICColors.messageBackgroundInfo = '#d9edf7';
FICColors.messageBackgroundWarning = '#fcf8e3';
FICColors.messageBackgroundDanger = '#f2dede';

FICColors.actionButton = { gray: '#d1d1d1' };

exports.default = FICColors;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICAutocomplete.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICAutocomplete.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fic-autocomplete input:not([disabled]){padding:0 10px;font-size:13px;color:#555}.fic-autocomplete input:-ms-input-placeholder{color:#9ba0a5}.fic-autocomplete input::-webkit-contacts-auto-fill-button{visibility:hidden;display:none!important;pointer-events:none;height:0;width:0;margin:0}.fic-autocomplete .fic-autocomplete-option{padding:5px 10px;text-align:left;font-size:13px;cursor:pointer}.fic-autocomplete .fic-autocomplete-option.is-selected{background-color:rgba(0,124,228,.1)}.fic-autocomplete .fic-autocomplete-option.is-focused{background-color:#007ce4;color:#fff}.fic-autocomplete .fic-autocomplete-menu{box-sizing:border-box}.fic-autocomplete .fic-autocomplete-menu-outer{border-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:0;max-height:200px;position:absolute;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch;overflow-x:hidden;overflow-y:visible}", ""]);

// exports


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactSAlert = __webpack_require__(118);

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _FAIcon = __webpack_require__(6);

var _FAIcon2 = _interopRequireDefault(_FAIcon);

__webpack_require__(119);

__webpack_require__(120);

__webpack_require__(69);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICAlert = function FICAlert() {
  _classCallCheck(this, FICAlert);
};

FICAlert.init = function (container) {
  FICAlert.container = ReactDOM.render(_react2.default.createElement(_reactSAlert2.default, { stack: { limit: 4, spacing: 20 } }), container);
};

FICAlert.show = function (type, message) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;

  // const successAlert = <FAIcon name="" />
  var mapping = {
    success: 'check-circle',
    error: 'exclamation-circle',
    warning: 'exclamation-triangle',
    info: 'info-circle'
  };
  var iconName = mapping[type];
  var customMessage = _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'icon' },
      _react2.default.createElement(_FAIcon2.default, { name: iconName })
    ),
    _react2.default.createElement(
      'div',
      { className: 'text' },
      message
    )
  );

  var options = {
    position: 'bottom-right',
    effect: 'slide',
    offset: 70,
    timeout: duration || 'none'
  };
  return _reactSAlert2.default[type](customMessage, options);
};

FICAlert.success = function (message) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

  return FICAlert.show('success', message, duration);
};

FICAlert.error = function (message) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

  return FICAlert.show('error', message, duration);
};

FICAlert.warning = function (message) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

  return FICAlert.show('warning', message, duration);
};

FICAlert.info = function (message) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

  return FICAlert.show('info', message, duration);
};

FICAlert.close = function (id) {
  _reactSAlert2.default.close(id);
};

FICAlert.closeAll = function () {
  _reactSAlert2.default.closeAll();
};

exports.default = FICAlert;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FICUtils = __webpack_require__(9);

var _FICUtils2 = _interopRequireDefault(_FICUtils);

var _FICModal = __webpack_require__(10);

var _FICModal2 = _interopRequireDefault(_FICModal);

var _FICMultilineTextView = __webpack_require__(53);

var _FICMultilineTextView2 = _interopRequireDefault(_FICMultilineTextView);

var _downloadjs = __webpack_require__(57);

var _downloadjs2 = _interopRequireDefault(_downloadjs);

var _FICAlert = __webpack_require__(14);

var _FICAlert2 = _interopRequireDefault(_FICAlert);

var _FICNetwork = __webpack_require__(38);

var _FICNetwork2 = _interopRequireDefault(_FICNetwork);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICRestV2 = function FICRestV2() {
  _classCallCheck(this, FICRestV2);
};

FICRestV2.execute = function (_ref) {
  var method = _ref.method,
      url = _ref.url,
      request = _ref.request,
      queryData = _ref.queryData,
      postData = _ref.postData,
      formData = _ref.formData,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      onComplete = _ref.onComplete,
      formMapping = _ref.formMapping,
      noAlerts = _ref.noAlerts;

  var query = $.param(queryData || {});
  var data = void 0;
  if (formData) {
    data = new FormData();
    Object.keys(formData).forEach(function (key) {
      data.append(key, formData[key]);
    });
  } else {
    data = JSON.stringify(postData);
  }
  var headers = {
    'Content-Type': !formData ? 'application/json; charset=utf-8' : undefined,
    'Accept-Language': 'it'
  };
  if (reactGlobalParams.access_token) {
    headers['Authorization'] = reactGlobalParams.access_token;
  }
  if (reactGlobalParams.adminAccountId) {
    headers['Admin-Account-Id'] = reactGlobalParams.adminAccountId;
  }
  var options = {
    url: url + '/' + request + (query ? '?' + query : ''),
    method: method,
    dataType: 'json',
    headers: headers,
    data: data,
    jsonp: false,
    cache: formData ? false : undefined,
    contentType: formData ? false : undefined,
    processData: formData ? false : undefined,
    type: formData ? 'POST' : undefined,
    success: function success(responseData, result, rawData) {
      if (FICRestV2.handleQuestion({ responseData: responseData, method: method, url: url, request: request, queryData: queryData, postData: postData, onSuccess: onSuccess, onError: onError, onComplete: onComplete, formMapping: formMapping })) {
        return;
      }

      FICRestV2.handlePopup(responseData);

      var alertShown = noAlerts || FICRestV2.handleAlert(responseData);
      var success = rawData.status >= 200 && rawData.status < 300;
      if (success) {
        if (onSuccess) {
          onSuccess(responseData);
        }
      } else if (onError) {
        onError(responseData);
      } else if (!alertShown) {
        if (!FICRestV2.handleValidationError(responseData, formMapping)) {
          if (!FICRestV2.handleError(responseData)) {
            _FICAlert2.default.error('Si è verificato un errore sconosciuto.');
          }
        }
      }
    },
    error: function error(rawData, result, statusMessage) {
      var responseData = rawData.responseJSON;
      if (!rawData.responseJSON && rawData.readyState !== 0) {
        // Comportamento inatteso
      }
      if (FICRestV2.handleQuestion({ responseData: responseData, method: method, url: url, request: request, queryData: queryData, postData: postData, onSuccess: onSuccess, onError: onError, onComplete: onComplete, formMapping: formMapping })) {
        return;
      }

      var alertShown = noAlerts || FICRestV2.handleAlert(responseData, onError);
      var handleError = true;
      if (onError) {
        handleError = onError(responseData, rawData);
      }
      if (handleError && !alertShown) {
        if (!FICRestV2.handleValidationError(responseData, formMapping)) {
          if (!FICRestV2.handleError(responseData)) {
            _FICAlert2.default.error('Si è verificato un errore sconosciuto.');
          }
        }
      }
    },
    complete: function complete(response, status) {
      var responseData = response.responseJSON;
      if (onComplete) {
        onComplete(responseData, status);
      }
    }
  };
  return $.ajax(options);
};

FICRestV2.handleAlert = function (responseData) {
  if (responseData && responseData.extra) {
    if (responseData.extra.alert) {
      _FICAlert2.default.show(responseData.extra.alert.type, responseData.extra.alert.message, responseData.extra.alert.duration || 5000);
      return true;
    }
  }
};

FICRestV2.handleError = function (responseData) {
  if (responseData && responseData.error && responseData.error.message) {
    _FICAlert2.default.error(responseData.error.message);
    return true;
  }
  return false;
};

FICRestV2.handleValidationError = function (responseData, formMapping) {
  if (responseData && responseData.error && responseData.error.validation_result) {
    var validations = responseData.error.validation_result;
    var fields = Object.keys(validations);
    if (fields.length > 0) {
      var field = fields[0];
      var message = validations[field][0];
      _FICAlert2.default.error(message);
      return true;
    }
  }
  return false;
};

FICRestV2.handleQuestion = function (_ref2) {
  var responseData = _ref2.responseData,
      params = _objectWithoutProperties(_ref2, ['responseData']);

  if (!responseData || !responseData.extra || !responseData.extra.question) {
    return false;
  }
  var question = responseData.extra.question;
  var options = question.options;
  var actions = [];

  var _loop = function _loop(o) {
    actions.push({
      text: o,
      color: options[o].color,
      onClick: options[o].value == null ? null : function () {
        var requestField = ['GET', 'DELETE'].includes(params.method) ? 'queryData' : 'postData';
        var newData = params[requestField] ? _FICUtils2.default.clone(params[requestField]) : {};
        if (!newData['_answers']) {
          newData['_answers'] = {};
        }
        newData['_answers'][question.name] = options[o].value;
        FICRestV2.execute(_extends({}, params, _defineProperty({}, requestField, newData)));
      }
    });
  };

  for (var o in options) {
    _loop(o);
  }
  _FICModal2.default.show({
    title: question.title,
    body: _react2.default.createElement(
      _FICMultilineTextView2.default,
      null,
      question.message
    ),
    actions: actions,
    allowClose: actions && actions.some(function (action) {
      return action.onClick === null;
    })
  });

  return true;
};

FICRestV2.handlePopup = function (responseData) {
  if (!responseData || !responseData.extra || !responseData.extra.popup) {
    return false;
  }
  var popup = responseData.extra.popup;
  _FICModal2.default.showMessage(popup.title, popup.message, null, popup.confirm_text, popup.confirm_color);
  return true;
};

FICRestV2.rest = function (params) {
  return FICRestV2.execute(_extends({}, params, { url: reactGlobalParams.api_host }));
};
FICRestV2.get = function (params) {
  return FICRestV2.rest(_extends({}, params, { method: 'GET' }));
};
FICRestV2.delete = function (params) {
  return FICRestV2.rest(_extends({}, params, { method: 'DELETE' }));
};
FICRestV2.post = function (params) {
  return FICRestV2.rest(_extends({}, params, { method: 'POST' }));
};
FICRestV2.put = function (params) {
  return FICRestV2.rest(_extends({}, params, { method: 'PUT' }));
};
FICRestV2.patch = function (params) {
  return FICRestV2.rest(_extends({}, params, { method: 'PATCH' }));
};
FICRestV2.navigate = function (request, queryData) {
  var returnUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var query = $.param(queryData || {});
  var url = reactGlobalParams.api_host + '/' + request + (query ? '?' + query : '');
  if (returnUrl) {
    return url;
  }
  window.open(url);
};

FICRestV2.download = function (_ref3) {
  var method = _ref3.method,
      url = _ref3.url,
      request = _ref3.request,
      queryData = _ref3.queryData,
      postData = _ref3.postData,
      filename = _ref3.filename,
      onSuccess = _ref3.onSuccess,
      onError = _ref3.onError;

  url = url || reactGlobalParams.api_host;
  var query = $.param(queryData || {});

  url = url + '/' + request + (query ? '?' + query : '');
  method = method || 'GET';

  var xhr = new XMLHttpRequest();
  xhr.open(method, url, true);
  xhr.setRequestHeader('Authorization', reactGlobalParams.access_token);
  if (method === 'POST' && postData) {
    xhr.setRequestHeader('Content-type', 'application/json');
  }
  if (reactGlobalParams.adminAccountId) {
    xhr.setRequestHeader('Admin-Account-Id', reactGlobalParams.adminAccountId);
  }

  xhr.responseType = 'blob';
  xhr.onload = function (e) {
    if (this.status === 200) {
      var headers = xhr.getAllResponseHeaders().split('\n');
      var disposition = headers.filter(function (header) {
        return header.startsWith('content-disposition') || header.startsWith('Content-Disposition');
      });
      if (disposition.length > 0) {
        filename = (0, _FICNetwork.headerFilename)(disposition[0]);
      }

      (0, _downloadjs2.default)(new Blob([this.response]), filename);

      if (onSuccess) {
        onSuccess();
      }
    } else {
      var blob = new Blob([this.response], { type: 'application/json' });
      var reader = new FileReader();

      reader.readAsText(blob);
      reader.addEventListener('loadend', function (e) {
        var text = e.srcElement.result;
        var responseArray = JSON.parse(text);

        if (onError) {
          onError(responseArray.error);
        } else {
          _FICAlert2.default.error(responseArray.error.message);
        }
      });
    }
  };

  var body = postData ? JSON.stringify(postData) : '';
  xhr.send(body);
};

/*
FICRestV2.download = ({ method, url, request, queryData, postData, filename, onSuccess, onError }) => {
  url = url || reactGlobalParams.api_host
  const query = $.param(queryData ? queryData : {})
  let options = {
    url: url + '/' + request + (query ? ('?' + query) : ''),
    method: method || 'GET',
    headers: { 'Authorization': reactGlobalParams.access_token, 'Content-Type': 'application/json; charset=utf-8' },
    data: JSON.stringify(postData),
    success: function (responseData, result, rawData) {
      if (!filename) {
        const headers = rawData.getAllResponseHeaders().split('\n')
        let disposition = headers.filter(header => header.startsWith('content-disposition') || header.startsWith('Content-Disposition'))
        if (disposition.length > 0)
          filename = headerFilename(disposition[0])
      }

      download(rawData.responseText, filename)
    },
    error: function (rawData, result, statusMessage) {

    },
  }
  $.ajax(options)
}
*/

/*
FICRestV2.download = (params) => {
  let myHeaders = new Headers({
    'Content-Type': 'application/json; charset=utf-8',
    'Authorization': reactGlobalParams.access_token,
  })
  const { method, request, queryData, data, onSuccess, onError } = params
  const query = $.param(queryData ? queryData : {})
  let url = reactGlobalParams.api_host + '/' + request + '?' + query
  let filename
  return fetch(url, {
    method: method || 'GET',
    headers: myHeaders,
    body: JSON.stringify(data),
    credentials: 'same-origin',
    mode: 'cors',
  }).then(resp => {
    filename = resp.headers.get('File-Name') || 'download'
    return resp.blob()
  }).then(blob => {
    download(blob, filename)
    if (onSuccess)
      onSuccess()
  })
}
*/
exports.default = FICRestV2;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  ul{margin-bottom: 0;}\n'], ['\n  ul{margin-bottom: 0;}\n']);

var _OverlayTrigger = __webpack_require__(153);

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Tooltip = __webpack_require__(154);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FICTooltipImpl = function FICTooltipImpl(props) {
  var children = props.children,
      text = props.text,
      enabled = props.enabled,
      className = props.className,
      tooltipProps = _objectWithoutProperties(props, ['children', 'text', 'enabled', 'className']);

  return React.createElement(
    _OverlayTrigger2.default,
    _extends({}, tooltipProps, { overlay: React.createElement(
        _Tooltip2.default,
        { id: 'tooltip', className: 'fic-tooltip ' + className + (enabled ? '' : ' fic-tooltip-invisible') },
        text
      ) }),
    children
  );
};

FICTooltipImpl.propTypes = {
  trigger: _propTypes2.default.array,
  enabled: _propTypes2.default.bool,
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  placement: _propTypes2.default.string
};

FICTooltipImpl.defaultProps = {
  trigger: ['hover', 'focus'],
  enabled: true,
  text: undefined,
  placement: 'top'
};

var FICTooltip = (0, _styledComponents2.default)(FICTooltipImpl)(_templateObject);

FICTooltip.propTypes = {
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  delayShow: _propTypes2.default.number,
  enabled: _propTypes2.default.bool
};

exports.default = FICTooltip;

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  cursor: pointer;\n  text-decoration: none;\n  &:hover{\n    color: ', ';\n    text-decoration: underline;\n  }\n'], ['\n  color: ', ';\n  cursor: pointer;\n  text-decoration: none;\n  &:hover{\n    color: ', ';\n    text-decoration: underline;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICBaseButton = __webpack_require__(35);

var _FICBaseButton2 = _interopRequireDefault(_FICBaseButton);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Renderizza un tag <a>
 * accetta solo testo (obbligatorio) e due parametri opzionali per il colore (color, colorHover)
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function FICLinkImpl(props) {
  return _react2.default.createElement(_FICBaseButton2.default, _extends({}, props, {
    className: props.className,
    style: props.style,
    renderButton: renderLink
  }));
}

function renderLink(props) {
  return props.text;
}

var FICLink = (0, _styledComponents2.default)(FICLinkImpl)(_templateObject, function (props) {
  return props.color ? props.color : _FICColors2.default.link.normal;
}, function (props) {
  return props.colorHover ? props.colorHover : _FICColors2.default.link.hover;
});

FICLink.propTypes = {
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  isDisabled: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  renderButton: _propTypes2.default.func,
  color: _propTypes2.default.string,
  colorHover: _propTypes2.default.string,
  style: _propTypes2.default.object,
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

FICLink.defaultProps = _extends({}, _FICBaseButton2.default.defaultProps, {
  color: undefined,
  colorHover: undefined,
  text: '',
  className: undefined
});

FICLinkImpl.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

FICLinkImpl.defaultProps = {
  className: undefined,
  style: undefined
};

exports.default = FICLink;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICNumbers = function FICNumbers() {
  _classCallCheck(this, FICNumbers);
};

FICNumbers.parse = function (string) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  string = FICNumbers.commasToDots(string);
  if (!strict) {
    string = string.replace(/[^\d.-]/g, '');
  } else if (/[^\d.-]/g.test(string)) {
    return NaN;
  }
  var n = parseFloat(string);
  return !strict && isNaN(n) ? 0 : n;
};

FICNumbers.randomBetween = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

FICNumbers.qtyPrecision = 6;

FICNumbers.roundToTwo = function (num) {
  return FICNumbers.roundToDigit(num, 2);
};

FICNumbers.roundToDigit = function (num, digits) {
  if (num < 1.0e-6 && num > -1.0e-6) return 0;
  return +(Math.round(num * FICNumbers.nSign(num) + 'e+' + digits) + 'e-' + digits) * FICNumbers.nSign(num);
};

FICNumbers.nSign = function (num) {
  if (num > 0) return 1;
  if (num < 0) return -1;
  return 0;
};

FICNumbers.roundSignificative = function (n) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FICNumbers.qtyPrecision;

  if (digits === undefined) {
    digits = 0;
  }
  var point = 0;
  var sign = FICNumbers.nSign(n);
  n *= sign;
  if (n >= 1) {
    for (var i = 1; i < 15; i++) {
      if (n / Math.pow(10, i) < 1) {
        point = -i + digits;
        break;
      }
    }
  } else {
    for (var _i = 1; _i < 15; _i++) {
      if (n * Math.pow(10, _i) > 1) {
        point = _i + digits - 1;
        break;
      }
    }
  }
  if (point < 0) {
    return sign * FICNumbers.roundToDigit(n / Math.pow(10, -point), 0) * Math.pow(10, -point);
  }
  return sign * FICNumbers.roundToDigit(n, point);
};

FICNumbers.dotsToCommas = function (txt) {
  if (txt === undefined) return '';
  return String(txt).replace('.', ',');
};

FICNumbers.commasToDots = function (txt) {
  if (txt === undefined) return '';
  return String(txt).replace(',', '.');
};

exports.default = FICNumbers;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: inline;\n'], ['\n  display: inline;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FAIcon = __webpack_require__(6);

var _FAIcon2 = _interopRequireDefault(_FAIcon);

__webpack_require__(62);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentsUtils = __webpack_require__(64);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/*

PROPS:
- text: (default "")
- color: (default primary)
- size: (default large)
- iconLeft: (default undefined)
- iconRight: (default undefined)
- style
- onClick
- href
- loading
- disabled
*/

var FICTextButton = function (_Component) {
  _inherits(FICTextButton, _Component);

  function FICTextButton(props) {
    _classCallCheck(this, FICTextButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.clickable = true;
    return _this;
  }

  FICTextButton.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var color = props.color ? props.color : 'primary';
    var size = props.size ? props.size : 'large';
    var disable = props.disabled ? 'btn-disabled' : '';
    var className = 'fic-text-button btn-flat ' + color + ' ' + size + ' ' + disable + (props.className ? ' ' + props.className : '');
    var dataSet = (0, _componentsUtils.buildDataSetObject)(props.dataSet);

    var iconLeft = null;var iconRight = null;
    if (props.loading) {
      iconLeft = _react2.default.createElement(Icon, { name: 'circle-o-notch fa-spin', style: { marginRight: props.text ? 3 : 0 } });
    } else if (props.iconLeft) {
      iconLeft = _react2.default.createElement(Icon, { name: props.iconLeft, style: { marginRight: props.text ? 4 : 0 } });
    }
    if (props.iconRight) {
      iconRight = _react2.default.createElement(Icon, { name: props.iconRight, style: { marginLeft: props.text ? 4 : 0 } });
    }
    return _react2.default.createElement(
      'a',
      _extends({
        className: className,
        style: props.style,
        onClick: function onClick() {
          if (!_this2.clickable || props.loading || props.disabled) {
            return;
          }
          _this2.clickable = false;
          setTimeout(function () {
            _this2.clickable = true;
          }, 500);
          if (props.onClick) {
            props.onClick();
          }
        },
        href: props.href,
        target: props.target
      }, dataSet, props.nativeProps),
      iconLeft,
      props.text,
      iconRight
    );
  };

  return FICTextButton;
}(_react.Component);

var Icon = (0, _styledComponents2.default)(_FAIcon2.default)(_templateObject);

FICTextButton.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  href: _propTypes2.default.string,
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  iconLeft: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  iconRight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};

FICTextButton.defaultProps = {
  text: '',
  color: 'primary',
  size: 'large',
  href: undefined,
  iconLeft: undefined,
  iconRight: undefined,
  style: undefined,
  onClick: undefined,
  disabled: false
};

exports.default = FICTextButton;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  background-color: ', ';\n  color: ', ';\n  border: 1px solid rgba(51, 51, 51, 0.16);\n  border-radius: 4px;\n  box-shadow: 0 1px 2px 0 rgba(51, 51, 51, 0.08);\n  min-width: 105px;\n  width: auto;\n  height: 32px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: center;\n  padding:4px 30px;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n  ', '\n  .fa, .icon{\n    font-size: 0.8em;\n    color: ', ';\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n'], ['\n  display: inline-block;\n  background-color: ', ';\n  color: ', ';\n  border: 1px solid rgba(51, 51, 51, 0.16);\n  border-radius: 4px;\n  box-shadow: 0 1px 2px 0 rgba(51, 51, 51, 0.08);\n  min-width: 105px;\n  width: auto;\n  height: 32px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: center;\n  padding:4px 30px;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-decoration: none;\n  ', '\n  .fa, .icon{\n    font-size: 0.8em;\n    color: ', ';\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    &:hover {\n      color: ', ';\n      text-decoration: none;\n      ', '\n    }\n    &:active{\n      background-color: ', ';\n    }\n    &:focus{\n      text-decoration: none;\n    }\n  '], ['\n    &:hover {\n      color: ', ';\n      text-decoration: none;\n      ', '\n    }\n    &:active{\n      background-color: ', ';\n    }\n    &:focus{\n      text-decoration: none;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        background-color: ', ';\n      '], ['\n        background-color: ', ';\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    min-width: 91px;\n  '], ['\n    min-width: 91px;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      min-width: 111px;\n      height: 40px;\n      line-height: 30px;\n  '], ['\n      min-width: 111px;\n      height: 40px;\n      line-height: 30px;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    opacity: 0.6;\n    cursor: not-allowed;\n    background-color: ', ';\n    border-color: ', ';\n    &:hover,\n    &:active{\n      background-color: ', ';\n    }\n    &:focus{\n      color: ', ';\n    }\n  '], ['\n    opacity: 0.6;\n    cursor: not-allowed;\n    background-color: ', ';\n    border-color: ', ';\n    &:hover,\n    &:active{\n      background-color: ', ';\n    }\n    &:focus{\n      color: ', ';\n    }\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    min-width: unset;\n    line-height: unset;\n    height: auto;\n  '], ['\n    min-width: unset;\n    line-height: unset;\n    height: auto;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    cursor:not-allowed;\n  '], ['\n    cursor:not-allowed;\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICBaseButton = __webpack_require__(35);

var _FICBaseButton2 = _interopRequireDefault(_FICBaseButton);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Renderizza un bottone.
 * Può avere sia href che onClick
 * Supporta isLoading con spinner
 * Può avere due icone (destra, sinistra) o una sola centrale ma senza testo, con larghezza minima fissa
 * Può avere solo un'icona, senza testo e di larghezza auto (un quadrato)
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function FICButtonImpl(props) {
  return _react2.default.createElement(_FICBaseButton2.default, _extends({}, props, {
    renderButton: renderButton
  }));
}

function renderButton(_ref) {
  var text = _ref.text,
      isLoading = _ref.isLoading,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      icon = _ref.icon;

  var iconElement = null;
  var iconLeftElement = null;
  var iconRightElement = null;

  if (isLoading) {
    iconElement = _react2.default.createElement(_FICIcon.RegularIcon, { name: 'circle-notch fa-spin', style: { marginRight: text ? 3 : 0 } });
  } else if (iconLeft) {
    iconLeftElement = _react2.default.createElement(_FICIcon2.default, { name: iconLeft, style: { marginRight: text ? 4 : 0 } });
  } else if (iconRight) {
    iconRightElement = _react2.default.createElement(_FICIcon2.default, { name: iconRight, style: { marginLeft: text ? 4 : 0 } });
  } else if (icon) {
    iconElement = _react2.default.createElement(_FICIcon2.default, { name: icon });
  }

  return _react2.default.createElement(
    _react.Fragment,
    null,
    iconLeftElement,
    iconElement,
    !isLoading && text,
    iconRightElement
  );
}

function getColorRoot(secondary) {
  return secondary ? _FICColors2.default.button.secondary : _FICColors2.default.button.primary;
}

var defaultColor = _FICColors2.default.button.primary.blue;

var FICButton = (0, _styledComponents2.default)(FICButtonImpl)(_templateObject, function (props) {
  return props.color ? getColorRoot(props.useSecondaryColor)[props.color].normal : defaultColor.normal;
}, function (props) {
  return props.color ? getColorRoot(props.useSecondaryColor)[props.color].text : defaultColor.text;
}, function (props) {
  return !props.isLoading && (0, _styledComponents.css)(_templateObject2, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].textHover : _FICColors2.default.white;
  }, function (props) {
    return !props.isDisabled && (0, _styledComponents.css)(_templateObject3, function (props) {
      return props.color ? getColorRoot(props.useSecondaryColor)[props.color].hover : defaultColor.hover;
    });
  }, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].active : defaultColor.active;
  });
}, function (props) {
  return props.color ? getColorRoot(props.useSecondaryColor)[props.color].text : defaultColor.text;
}, function (props) {
  return props.size === 'small' && (0, _styledComponents.css)(_templateObject4);
}, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject5);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject6, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].disabled : defaultColor.disabled;
  }, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].disabled : defaultColor.disabled;
  }, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].disabled : defaultColor.disabled;
  }, function (props) {
    return props.color ? getColorRoot(props.useSecondaryColor)[props.color].text : defaultColor.text;
  });
}, function (props) {
  return props.text === undefined && (0, _styledComponents.css)(_templateObject7);
}, function (props) {
  return props.isLoading && (0, _styledComponents.css)(_templateObject8);
});

FICButtonImpl.propTypes = FICButton.propTypes = {
  color: _propTypes2.default.string,
  /* colore del bottone */
  useSecondaryColor: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['medium', 'large']),
  reactRouterLink: _propTypes2.default.bool,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  iconLeft: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  iconRight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  style: _propTypes2.default.object,
  isLoading: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

FICButtonImpl.defaultProps = FICButton.defaultProps = renderButton.defaultProps = _extends({}, _FICBaseButton2.default.defaultProps, {
  color: undefined,
  useSecondaryColor: false,
  size: 'medium',
  icon: undefined,
  iconLeft: undefined,
  iconRight: undefined,
  text: undefined,
  reactRouterLink: false,
  style: undefined,
  isLoading: undefined,
  onClick: undefined
});

renderButton.propTypes = {
  text: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  iconLeft: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  iconRight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

renderButton.defaultProps = {
  text: undefined,
  isLoading: false,
  iconLeft: undefined,
  iconRight: undefined,
  icon: undefined
};

exports.default = FICButton;

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICStyles = function FICStyles() {
  _classCallCheck(this, FICStyles);
};

FICStyles.h1 = {
  color: _FICColors2.default.black,
  fontSize: '48px',
  fontWeight: 400,
  lineHeight: '72px'
};

FICStyles.h2 = {
  color: _FICColors2.default.black,
  fontSize: '36px',
  fontWeight: 400,
  lineHeight: '54px'
};

FICStyles.h3 = {
  color: _FICColors2.default.black,
  fontSize: '30px',
  fontWeight: 400,
  lineHeight: '45px'
};

FICStyles.h4 = {
  color: _FICColors2.default.black,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '36px'
};

FICStyles.h5 = {
  color: _FICColors2.default.black,
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: '30px'
};

FICStyles.h6 = {
  color: _FICColors2.default.black,
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '27px'
};

FICStyles.headline = {
  color: _FICColors2.default.black,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px'
};

FICStyles.body = {
  color: _FICColors2.default.black,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px'
};

FICStyles.border = '1px solid ' + _FICColors2.default.borderColor;

FICStyles.boxContainer = {
  padding: 16,
  boxSizing: 'border-box',
  backgroundColor: _FICColors2.default.boxBackgroundColor,
  border: FICStyles.border,
  borderRadius: 4,
  color: '#5C6E77'
};
var formLabelStyle = {
  color: _FICColors2.default.black,
  fontWeight: 400
};

FICStyles.formLabel = {
  default: {
    medium: _extends({
      fontSize: '14px',
      lineHeight: '20px'
    }, formLabelStyle),
    large: _extends({
      fontSize: '16px',
      lineHeight: '24px'
    }, formLabelStyle)
  },
  inline: {
    medium: _extends({
      fontSize: '14px',
      lineHeight: '30px'
    }, formLabelStyle),
    large: _extends({
      fontSize: '16px',
      lineHeight: '30px'
    }, formLabelStyle)
  }
};

FICStyles.elevation3 = {
  boxShadow: '0px 3px 6px rgba(51, 51, 51, 0.1), 0px 10px 20px rgba(51, 51, 51, 0.15)'
};

exports.default = FICStyles;

/***/ }),

/***/ 2402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(58);

var _FIC = __webpack_require__(11);

var _FIC2 = _interopRequireDefault(_FIC);

var _App = __webpack_require__(2403);

var _App2 = _interopRequireDefault(_App);

var _HelpInternal = __webpack_require__(614);

var _HelpInternal2 = _interopRequireDefault(_HelpInternal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_FIC2.default.init();

var props = {};
var ExternalApp = _App2.default;
if (reactInitParams.embedded) {
  ExternalApp = _HelpInternal2.default;
  props.loadData = true;
  props.embedded = true;
  props.realm = reactInitParams.realm;
  reactGlobalParams.chat.help_visible = false;
}

_reactDom2.default.render(_react2.default.createElement(ExternalApp, _extends({ globals: reactGlobalParams, params: reactInitParams }, props)), document.getElementById('react-wrapper-root'));

/***/ }),

/***/ 2403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(333);

var _customComponents = __webpack_require__(2411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChangeView = function (permalink, page, history) {
      var path = page && permalink ? page + '/' + permalink : '';
      history.push('/' + path);
    };

    _this.state = {};
    var hash = window.location.hash;

    if (hash) {
      var newUrl = hash.replace('#', '/');
      newUrl = newUrl.replace('-', '/');
      window.location.href = window.location.origin + '/help' + newUrl;
    }
    return _this;
  }

  App.prototype.render = function render() {
    var _this2 = this;

    var Section = function Section(routeProps) {
      var match = routeProps.match;
      if (match.params.type === 'section' || match.params.type === 'sezione') {
        return _react2.default.createElement(_customComponents.SectionDefault, _extends({}, routeProps, {
          realm: _this2.props.params.realm,
          changeView: function changeView(permalink, page) {
            return _this2.handleChangeView(permalink, page, routeProps.history);
          },
          className: 'mainpageDefault',
          isExternal: true,
          searchKey: match.params.id
        }));
      } else if (match.params.type === 'article' || match.params.type === 'articolo') {
        return _react2.default.createElement(_customComponents.ArticleDefault, {
          realm: _this2.props.params.realm,
          changeView: function changeView(permalink, page) {
            return _this2.handleChangeView(permalink, page, routeProps.history);
          },
          searchKey: match.params.id,
          isExternal: true
        });
      }
    };

    return _react2.default.createElement(
      _reactRouterDom.BrowserRouter,
      { basename: 'help' },
      _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true,
          render: function render(routeProps) {
            return _react2.default.createElement(_customComponents.MainPageDefault, _extends({}, routeProps, {
              realm: _this2.props.params.realm,
              changeView: function changeView(permalink, page) {
                return _this2.handleChangeView(permalink, page, routeProps.history);
              },
              className: 'mainpageDefault',
              isExternal: true
            }));
          }
        }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/:type', exact: true,
          render: function render(routeProps) {
            return _react2.default.createElement(Section, routeProps);
          }
        }),
        _react2.default.createElement(_reactRouterDom.Route, { path: '/:type/:id', exact: true,
          render: function render(routeProps) {
            return _react2.default.createElement(Section, routeProps);
          }
        })
      )
    );
  };

  return App;
}(_react.Component);

exports.default = App;


App.propTypes = {
  params: _propTypes2.default.object
};

/***/ }),

/***/ 2411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleDefault = exports.Footer = exports.SectionDefault = exports.TopHeader = exports.MainPageDefault = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  border-radius: unset;\n  height: 100%;\n  min-height: 100%;\n  overflow: auto;\n  .helpHeader{padding:0 10px 50px}\n  .topHeader{\n    width: 100%;\n    max-width: 1200px;\n    height: 80px;\n    position: relative;\n    margin: 0 auto;\n    @media screen and (max-width: 799px){\n      padding-top: 0;\n      text-align: center;\n    }\n    .closeIcon{display: none}\n    .logo{\n      height: 32px;\n      width: auto;\n      left:0;\n      @media screen and (max-width: 799px){\n        position: relative;\n        display: inline-block;\n        left: unset;\n      }\n      @media (max-width: 425px) {\n        height: 28px;\n      }\n    }\n    .defaultTitle{\n      position: absolute;\n      left: 130px;\n      top:34px;\n      height: 28px;\n      color:', ';\n      font-size: 20px;\n      font-weight: 400;\n      border-left: 2px solid rgba(255,255,255,0.5);\n      padding-left: 24px;\n      margin-left: 24px;\n      padding-top: 5px;\n      box-sizing: border-box;\n      @media screen and (max-width: 799px){\n        position: relative;\n        display: inline-block;\n        left: unset;\n      }\n      @media (max-width: 425px) {\n        font-size: 16px;\n        line-height: 27px;\n        height: 32px;\n        padding-left: 16px;\n        margin-left: 16px;\n        padding-top: 2px;\n      }\n    }\n    .accessButton{\n      position: absolute;\n      right: 0;\n      top:30px;\n      .fic-text-button{\n        height: 40px;\n        @media all and (-ms-high-contrast: none) {\n          min-height: 40px;\n        }\n        border: 2px solid ', ';\n        max-height: unset;\n        box-sizing: border-box;\n        text-align: center;\n        font-size: 16px;\n        font-weight: 400;\n        padding-top: 10px;\n        text-transform: none;\n        background-color: transparent;\n        &:first-child{margin-right: 24px}\n        &:hover{\n          color: ', ';\n          background-color: rgba(255,255,255,0.24);\n        }\n      }\n      @media screen and (max-width: 799px){\n        display: none;\n      }\n    }\n  }\n'], ['\n  border-radius: unset;\n  height: 100%;\n  min-height: 100%;\n  overflow: auto;\n  .helpHeader{padding:0 10px 50px}\n  .topHeader{\n    width: 100%;\n    max-width: 1200px;\n    height: 80px;\n    position: relative;\n    margin: 0 auto;\n    @media screen and (max-width: 799px){\n      padding-top: 0;\n      text-align: center;\n    }\n    .closeIcon{display: none}\n    .logo{\n      height: 32px;\n      width: auto;\n      left:0;\n      @media screen and (max-width: 799px){\n        position: relative;\n        display: inline-block;\n        left: unset;\n      }\n      @media (max-width: 425px) {\n        height: 28px;\n      }\n    }\n    .defaultTitle{\n      position: absolute;\n      left: 130px;\n      top:34px;\n      height: 28px;\n      color:', ';\n      font-size: 20px;\n      font-weight: 400;\n      border-left: 2px solid rgba(255,255,255,0.5);\n      padding-left: 24px;\n      margin-left: 24px;\n      padding-top: 5px;\n      box-sizing: border-box;\n      @media screen and (max-width: 799px){\n        position: relative;\n        display: inline-block;\n        left: unset;\n      }\n      @media (max-width: 425px) {\n        font-size: 16px;\n        line-height: 27px;\n        height: 32px;\n        padding-left: 16px;\n        margin-left: 16px;\n        padding-top: 2px;\n      }\n    }\n    .accessButton{\n      position: absolute;\n      right: 0;\n      top:30px;\n      .fic-text-button{\n        height: 40px;\n        @media all and (-ms-high-contrast: none) {\n          min-height: 40px;\n        }\n        border: 2px solid ', ';\n        max-height: unset;\n        box-sizing: border-box;\n        text-align: center;\n        font-size: 16px;\n        font-weight: 400;\n        padding-top: 10px;\n        text-transform: none;\n        background-color: transparent;\n        &:first-child{margin-right: 24px}\n        &:hover{\n          color: ', ';\n          background-color: rgba(255,255,255,0.24);\n        }\n      }\n      @media screen and (max-width: 799px){\n        display: none;\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  top: 0;\n  width: 100%;\n  z-index: 101;\n  background-color: ', ';\n  color: ', ';\n  border-bottom: 1px solid rgba(51,51,51,0.08);\n  box-sizing: border-box;\n  .headerContainer{\n    max-width: 1200px;\n    margin: 0 auto;\n    position: relative;\n    height: 100%;\n    padding: 25px 0;\n    box-sizing: border-box;\n    @media screen and (max-width: 799px){\n      text-align: center;\n    }\n    @media (max-width: 425px) {\n      padding: 10px 0;\n      img {\n        height: 28px;\n      }\n    }\n  }\n  .logo{\n      display: inline-block;\n      margin-top: 5px;\n      cursor: pointer;\n    }\n    .defaultTitle{\n      display: inline-block;\n      height: 33px;\n      font-size: 20px;\n      font-weight: 400;\n      border-left: 2px solid rgba(0,0,0,0.3);\n      padding-left: 24px;\n      margin-left: 24px;\n      padding-top: 6px;\n      vertical-align: top;\n      box-sizing: border-box;\n      margin-top: 5px;\n      color: rgba(51,51,51,0.8);\n      @media (max-width: 425px) {\n        font-size: 16px;\n        line-height: 27px;\n        height: 32px;\n        padding-left: 16px;\n        margin-left: 16px;\n        padding-top: 2px;\n      }\n    }\n    .accessButton{\n      float: right;\n      .fic-text-button{\n        height: 40px!important;\n        @media all and (-ms-high-contrast: none) {\n          min-height: 40px;\n        }\n        max-height: unset!important;\n        box-sizing: border-box;\n        text-align: center;\n        font-size: 16px;\n        font-weight: 400;\n        padding-top: 10px!important;\n        text-transform: none;\n        background-color: #0294D3;\n        border: 2px solid #0294D3;\n        &:first-child{margin-right: 24px}\n        &:nth-child(2){\n          background-color: #fff;\n          color: #0294D3;\n          &:hover{\n            background-color: #0294D3;\n            color: ', ';\n          }\n        }\n        &:hover{\n          background-color: ', ';\n          color: #0294D3;\n          opacity: 1;\n        }\n      }\n      @media screen and (max-width: 799px){\n        display: none;\n      }\n    }\n'], ['\n  top: 0;\n  width: 100%;\n  z-index: 101;\n  background-color: ', ';\n  color: ', ';\n  border-bottom: 1px solid rgba(51,51,51,0.08);\n  box-sizing: border-box;\n  .headerContainer{\n    max-width: 1200px;\n    margin: 0 auto;\n    position: relative;\n    height: 100%;\n    padding: 25px 0;\n    box-sizing: border-box;\n    @media screen and (max-width: 799px){\n      text-align: center;\n    }\n    @media (max-width: 425px) {\n      padding: 10px 0;\n      img {\n        height: 28px;\n      }\n    }\n  }\n  .logo{\n      display: inline-block;\n      margin-top: 5px;\n      cursor: pointer;\n    }\n    .defaultTitle{\n      display: inline-block;\n      height: 33px;\n      font-size: 20px;\n      font-weight: 400;\n      border-left: 2px solid rgba(0,0,0,0.3);\n      padding-left: 24px;\n      margin-left: 24px;\n      padding-top: 6px;\n      vertical-align: top;\n      box-sizing: border-box;\n      margin-top: 5px;\n      color: rgba(51,51,51,0.8);\n      @media (max-width: 425px) {\n        font-size: 16px;\n        line-height: 27px;\n        height: 32px;\n        padding-left: 16px;\n        margin-left: 16px;\n        padding-top: 2px;\n      }\n    }\n    .accessButton{\n      float: right;\n      .fic-text-button{\n        height: 40px!important;\n        @media all and (-ms-high-contrast: none) {\n          min-height: 40px;\n        }\n        max-height: unset!important;\n        box-sizing: border-box;\n        text-align: center;\n        font-size: 16px;\n        font-weight: 400;\n        padding-top: 10px!important;\n        text-transform: none;\n        background-color: #0294D3;\n        border: 2px solid #0294D3;\n        &:first-child{margin-right: 24px}\n        &:nth-child(2){\n          background-color: #fff;\n          color: #0294D3;\n          &:hover{\n            background-color: #0294D3;\n            color: ', ';\n          }\n        }\n        &:hover{\n          background-color: ', ';\n          color: #0294D3;\n          opacity: 1;\n        }\n      }\n      @media screen and (max-width: 799px){\n        display: none;\n      }\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n  .section{\n    border-radius: unset;\n    .sectionHeader{\n      max-width: 940px;\n      margin: 0 auto;\n      padding: 50px 10px 0;\n      @media (max-width: 425px) {\n        padding-top: 25px;\n      }\n    }\n    .breadCrumbs{padding: 0 10px}\n    .breadCrumbsContainer{\n      max-width: 940px;\n      margin: 0 auto;\n      position: relative;\n      .autocomplete{\n        right:0;\n        height: 63px;\n        &.open{\n          width: 940px;\n          max-width: 100%;\n        }\n        .faicon{margin: 0}\n      }\n    }\n    .sectionListLoading{\n      svg{margin: 0}\n    }\n    .separator{\n      width: 940px;\n      max-width: 100%;\n      margin: 0 auto;\n    }\n  }\n'], ['\n  height: 100%;\n  .section{\n    border-radius: unset;\n    .sectionHeader{\n      max-width: 940px;\n      margin: 0 auto;\n      padding: 50px 10px 0;\n      @media (max-width: 425px) {\n        padding-top: 25px;\n      }\n    }\n    .breadCrumbs{padding: 0 10px}\n    .breadCrumbsContainer{\n      max-width: 940px;\n      margin: 0 auto;\n      position: relative;\n      .autocomplete{\n        right:0;\n        height: 63px;\n        &.open{\n          width: 940px;\n          max-width: 100%;\n        }\n        .faicon{margin: 0}\n      }\n    }\n    .sectionListLoading{\n      svg{margin: 0}\n    }\n    .separator{\n      width: 940px;\n      max-width: 100%;\n      margin: 0 auto;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 10px;\n  background-color: ', ';\n  position: relative;\n'], ['\n  width: 100%;\n  height: 10px;\n  background-color: ', ';\n  position: relative;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 100%;\n  .article{\n    border-radius: unset;\n    .sectionHeader{\n      max-width: 940px;\n      margin: 0 auto;\n      padding: 50px 10px 0;\n      @media (max-width: 425px) {\n        padding-top: 25px;\n      }\n    }\n    .breadCrumbs{padding: 0 10px;}\n    .breadCrumbsContainer{\n      max-width: 940px;\n      margin: 0 auto;\n      position: relative;\n      .autocomplete{\n        right:0;\n        height: 63px;\n        &.open{\n          width: 940px;\n          max-width: 100%;\n        }\n        .faicon{\n          margin: 0;\n        }\n      }\n    }\n    .articleContent{\n      max-width: 940px;\n      margin: 35px auto;\n      padding: 0 10px;\n      .subArticleContent{padding: 0 5px}\n    }\n  }\n'], ['\n  height: 100%;\n  .article{\n    border-radius: unset;\n    .sectionHeader{\n      max-width: 940px;\n      margin: 0 auto;\n      padding: 50px 10px 0;\n      @media (max-width: 425px) {\n        padding-top: 25px;\n      }\n    }\n    .breadCrumbs{padding: 0 10px;}\n    .breadCrumbsContainer{\n      max-width: 940px;\n      margin: 0 auto;\n      position: relative;\n      .autocomplete{\n        right:0;\n        height: 63px;\n        &.open{\n          width: 940px;\n          max-width: 100%;\n        }\n        .faicon{\n          margin: 0;\n        }\n      }\n    }\n    .articleContent{\n      max-width: 940px;\n      margin: 35px auto;\n      padding: 0 10px;\n      .subArticleContent{padding: 0 5px}\n    }\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _MainPage = __webpack_require__(479);

var _MainPage2 = _interopRequireDefault(_MainPage);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICTextButton = __webpack_require__(21);

var _FICTextButton2 = _interopRequireDefault(_FICTextButton);

var _Section = __webpack_require__(480);

var _Section2 = _interopRequireDefault(_Section);

var _Article = __webpack_require__(368);

var _Article2 = _interopRequireDefault(_Article);

var _customComponents = __webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MainPageDefault = exports.MainPageDefault = (0, _styledComponents2.default)(_MainPage2.default)(_templateObject, _FICColors2.default.white, _FICColors2.default.white, _FICColors2.default.white);
var TopHeaderImpl = function TopHeaderImpl(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    props.realm === 'fic' && _react2.default.createElement(_customComponents.FBCommunityBanner, { isExternal: props.isExternal }),
    _react2.default.createElement(
      'div',
      { className: 'headerContainer' },
      props.realm === 'fic' ? _react2.default.createElement('img', { src: '/img/logo-new-blue.png', srcSet: '/img/logo-new-blue@2x.png 2x, /img/logo-new-blue@3x.png 3x', className: 'logo', onClick: function onClick() {
          return props.changeView(undefined, 'main');
        } }) : _react2.default.createElement('img', { src: '/img/logo-dipendenticloud-blue.png', className: 'logo', onClick: function onClick() {
          return props.changeView(undefined, 'main');
        }, style: { height: 32 } }),
      _react2.default.createElement(
        'h1',
        { className: 'defaultTitle' },
        'Supporto clienti'
      ),
      _react2.default.createElement(
        'div',
        { className: 'accessButton' },
        _react2.default.createElement(_FICTextButton2.default, { text: 'Prova Gratis', iconLeft: ['fal', 'rocket'], href: props.realm === 'fic' ? 'https://www.fattureincloud.it/service/form/form-registrazione/' : 'https://secure.dipendentincloud.it/login?status=register' }),
        _react2.default.createElement(_FICTextButton2.default, { text: 'Accedi', iconLeft: ['fal', 'sign-in'], href: props.realm === 'fic' ? 'https://www.fattureincloud.it/service/form/form-login/' : 'https://secure.dipendentincloud.it/login?status=login' })
      )
    )
  );
};

var TopHeader = exports.TopHeader = (0, _styledComponents2.default)(TopHeaderImpl)(_templateObject2, _FICColors2.default.white, _FICColors2.default.textDefault, _FICColors2.default.white, _FICColors2.default.white);

var SectionImpl = function SectionImpl(_ref2) {
  var className = _ref2.className,
      realm = _ref2.realm,
      props = _objectWithoutProperties(_ref2, ['className', 'realm']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(TopHeader, { changeView: props.changeView, realm: realm, isExternal: props.isExternal }),
    _react2.default.createElement(_Section2.default, _extends({}, props, { realm: realm, className: 'section' }))
  );
};
var SectionDefault = exports.SectionDefault = (0, _styledComponents2.default)(SectionImpl)(_templateObject3);

var FooterImpl = function FooterImpl(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ['className']);

  return _react2.default.createElement('div', { className: className });
};
var Footer = exports.Footer = (0, _styledComponents2.default)(FooterImpl)(_templateObject4, _FICColors2.default.defaultBlue);

var ArticleImpl = function ArticleImpl(_ref4) {
  var className = _ref4.className,
      realm = _ref4.realm,
      props = _objectWithoutProperties(_ref4, ['className', 'realm']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(TopHeader, { changeView: props.changeView, realm: realm, isExternal: props.isExternal }),
    _react2.default.createElement(_Article2.default, _extends({}, props, { realm: realm, className: 'article' }))
  );
};
var ArticleDefault = exports.ArticleDefault = (0, _styledComponents2.default)(ArticleImpl)(_templateObject5);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FICFormField = exports.Description = exports.Field = exports.Label = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n'], ['\n  display: block;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n  background-color: transparent;\n  display: block;\n  ', ';\n  color: ', ';\n  text-align: left;\n  margin-bottom: 6px;\n  border-radius: 0;\n  padding: 0;\n'], ['\n  ', ';\n  background-color: transparent;\n  display: block;\n  ', ';\n  color: ', ';\n  text-align: left;\n  margin-bottom: 6px;\n  border-radius: 0;\n  padding: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 25px;\n  '], ['\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 25px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: block;\n  ', '\n'], ['\n  display: block;\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: top;\n  '], ['\n    display: inline-block;\n    vertical-align: top;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: block;\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 4px;\n'], ['\n  display: block;\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 4px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICStyles = __webpack_require__(24);

var _FICStyles2 = _interopRequireDefault(_FICStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'FICFormField__Container',
  componentId: 'gpfmk9-0'
})(_templateObject);

var Label = exports.Label = _styledComponents2.default.div.withConfig({
  displayName: 'FICFormField__Label',
  componentId: 'gpfmk9-1'
})(_templateObject2, function (props) {
  return _FICStyles2.default.formLabel[props.inline ? 'inline' : 'default'][props.size || 'large'];
}, function (props) {
  return props.inline && (0, _styledComponents.css)(_templateObject3);
}, _FICColors2.default.form.field.label);

var Field = exports.Field = _styledComponents2.default.div.withConfig({
  displayName: 'FICFormField__Field',
  componentId: 'gpfmk9-2'
})(_templateObject4, function (props) {
  return props.inline && (0, _styledComponents.css)(_templateObject5);
});

var ValidationMessage = _styledComponents2.default.div.withConfig({
  displayName: 'FICFormField__ValidationMessage',
  componentId: 'gpfmk9-3'
})(_templateObject6, _FICColors2.default.form.field.validationMessage);

var Description = exports.Description = _styledComponents2.default.div.withConfig({
  displayName: 'FICFormField__Description',
  componentId: 'gpfmk9-4'
})(_templateObject6, _FICColors2.default.form.field.description);

/* eslint-disable react/prop-types */

var renderLabel = function renderLabel(_ref) {
  var label = _ref.label,
      inline = _ref.inline,
      labelSize = _ref.labelSize,
      required = _ref.required;

  if (label === '') label = _react2.default.createElement(
    'span',
    null,
    '\xA0'
  );
  return label ? _react2.default.createElement(
    Label,
    {
      key: 'label',
      className: 'label',
      inline: inline,
      size: labelSize || 'large' },
    label,
    required && '*'
  ) : null;
};

renderLabel.propTypes = {
  inline: _propTypes2.default.bool
};

renderLabel.defaultProps = {
  inline: false
};

var renderField = function renderField(Component, schema, data, onChange, _ref2) {
  var validationMessage = _ref2.validationMessage;

  var value = _lodash2.default.get(data, schema.name);
  var isValid = value === undefined ? undefined : Array.isArray(validationMessage) ? validationMessage.length === 0 : undefined;
  return _react2.default.createElement(
    Field,
    {
      key: 'field',
      inline: schema.inline
    },
    _react2.default.createElement(Component, _extends({}, schema.componentProps, {
      value: value,
      onChange: onChange ? function (value, data) {
        onChange(schema.name, value, data);
      } : undefined,
      isValid: isValid
    }))
  );
};

renderField.propTypes = {
  inline: _propTypes2.default.bool,
  validation: _propTypes2.default.object,
  formOptions: _propTypes2.default.object
};

renderField.defaultProps = {
  inline: false,
  validation: {},
  formOptions: {}
};

var renderValidationMessage = function renderValidationMessage(schema, data, _ref3) {
  var validationMessage = _ref3.validationMessage;

  var value = _lodash2.default.get(data, schema.name);
  return value !== undefined && validationMessage ? _react2.default.createElement(
    ValidationMessage,
    { key: 'message' },
    validationMessage[0],
    '.'
  ) : null;
};

var renderDescription = function renderDescription(_ref4, data) {
  var description = _ref4.description;

  return description ? _react2.default.createElement(
    Description,
    { key: 'description' },
    description
  ) : null;
};

/* eslint-enable react/prop-types */

var FICFormField = exports.FICFormField = function FICFormField(_ref5) {
  var className = _ref5.className,
      style = _ref5.style,
      config = _ref5.config,
      schema = _ref5.schema,
      data = _ref5.data,
      onChange = _ref5.onChange,
      validation = _ref5.validation,
      hideValidation = _ref5.hideValidation,
      formOptions = _ref5.formOptions;

  // Load config
  var fieldConfig = config.components[schema.type];
  if (!fieldConfig) {
    console.error('FICForm: Component config not found for type \'' + schema.type + '\'.');
    return null;
  }

  // Calculations
  var Component = fieldConfig.component;
  var extra = {};
  if (_lodash2.default.has(validation, schema.name)) {
    extra.validationMessage = _lodash2.default.get(validation, schema.name);
  }

  // Render
  return _react2.default.createElement(
    Container,
    {
      className: className,
      style: style
    },
    renderLabel(schema),
    renderField(Component, schema, data, onChange, extra),
    !hideValidation && renderValidationMessage(schema, data, extra),
    renderDescription(schema, data)
  );
};

// label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])

FICFormField.defaultProps = {
  className: undefined,
  style: {},
  config: {},
  schema: {},
  data: {},
  onChange: undefined,
  hideValidation: false,
  validation: {},
  formOptions: {}
};

FICFormField.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  config: _propTypes2.default.object,
  schema: _propTypes2.default.object,
  data: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  validation: _propTypes2.default.object,
  hideValidation: _propTypes2.default.bool,
  formOptions: _propTypes2.default.object
};

exports.default = FICFormField;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FICAutocompleteImpl = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutocomplete = __webpack_require__(94);

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _style = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICAutocompleteImpl = exports.FICAutocompleteImpl = function (_Component) {
  _inherits(FICAutocompleteImpl, _Component);

  function FICAutocompleteImpl(props) {
    _classCallCheck(this, FICAutocompleteImpl);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.autocompleteRef = null;
    _this.firstLoad = false;
    _this.filter = props.value;
    _this.scheduledChange = null;
    _this.scheduledLoadOptions = null;
    _this.lastOnChangeValue = props.value || undefined;
    _this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined
    };
    return _this;
  }

  FICAutocompleteImpl.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.autoFocus) {
      setTimeout(function () {
        _this2.focus();
        setTimeout(function () {
          _this2.setState({ useInternalValue: false });
        }, 0);
      }, 100);
    }
  };

  FICAutocompleteImpl.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        placeholder = _props.placeholder,
        options = _props.options,
        loadOptions = _props.loadOptions,
        value = _props.value,
        idKey = _props.idKey,
        valueKey = _props.valueKey,
        labelKey = _props.labelKey,
        triggerLength = _props.triggerLength,
        maxMenuHeight = _props.maxMenuHeight,
        renderMenuContent = _props.renderMenuContent,
        _renderItem = _props.renderItem,
        validator = _props.validator,
        _shouldItemRender = _props.shouldItemRender,
        props = _objectWithoutProperties(_props, ['placeholder', 'options', 'loadOptions', 'value', 'idKey', 'valueKey', 'labelKey', 'triggerLength', 'maxMenuHeight', 'renderMenuContent', 'renderItem', 'validator', 'shouldItemRender']);

    var className = 'FICAutocomplete';
    if (props.className) {
      className += ' ' + props.className;
    }
    var inputClassName = 'FICInputText_Input';
    if (validator && !validator.valid) {
      inputClassName += ' FICInputText_Invalid';
    }
    value = this.getDisplayValue();
    return _react2.default.createElement(_reactAutocomplete2.default, {
      ref: function ref(_ref) {
        _this3.autocompleteRef = _ref;
      },
      wrapperProps: { className: className },
      getItemValue: function getItemValue(item) {
        return item[valueKey || labelKey];
      },
      wrapperStyle: {
        position: 'relative'
      },
      renderMenu: function renderMenu(items, value, style) {
        if (renderMenuContent) {
          return renderMenuContent(items, value, style);
        }

        if (!items || items.length === 0) {
          return _react2.default.createElement('div', null);
        }
        style.minWidth = 0;
        if (maxMenuHeight) {
          style.maxHeight = 30 * maxMenuHeight;
        }
        var displayMenu = triggerLength > _this3.filter.length ? 'none' : 'block';
        return _react2.default.createElement(
          _style.MenuOuter,
          { style: { display: displayMenu } },
          _react2.default.createElement(_style.AutocompleteMenu, { style: style, children: items, className: 'FICAutocomplete_Menu' })
        );
      },
      menuStyle: {
        position: 'absolute',
        top: 30,
        left: 0
      },
      items: options,
      renderItem: function renderItem(item, isHighlighted) {
        return _renderItem ? _renderItem(item) : _react2.default.createElement(
          _style.AutocompleteOption,
          { key: item[idKey || labelKey], focus: isHighlighted },
          item[labelKey]
        );
      },
      shouldItemRender: function shouldItemRender(item, value) {
        return _shouldItemRender ? _shouldItemRender(item, value) : item[labelKey] && item[labelKey].toLowerCase().indexOf(value.toLowerCase()) > -1;
      },

      inputProps: {
        className: inputClassName,
        placeholder: placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: props.onKeyPress,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp,
        onClick: props.onClick,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut,
        autoComplete: 'new-password'
      },
      value: value,
      onChange: this.handleChange,
      onSelect: this.handleSelect,
      onMenuVisibilityChange: function onMenuVisibilityChange(isOpen) {
        if (isOpen && !_this3.firstLoad && loadOptions && triggerLength <= _this3.filter.length) {
          _this3.firstLoad = true;
          loadOptions('');
        }
      }
    });
  };

  return FICAutocompleteImpl;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.focus = function () {
    if (_this4.autocompleteRef) {
      _this4.autocompleteRef.focus();
    }
  };

  this.blur = function () {
    if (_this4.autocompleteRef) {
      _this4.autocompleteRef.blur();
    }
  };

  this.shouldUseInternalValue = function () {
    return _this4.props.changeOnBlur || !_this4.props.uncontrolled && _this4.props.changeDelay;
  };

  this.getDisplayValue = function () {
    var props = _this4.props;
    var state = _this4.state;
    return _this4.shouldUseInternalValue() && state.useInternalValue ? state.internalValue || '' : props.value != null ? props.value : '';
  };

  this.handleChange = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    // Options
    _this4.filter = value;
    if (props.loadOptions) {
      _this4.cancelScheduledLoadOptions();
      if (props.triggerLength <= value.length) {
        _this4.scheduleLoadOptions(value);
      }
    }
    // General input
    if (props.clearable) {
      _this4.setState({ clearableVisible: value });
    }
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value });
    }
    if (props.changeDelay) {
      _this4.cancelScheduledChange();
      _this4.scheduleChange(value);
    } else {
      _this4.executeOnChange(value);
    }
  };

  this.executeOnChange = function (value) {
    var props = _this4.props;
    if (props.onChange && value !== _this4.lastOnChangeValue) {
      _this4.lastOnChangeValue = value;
      props.onChange(value, props.name);
    }
  };

  this.handleSelect = function (value, data) {
    var props = _this4.props;
    value = data[props.valueKey ? props.valueKey : props.labelKey];
    _this4.cancelScheduledChange();
    _this4.cancelScheduledLoadOptions();
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value });
    }
    if (!props.preventChangeOnSelect) {
      _this4.executeOnChange(value);
    }
    if (props.onSelect) {
      _this4.lastOnChangeValue = value;
      props.onSelect(value, data);
    }
  };

  this.handleFocus = function (e) {
    var props = _this4.props;
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({
        useInternalValue: true,
        internalValue: props.value
      });
    }
    if (props.onFocus) {
      props.onFocus(e);
    }
  };

  this.handleBlur = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    _this4.setState({ useInternalValue: false });
    if (props.changeOnBlur) {
      _this4.executeOnChange(value);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  this.scheduleChange = function (value) {
    _this4.scheduledChange = setTimeout(function () {
      _this4.executeOnChange(value);
    }, _this4.props.changeDelay);
  };

  this.cancelScheduledChange = function () {
    if (_this4.scheduledChange) {
      clearTimeout(_this4.scheduledChange);
    }
  };

  this.scheduleLoadOptions = function (value) {
    _this4.scheduledLoadOptions = setTimeout(function () {
      return _this4.props.loadOptions(value);
    }, _this4.props.loadOptionsDelay);
  };

  this.cancelScheduledLoadOptions = function () {
    if (_this4.scheduledLoadOptions) {
      clearTimeout(_this4.scheduledLoadOptions);
    }
  };
};

_style.FICAutocomplete.propTypes = FICAutocompleteImpl.propTypes = {
  className: _propTypes2.default.string,
  options: _propTypes2.default.array,
  loadOptions: _propTypes2.default.func,
  loadOptionsDelay: _propTypes2.default.number,
  triggerLength: _propTypes2.default.number,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  idKey: _propTypes2.default.string,
  valueKey: _propTypes2.default.string,
  labelKey: _propTypes2.default.string,
  emptyLabel: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  changeOnBlur: _propTypes2.default.bool,
  changeDelay: _propTypes2.default.number,
  clearable: _propTypes2.default.bool,
  maxMenuHeight: _propTypes2.default.number,
  preventChangeOnSelect: _propTypes2.default.bool,
  renderMenuContent: _propTypes2.default.func,
  renderItem: _propTypes2.default.func,
  validator: _propTypes2.default.func,
  shouldItemRender: _propTypes2.default.func,
  autoFocus: _propTypes2.default.bool,
  uncontrolled: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  isValid: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool
};

_style.FICAutocomplete.defaultProps = FICAutocompleteImpl.defaultProps = {
  className: undefined,
  options: [],
  loadOptions: undefined,
  loadOptionsDelay: 0,
  triggerLength: 0,
  value: '',
  idKey: undefined,
  valueKey: undefined,
  labelKey: 'label',
  emptyLabel: '',
  placeholder: '',
  onSelect: undefined,
  onChange: undefined,
  changeOnBlur: true,
  changeDelay: 500,
  clearable: true,
  maxMenuHeight: undefined,
  preventChangeOnSelect: false,
  renderMenuContent: undefined,
  renderItem: undefined,
  validator: undefined,
  shouldItemRender: undefined,
  autoFocus: false,
  uncontrolled: false,
  size: undefined,
  isValid: undefined,
  isDisabled: undefined
};

exports.default = _style.FICAutocomplete;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FICPageSectionBlockText = exports.FICPageSectionSubtitle = exports.FICPageSectionBlock = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  text-align: ', ';\n  float: ', ';\n  display: inline-block;\n  margin-top: 8px;\n  vertical-align: middle;\n  flex: ', ';\n  a.btn-flat + a.btn-flat {\n    margin-left: 8px;\n  }\n'], ['\n  text-align: ', ';\n  float: ', ';\n  display: inline-block;\n  margin-top: 8px;\n  vertical-align: middle;\n  flex: ', ';\n  a.btn-flat + a.btn-flat {\n    margin-left: 8px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: ', ';\n  float: ', ';\n  flex: ', ';\n  align-items: ', ';\n  overflow-y: ', ';\n  margin-top:  ', ';\n  margin-bottom:  ', ';\n  display: ', ';\n  width: 100%;\n  ', ' + ', '{\n    margin-left: 8px;\n  }\n  a.btn-flat + a.btn-flat {\n    margin-left: 8px;\n  }\n'], ['\n  text-align: ', ';\n  float: ', ';\n  flex: ', ';\n  align-items: ', ';\n  overflow-y: ', ';\n  margin-top:  ', ';\n  margin-bottom:  ', ';\n  display: ', ';\n  width: 100%;\n  ', ' + ', '{\n    margin-left: 8px;\n  }\n  a.btn-flat + a.btn-flat {\n    margin-left: 8px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-top: 0;\n'], ['\n  margin-top: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  line-height: 30px;\n'], ['\n  font-size: 13px;\n  line-height: 30px;\n']);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* FICPageSectionBlock */

var FICPageSectionBlock = exports.FICPageSectionBlock = _styledComponents2.default.div.attrs({
  className: 'fic-page-section-block'
})(_templateObject, function (props) {
  return props.align;
}, function (props) {
  return props.align === 'center' ? 'none' : props.align;
}, function (props) {
  return props.flex;
});

FICPageSectionBlock.propTypes = {
  style: _propTypes2.default.object,
  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
  flex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

FICPageSectionBlock.defaultProps = {
  style: {},
  align: 'center',
  flex: undefined

  /* FICPageSection */

};var FICPageSection = _styledComponents2.default.div.attrs({
  className: 'fic-page-section'
})(_templateObject2, function (props) {
  return props.align;
}, function (props) {
  return props.align === 'center' ? 'none' : props.align;
}, function (props) {
  return props.fillPage ? 1 : undefined;
}, function (props) {
  return props.alignChildren;
}, function (props) {
  return props.fillPage ? 'hidden' : undefined;
}, function (props) {
  return props.spaced ? '15px' : 0;
}, function (props) {
  return props.spacedBottom ? '15px' : 0;
}, function (props) {
  return props.flexChildren ? 'inline-flex' : 'inline-block';
}, FICPageSectionBlock, FICPageSectionBlock);

exports.default = FICPageSection;


FICPageSection.propTypes = {
  style: _propTypes2.default.object,
  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
  flexChildren: _propTypes2.default.bool,
  alignChildren: _propTypes2.default.string,
  fillPage: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  spaced: _propTypes2.default.bool,
  spacedBottom: _propTypes2.default.bool
};

FICPageSection.defaultProps = {
  style: {},
  align: 'center',
  flexChildren: false,
  fillPage: false,
  scrollable: undefined

  /* FICPageSectionSubtitle */

};var FICPageSectionSubtitle = exports.FICPageSectionSubtitle = (0, _styledComponents2.default)(FICPageSection)(_templateObject3);

/* FICPageSectionBlockText */

var FICPageSectionBlockText = exports.FICPageSectionBlockText = _styledComponents2.default.span.withConfig({
  displayName: 'FICPageSection__FICPageSectionBlockText',
  componentId: 'vj0kk5-0'
})(_templateObject4);

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _FICUtils = __webpack_require__(9);

var _FICUtils2 = _interopRequireDefault(_FICUtils);

var _iban = __webpack_require__(121);

var _iban2 = _interopRequireDefault(_iban);

var _FICNumbers = __webpack_require__(19);

var _FICNumbers2 = _interopRequireDefault(_FICNumbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICValidator = function FICValidator() {
  _classCallCheck(this, FICValidator);
};

exports.default = FICValidator;


FICValidator.piva = function (piva, paese) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!piva && required) {
    return { valid: false, message: 'Partita IVA richiesta.' };
  }
  if (paese !== 'Italia' || !piva) return { valid: true };
  if (_FICUtils2.default.controllaPIVA(piva) === '') {
    return { valid: true };
  }
  return { valid: false, message: 'Partita IVA non valida.' };
};

FICValidator.cf = function (cf, paese) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!cf && required) {
    return { valid: false, message: 'Codice fiscale richiesto.' };
  }
  if (paese !== 'Italia' || !cf) return { valid: true };
  if (_FICUtils2.default.controllaCF(cf) === '' || _FICUtils2.default.controllaPIVA(cf) === '') {
    return { valid: true };
  }
  return { valid: false, message: 'Codice fiscale non valido.' };
};

FICValidator.personCf = function (cf) {
  if (!cf) {
    return { valid: false, message: 'Codice fiscale richiesto.' };
  }
  if (cf.length === 16 && _FICUtils2.default.controllaCF(cf) === '') {
    return { valid: true };
  }
  return { valid: false, message: 'É richiesto un codice fiscale italiano valido.' };
};

FICValidator.required = function (text) {
  var validateCondition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!validateCondition) {
    return { valid: true };
  }
  var toEval = text === undefined || text === null ? '' : '' + text;
  if (toEval && toEval.length > 0) {
    return { valid: true };
  }
  return { valid: false, message: 'Questo campo non può essere vuoto.' };
};

FICValidator.minLength = function (text, minLength) {
  var toEval = '' + text;
  if (toEval && toEval.length >= minLength) {
    return { valid: true };
  }
  return { valid: false, message: 'Il valore inserito è troppo corto.' };
};

FICValidator.iban = function (iban, allowEmpty) {
  var valid = !iban && allowEmpty || iban && _iban2.default.isValid(iban);
  return { valid: valid, message: valid ? '' : 'IBAN errato o mancante.' };
};

FICValidator.sia = function (sia, allowEmpty) {
  var valid = !sia && allowEmpty || sia && sia.length == 5 && sia.match(/^[A-Z0-9$]{5}$/g);
  return { valid: valid, message: valid ? '' : 'Codice SIA errato o mancante.' };
};

FICValidator.numeration = function (numeration) {
  if (numeration && numeration.charAt(0) >= '0' && numeration.charAt(0) <= '9') {
    return { valid: false, message: 'La numerazione non è valida.' };
  }
  return { valid: true };
};

FICValidator.email = function (email) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!email && required) {
    return { valid: false, message: 'L\'indirizzo e-mail è obbligatorio.' };
  }

  if (!email || /^\w+(?:[.+-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,20})+$/.test(email)) return { valid: true };
  return { valid: false, message: 'L\'indirizzo e-mail potrebbe non essere corretto.' };
};

FICValidator.multiEmail = function (emailString) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var emailArray = Array();

  if (emailString) {
    emailArray.push(emailString);

    if (emailString.includes(',')) {
      emailArray = emailString.split(',');
    } else if (emailString.includes(';')) {
      emailArray = emailString.split(';');
    }
  }

  if (!emailArray.length > 0 && required) {
    return { valid: false, message: 'Nessun indirizzo e-mail inserito' };
  }

  if (emailString) {
    if (!emailArray.every(function (email) {
      return FICValidator.email(email.trim(), true).valid;
    })) {
      return { valid: false, message: 'Uno o più indirizzi e-mail inseriti non sono corretti.' };
    }
  }
  return { valid: true };
};

FICValidator.eInvoiceCode = function (code, pa) {
  var regex = pa === null ? /^[A-Z0-9]{6,7}$/ : pa ? /^[A-Z0-9]{6}$/ : /^[A-Z0-9]{7}$/;
  if (!code || regex.test(code)) return { valid: true };
  return { valid: false, message: 'Il codice ' + (pa ? 'PA' : 'destinatario') + ' non sembra corretto.' };
};

FICValidator.engDate = function (date) {
  if (!date || (0, _moment2.default)(date, 'YYYY-MM-DD', true).isValid()) return { valid: true };
  return { valid: false, message: 'La data non è nel formato corretto.' };
};

FICValidator.between = function (value, min, max) {
  var clearedValue = _FICNumbers2.default.parse(value, true);
  if (!isNaN(clearedValue) && clearedValue >= min && clearedValue <= max) return { valid: true };
  return { valid: false, message: 'Il valore deve essere compreso tra ' + min + ' e ' + max };
};

FICValidator.equal = function (a, b) {
  if (a === b) {
    return { valid: true };
  }
  return { valid: false, message: 'I valori non corrispondono.' };
};

FICValidator.postalCode = function (code) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Italia';
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!code && required) {
    return { valid: false, message: 'Il CAP è obbligatorio.' };
  }
  if (country !== 'Italia' || code === null || code.length === 0) {
    return { valid: true };
  }
  if (code && /^[0-9]{5}$/.test(code)) {
    return { valid: true };
  }
  return { valid: false, message: 'Il CAP non è valido.' };
};

FICValidator.province = function (province) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Italia';
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!province && required) {
    return { valid: false, message: 'La provincia è obbligatoria.' };
  }
  if (country !== 'Italia' || province === null || province.length === 0) {
    return { valid: true };
  }
  if (province && /^[A-Za-z]{2}$/.test(province)) {
    return { valid: true };
  }
  return { valid: false, message: 'Va indicata la singla della provincia.' };
};

FICValidator.pecDomain = function (email) {
  var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var domains = ['pec.it', 'legalmail.it', 'hyperpec.it', 'postacert.it', 'registerpec.it', 'dadapec.com', 'pec-mail.it', 'arubapec.it'];
  var checkMail = FICValidator.email(email, required);
  if (!checkMail.valid) {
    return checkMail;
  }
  if (domains.includes(email.split('@')[1])) {
    return { valid: false, message: 'L\'utilizzo di un\'e-mail PEC è sconsigliato.' };
  }
  return { valid: true };
};

FICValidator.disabledVatId = function (vat) {
  if (vat.is_disabled) {
    return { valid: false, message: 'Aliquota IVA non valida a seguito del nuovo tracciato per la fattura elettronica.' };
  }
  return { valid: true };
};

FICValidator.natureVatId = function (vat) {
  if (!vat.ei_type && !vat.is_disabled) {
    return { valid: false, message: 'La Natura è obbligatoria per le aliquote al 0%.' };
  }
  if ((!vat.ei_type || ['2', '3', '6'].includes(vat.ei_type)) && vat.is_disabled) {
    return { valid: false, message: 'Natura Aliquota IVA non valida a seguito del nuovo tracciato per la fattura elettronica.' };
  }
  return { valid: true };
};

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICTooltip = __webpack_require__(18);

var _FICTooltip2 = _interopRequireDefault(_FICTooltip);

var _FICNumbers = __webpack_require__(19);

var _FICNumbers2 = _interopRequireDefault(_FICNumbers);

var _FAIcon = __webpack_require__(6);

var _FAIcon2 = _interopRequireDefault(_FAIcon);

__webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICInputText = function (_Component) {
  _inherits(FICInputText, _Component);

  function FICInputText(props) {
    _classCallCheck(this, FICInputText);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.textInput = null;
    _this.leftText = null;
    _this.rightText = null;
    _this.scheduledChange = null;
    _this.lastOnChangeValue = props.value || undefined;
    _this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined,
      clearableVisible: props.clearable && props.value
      // allowAutoFocusChange: true,
    };
    return _this;
  }

  /*
  static getDerivedStateFromProps(nextProps, prevState) {
    console.log(nextProps, prevState)
    if (nextProps.autoFocus && prevState.allowAutoFocusChange && nextProps.value !== prevState.internalValue && !prevState.internalValue) {
      return Object.assign({}, prevState, { internalValue: nextProps.value, allowAutoFocusChange: false })
    }
    return null
  }
  */

  FICInputText.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.autoFocus) {
      setTimeout(function () {
        _this2.focus();
        setTimeout(function () {
          _this2.setState({ useInternalValue: false });
        }, 0);
      }, 100);
    }
    if (this.textInput && this.leftText) {
      this.textInput.style.paddingLeft = this.leftText.getBoundingClientRect().width + 12 + 'px';
    }
    if (this.textInput && this.rightText) {
      this.textInput.style.paddingRight = this.rightText.getBoundingClientRect().width + 12 + 'px';
    }
  };

  FICInputText.prototype.focus = function focus() {
    if (this.textInput) {
      this.textInput.focus();
    }
  };

  FICInputText.prototype.blur = function blur() {
    if (this.textInput) {
      this.textInput.blur();
    }
  };

  FICInputText.prototype.nextInput = function nextInput() {
    var inputs = $(':input');
    var nextInput = inputs.get(inputs.index(this.textInput) + 1);
    if (nextInput) {
      nextInput.focus();
    }
  };

  FICInputText.prototype.uncontrolledGetValue = function uncontrolledGetValue() {
    return this.textInput.value;
  };

  FICInputText.prototype.uncontrolledSetValue = function uncontrolledSetValue(value) {
    this.textInput.value = value;
  };

  FICInputText.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.textInput && this.leftText) {
      this.textInput.style.paddingLeft = this.leftText.getBoundingClientRect().width + 12 + 'px';
    }
    if (this.textInput && this.rightText) {
      this.textInput.style.paddingRight = this.rightText.getBoundingClientRect().width + 12 + 'px';
    }
  };

  FICInputText.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        leftIcon = _props.leftIcon,
        leftIconClick = _props.leftIconClick,
        leftText = _props.leftText,
        rightIcon = _props.rightIcon,
        rightIconClick = _props.rightIconClick,
        rightText = _props.rightText,
        style = _props.style,
        clearable = _props.clearable,
        onChange = _props.onChange,
        props = _objectWithoutProperties(_props, ['leftIcon', 'leftIconClick', 'leftText', 'rightIcon', 'rightIconClick', 'rightText', 'style', 'clearable', 'onChange']);

    var FICInputTextTag = props.type === 'multiline' ? 'textarea' : 'input';
    // Class name
    var className = 'fic-input-text-input';
    if (props.validator && !props.validator.valid) {
      className += ' fic-input-invalid';
    }
    style = _extends({}, style);
    // Textarea
    if (FICInputTextTag === 'textarea' && props.lines > 0) {
      style = _extends({}, props.style, { height: 30 + 50 * (props.lines - 1) });
    }
    // Clearable
    if (clearable) {
      rightIcon = this.state.clearableVisible ? 'close' : null;
      rightIconClick = onChange ? function () {
        var prevValue = _this3.uncontrolledGetValue();
        if (props.uncontrolled) {
          _this3.uncontrolledSetValue('');
        }
        if (prevValue !== '') {
          _this3.setState({ clearableVisible: false });
          _this3.executeOnChange('');
        }
      } : rightIconClick;
    }
    // Advanced options style
    if (leftIcon) {
      _extends(style, { paddingLeft: 24 });
    }
    if (rightIcon) {
      _extends(style, { paddingRight: 24 });
    }
    leftText = leftText && (typeof leftText === 'function' ? leftText() : leftText);
    rightText = rightText && (typeof rightText === 'function' ? rightText() : rightText);

    // Display
    var value = this.getDisplayValue();
    var result = _react2.default.createElement(FICInputTextTag, {
      type: props.inputType,
      ref: function ref(input) {
        _this3.textInput = input;
      },
      value: value,
      placeholder: props.placeholder,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: props.onKeyPress,
      onKeyDown: props.onKeyDown,
      onKeyUp: props.onKeyUp,
      onClick: props.onClick,
      onMouseOver: props.onMouseOver,
      onMouseOut: props.onMouseOut,
      className: className,
      maxLength: props.maxLength,
      style: style || props.style,
      disabled: props.disabled,
      autoComplete: 'new-password' // Disable Chrome autofill
    });
    // Advanced options wrap
    if (leftText || leftIcon || rightText || rightIcon) {
      result = _react2.default.createElement(
        'div',
        { className: 'fic-advanced-input-text' },
        leftText && _react2.default.createElement(
          'span',
          { className: 'text-left', ref: function ref(leftText) {
              return _this3.leftText = leftText;
            } },
          leftText
        ),
        leftIcon && _react2.default.createElement(_FAIcon2.default, { className: 'icon-left', name: leftIcon, onClick: leftIconClick, style: leftIconClick ? { cursor: 'pointer' } : {} }),
        result,
        rightIcon && _react2.default.createElement(_FAIcon2.default, { className: 'icon-right', name: rightIcon, onClick: rightIconClick, style: rightIconClick ? { cursor: 'pointer' } : {} }),
        rightText && _react2.default.createElement(
          'span',
          { className: 'text-right', ref: function ref(rightText) {
              return _this3.rightText = rightText;
            } },
          rightText
        )
      );
    }
    // Validator tooltip wrap
    if (props.validator) {
      result = _react2.default.createElement(
        _FICTooltip2.default,
        {
          placement: 'top',
          text: props.validator.message,
          trigger: props.validator.valid ? [] : ['hover', 'focus'],
          enabled: !props.validator.valid && !!props.validator.message },
        result
      );
    }
    return result;
  };

  return FICInputText;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.shouldUseInternalValue = function () {
    return _this4.props.changeOnBlur || !_this4.props.uncontrolled && _this4.props.changeDelay;
  };

  this.getDisplayValue = function () {
    var props = _this4.props;
    var state = _this4.state;
    return props.uncontrolled ? undefined : _this4.shouldUseInternalValue() && state.useInternalValue ? state.internalValue || '' : props.transform ? props.transform(props.value) : props.value != null ? props.value : '';
  };

  this.handleChange = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    // this.setState({ allowAutoFocusChange: false })
    if (props.clearable) {
      _this4.setState({ clearableVisible: value });
    }
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value, useInternalValue: true });
    }
    if (props.changeDelay) {
      if (_this4.scheduledChange) {
        clearTimeout(_this4.scheduledChange);
      }
      _this4.scheduledChange = setTimeout(function () {
        _this4.executeOnChange(value);
      }, props.changeDelay);
    } else {
      _this4.executeOnChange(value);
    }
  };

  this.executeOnChange = function (value) {
    var props = _this4.props;
    if (props.onChange && (value !== _this4.lastOnChangeValue || value !== props.value)) {
      _this4.lastOnChangeValue = value;
      props.onChange(props.name, value, null, 'text');
    }
  };

  this.handleFocus = function (e) {
    var props = _this4.props;
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({
        useInternalValue: true,
        internalValue: props.value
      });
    }
    if (props.onFocus) {
      props.onFocus(e);
    }
  };

  this.handleBlur = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    _this4.setState({ useInternalValue: false });
    if (props.changeOnBlur) {
      _this4.executeOnChange(value);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
};

FICInputText.propTypes = {
  type: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  placeholder: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  maxLength: _propTypes2.default.number,
  style: _propTypes2.default.object,
  uncontrolled: _propTypes2.default.bool,
  changeOnBlur: _propTypes2.default.bool,
  changeDelay: _propTypes2.default.number,
  lines: _propTypes2.default.number,
  transform: _propTypes2.default.func,
  inputType: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  clearable: _propTypes2.default.bool,
  leftIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  leftIconClick: _propTypes2.default.func,
  leftIconHover: _propTypes2.default.func,
  leftText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  rightIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  rightIconClick: _propTypes2.default.func,
  rightIconHover: _propTypes2.default.func,
  rightText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};

FICInputText.defaultProps = {
  type: 'text',
  value: undefined,
  placeholder: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyPress: undefined,
  onKeyDown: undefined,
  onKeyUp: undefined,
  onClick: undefined,
  maxLength: undefined,
  style: {},
  uncontrolled: false,
  changeOnBlur: true,
  changeDelay: 500,
  lines: 1,
  transform: undefined,
  inputType: 'text',
  disabled: undefined,
  clearable: false,
  leftIcon: undefined,
  leftIconClick: undefined,
  leftIconHover: undefined,
  leftText: undefined,
  rightIcon: undefined,
  rightIconClick: undefined,
  rightIconHover: undefined,
  rightText: undefined
};

FICInputText.dotsToCommasTransform = function (value) {
  return _FICNumbers2.default.dotsToCommas(value);
};

exports.default = FICInputText;

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyMessage = exports.FBCommunityBanner = exports.ElementNotFound = exports.Chat = exports.Separator = exports.HelpHeaderDetailed = exports.HelpHeader = exports.MainContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\theight: 40px;\n\tcursor: pointer;\n\tposition: absolute;\n  top:30px;\n  right:34px;\n  color: ', ';\n  opacity:1;\n'], ['\n\theight: 40px;\n\tcursor: pointer;\n\tposition: absolute;\n  top:30px;\n  right:34px;\n  color: ', ';\n  opacity:1;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top:30px;\n  left:34px;\n'], ['\n  position: absolute;\n  top:30px;\n  left:34px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  height:100%;\n  ', ';\n  @supports (-ms-ime-align: auto) {\n    & {border-radius: 7px;}\n  }\n  .embeddedArticle {\n    max-width: 800px;\n  }\n  .embeddedSection {\n    max-width: 800px;\n  }\n'], ['\n  background-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  height:100%;\n  ', ';\n  @supports (-ms-ime-align: auto) {\n    & {border-radius: 7px;}\n  }\n  .embeddedArticle {\n    max-width: 800px;\n  }\n  .embeddedSection {\n    max-width: 800px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    height: calc(100% - 90px);\n    @media (max-width: 425px) {\n      height: calc(100% - 57px);\n    }\n  '], ['\n    height: calc(100% - 90px);\n    @media (max-width: 425px) {\n      height: calc(100% - 57px);\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    text-align: center;\n    ', ';\n    .fic-page-section-block{max-width: 100%}\n    h1{\n      height: 24px;\n      color: rgba(255,255,255,0.8);\n      font-size: 20px;\n      font-weight: 600;\n      letter-spacing: 0.11px;\n      line-height: 24px;\n      margin-bottom: 60px;\n      margin-top: 35px;\n    }\n    .subtitle {\n      height: 48px;\n      @media screen and (max-width: 799px){\n        height: auto;\n      }\n      color: ', ';\n      font-size: 32px;\n      font-weight: bold;\n      letter-spacing: 0.17px;\n      line-height: 48px;\n      text-align: center;\n      @media (max-width: 425px) {\n        font-size: 20px;\n        line-height: 30px;\n      }\n    }\n'], ['\n    text-align: center;\n    ', ';\n    .fic-page-section-block{max-width: 100%}\n    h1{\n      height: 24px;\n      color: rgba(255,255,255,0.8);\n      font-size: 20px;\n      font-weight: 600;\n      letter-spacing: 0.11px;\n      line-height: 24px;\n      margin-bottom: 60px;\n      margin-top: 35px;\n    }\n    .subtitle {\n      height: 48px;\n      @media screen and (max-width: 799px){\n        height: auto;\n      }\n      color: ', ';\n      font-size: 32px;\n      font-weight: bold;\n      letter-spacing: 0.17px;\n      line-height: 48px;\n      text-align: center;\n      @media (max-width: 425px) {\n        font-size: 20px;\n        line-height: 30px;\n      }\n    }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n      margin-top: 60px;\n      @media screen and (max-width: 799px){\n        margin-top: 20px;\n      }\n    '], ['\n      margin-top: 60px;\n      @media screen and (max-width: 799px){\n        margin-top: 20px;\n      }\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: ', ';\n  position: relative;\n  padding-bottom: 50px;\n  background: url(\'/img/background-faq.png\');\n'], ['\n  color: ', ';\n  position: relative;\n  padding-bottom: 50px;\n  background: url(\'/img/background-faq.png\');\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  position: relative;\n  padding-bottom: 50px;\n  min-height: 190px;\n  box-sizing: border-box;\n  background: url(\'/img/background-faq.png\');\n  @media (max-width: 425px) {\n    padding-bottom: 25px;\n    min-height: 80px;\n  }\n  .sectionHeader{\n    margin: 0 auto;\n    padding-top: 25px;\n    position: relative;\n    max-width: 940px;\n    @media (max-width: 425px) {\n      h1 {\n        font-size: 20px;\n        line-height: 30px;\n        margin: 0;\n      }\n      h4 {\n        font-size: 16px;\n        line-height: 27px;\n        margin-bottom: 0;\n      }\n    }\n  }\n  .embeddedHeader {\n    max-width: 800px;\n  }\n  .fic-text-button {\n    height: auto!important;\n    max-height: unset!important;\n    text-transform: none;\n    width: auto;\n    border-radius: 18.5px!important;\n    color: ', ';\n    font-size: 18px!important;\n    font-weight: 400;\n    line-height: 24px;\n    background-color: rgba(255,255,255,0.24);\n    border:none;\n    @media all and (-ms-high-contrast: none) {\n      & { padding:5px 14px 14px!important; }  \n   }\n  }\n  h1{\n    color: ', ';\n    font-size: 34px;\n    font-weight: bold;\n    line-height: 48px;\n    margin-top: 17px;\n  }\n  .description{\n    color: ', ';\n    font-size: 16px;\n    line-height: 24px;\n    margin-top: 5px;\n  }\n'], ['\n  color: ', ';\n  position: relative;\n  padding-bottom: 50px;\n  min-height: 190px;\n  box-sizing: border-box;\n  background: url(\'/img/background-faq.png\');\n  @media (max-width: 425px) {\n    padding-bottom: 25px;\n    min-height: 80px;\n  }\n  .sectionHeader{\n    margin: 0 auto;\n    padding-top: 25px;\n    position: relative;\n    max-width: 940px;\n    @media (max-width: 425px) {\n      h1 {\n        font-size: 20px;\n        line-height: 30px;\n        margin: 0;\n      }\n      h4 {\n        font-size: 16px;\n        line-height: 27px;\n        margin-bottom: 0;\n      }\n    }\n  }\n  .embeddedHeader {\n    max-width: 800px;\n  }\n  .fic-text-button {\n    height: auto!important;\n    max-height: unset!important;\n    text-transform: none;\n    width: auto;\n    border-radius: 18.5px!important;\n    color: ', ';\n    font-size: 18px!important;\n    font-weight: 400;\n    line-height: 24px;\n    background-color: rgba(255,255,255,0.24);\n    border:none;\n    @media all and (-ms-high-contrast: none) {\n      & { padding:5px 14px 14px!important; }  \n   }\n  }\n  h1{\n    color: ', ';\n    font-size: 34px;\n    font-weight: bold;\n    line-height: 48px;\n    margin-top: 17px;\n  }\n  .description{\n    color: ', ';\n    font-size: 16px;\n    line-height: 24px;\n    margin-top: 5px;\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 1px;\n  background-color: rgba(51,51,51,0.08)\n'], ['\n  width: 100%;\n  height: 1px;\n  background-color: rgba(51,51,51,0.08)\n']),
    _templateObject10 = _taggedTemplateLiteral(['\nmargin: 50px auto;\nbox-sizing: border-box;\ntext-align: center;\npadding-left: 12.5px;\npadding-right: 12.5px;\n  .fic-text-button{\n    background-color: ', ';\n    color:', ';\n    border:2px solid ', ';\n    font-size: 16px!important;\n    text-transform: none;\n    padding: 15px!important;\n    &:hover{\n      color:', ';\n      background-color: ', ';\n    }\n  }\n  h3{\n    margin: 25px 0;\n    font-size: 20px;\n  }\n  .averageResponseTime {\n    box-sizing: border-box;\n    height: auto;\n    width: 640px;\n    max-width: 100%;\n    border: 1px solid rgba(255,141,45,0.32);\n    border-radius: 4px;\n    background-color: rgba(255,141,45,0.24);\n    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n    margin: 30px auto;\n    color: #FF8D2D;\n    font-size: 16px;\n    padding: 13px ;\n    line-height: 23px;\n    .fa, .faicon{\n      display: table-cell;\n      vertical-align: middle;\n      padding-right: 8px;\n      font-size: 23px;\n    }\n    span{\n      display: table-cell;\n      width: 100%;\n    }\n  }\n'], ['\nmargin: 50px auto;\nbox-sizing: border-box;\ntext-align: center;\npadding-left: 12.5px;\npadding-right: 12.5px;\n  .fic-text-button{\n    background-color: ', ';\n    color:', ';\n    border:2px solid ', ';\n    font-size: 16px!important;\n    text-transform: none;\n    padding: 15px!important;\n    &:hover{\n      color:', ';\n      background-color: ', ';\n    }\n  }\n  h3{\n    margin: 25px 0;\n    font-size: 20px;\n  }\n  .averageResponseTime {\n    box-sizing: border-box;\n    height: auto;\n    width: 640px;\n    max-width: 100%;\n    border: 1px solid rgba(255,141,45,0.32);\n    border-radius: 4px;\n    background-color: rgba(255,141,45,0.24);\n    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n    margin: 30px auto;\n    color: #FF8D2D;\n    font-size: 16px;\n    padding: 13px ;\n    line-height: 23px;\n    .fa, .faicon{\n      display: table-cell;\n      vertical-align: middle;\n      padding-right: 8px;\n      font-size: 23px;\n    }\n    span{\n      display: table-cell;\n      width: 100%;\n    }\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 24px 0;\n  font-size: 16px;\n  text-align: center;\n'], ['\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 24px 0;\n  font-size: 16px;\n  text-align: center;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n  top: 0;\n  z-index: 102;\n  width: 100%;\n  transition: max-height 500ms;\n  max-height: 0;\n  overflow: hidden;\n  ', '\n  >div{\n    max-width: 1080px;\n    ', ';\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n    padding: 12px;\n    \n    @media (max-width: 425px) {\n      align-items: start;\n    }\n  }\n  img{\n    display: block;\n    height: 16px;\n    margin-right: 12px;\n  }\n  span {\n  flex: 1;\n  }\n  .Icon{\n    cursor: pointer;\n    margin-left: 12px;\n    justify-self: right;\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n  top: 0;\n  z-index: 102;\n  width: 100%;\n  transition: max-height 500ms;\n  max-height: 0;\n  overflow: hidden;\n  ', '\n  >div{\n    max-width: 1080px;\n    ', ';\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n    padding: 12px;\n    \n    @media (max-width: 425px) {\n      align-items: start;\n    }\n  }\n  img{\n    display: block;\n    height: 16px;\n    margin-right: 12px;\n  }\n  span {\n  flex: 1;\n  }\n  .Icon{\n    cursor: pointer;\n    margin-left: 12px;\n    justify-self: right;\n  }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n    max-height: 200px;\n  '], ['\n    max-height: 200px;\n  ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      max-width: 1200px;\n    '], ['\n      max-width: 1200px;\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n  max-width: 640px;\n  color: #6F7E86;\n  font-size: 10px;\n  margin: 0 auto 40px;\n  line-height: 15px;\n  @media (max-width: 425px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n'], ['\n  max-width: 640px;\n  color: #6F7E86;\n  font-size: 10px;\n  margin: 0 auto 40px;\n  line-height: 15px;\n  @media (max-width: 425px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FAIcon = __webpack_require__(6);

var _FICPageSection = __webpack_require__(27);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _Autocomplete = __webpack_require__(406);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _FICTextButton = __webpack_require__(21);

var _FICTextButton2 = _interopRequireDefault(_FICTextButton);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _htmlToReact = __webpack_require__(181);

var _FICButton = __webpack_require__(23);

var _FICButton2 = _interopRequireDefault(_FICButton);

var _FICLink = __webpack_require__(183);

var _FICLink2 = _interopRequireDefault(_FICLink);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var htmlToReactParser = new _htmlToReact.Parser();

var IconClose = (0, _styledComponents2.default)(_FAIcon.FALIcon)(_templateObject, _FICColors2.default.white);
var Logo = _styledComponents2.default.img.withConfig({
  displayName: 'customComponents__Logo',
  componentId: 'und8mt-0'
})(_templateObject2);

var MainContainer = exports.MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'customComponents__MainContainer',
  componentId: 'und8mt-1'
})(_templateObject3, _FICColors2.default.white, function (props) {
  return props.isExternal && (0, _styledComponents.css)(_templateObject4);
});

var HeaderSearchSectionImpl = function HeaderSearchSectionImpl(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      _FICPageSection.FICPageSectionBlock,
      null,
      !props.isExternal && !props.embedded && _react2.default.createElement(
        'h1',
        null,
        'Supporto clienti'
      ),
      _react2.default.createElement(
        'div',
        { className: 'subtitle' },
        'Ciao! Come possiamo aiutarti?'
      ),
      _react2.default.createElement(_Autocomplete2.default, { onChange: props.onChange, onSelect: props.onSelect, isExternal: props.isExternal, realm: props.realm })
    )
  );
};

var HeaderSearchSection = (0, _styledComponents2.default)(HeaderSearchSectionImpl)(_templateObject5, function (props) {
  return props.isExternal && (0, _styledComponents.css)(_templateObject6);
}, _FICColors2.default.white);

var HelpHeaderImpl = function HelpHeaderImpl(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    !props.embedded && _react2.default.createElement(
      'div',
      { className: 'topHeader' },
      props.realm === 'fic' ? _react2.default.createElement(Logo, { src: '/img/logo-new-white.png', srcSet: '/img/logo-new-white@2x.png 2x, /img/logo-new-white@3x.png 3x', className: 'logo' }) : _react2.default.createElement(Logo, { src: '/img/logo-dipendenticloud-white.png', className: 'logo' }),
      props.isExternal && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'h1',
          { className: 'defaultTitle' },
          'Supporto clienti'
        ),
        _react2.default.createElement(
          'div',
          { className: 'accessButton' },
          _react2.default.createElement(_FICTextButton2.default, { text: 'Prova Gratis', iconLeft: ['fal', 'rocket'], href: props.realm === 'fic' ? 'https://www.fattureincloud.it/service/form/form-registrazione/' : 'https://secure.dipendentincloud.it/login?status=register' }),
          _react2.default.createElement(_FICTextButton2.default, { text: 'Accedi', iconLeft: ['fal', 'sign-in'], href: props.realm === 'fic' ? 'https://www.fattureincloud.it/service/form/form-login/' : 'https://secure.dipendentincloud.it/login?status=login' })
        )
      ),
      props.closeIcon && _react2.default.createElement(IconClose, { name: 'close', onClick: function onClick() {
          return props.onClickClose();
        }, size: 30, className: 'closeIcon' })
    ),
    _react2.default.createElement(HeaderSearchSection, {
      onChange: props.onChange,
      onSelect: props.onSelect,
      isExternal: props.isExternal,
      realm: props.realm,
      embedded: props.embedded
    })
  );
};

var HelpHeader = exports.HelpHeader = (0, _styledComponents2.default)(HelpHeaderImpl)(_templateObject7, _FICColors2.default.white);

var HelpHeaderDetailedImpl = (0, _react.forwardRef)(function (forwardedProps, ref) {
  var props = _extends({}, forwardedProps);
  return _react2.default.createElement(
    'div',
    { className: props.className, ref: ref },
    props.realm === 'fic' && !props.isExternal && _react2.default.createElement(FBCommunityBanner, { isExternal: false }),
    _react2.default.createElement(
      'div',
      { className: 'sectionHeader ' + (props.embedded ? 'embeddedHeader' : '') },
      !props.isExternal && _react2.default.createElement(_FICTextButton2.default, { iconLeft: ['fal', 'angle-left'], text: 'Indietro', onClick: props.onClick }),
      _react2.default.createElement(
        'h1',
        null,
        props.title
      ),
      props.description && _react2.default.createElement(
        'h4',
        { className: 'description' },
        props.description
      ),
      props.subtitle && _react2.default.createElement(
        'div',
        { className: 'subtitle' },
        props.subtitle
      ),
      props.closeIcon && !props.isExternal && _react2.default.createElement(IconClose, { name: 'close', onClick: function onClick() {
          return props.onClickClose();
        }, size: 30, style: { right: 0 } })
    )
  );
});

var HelpHeaderDetailed = exports.HelpHeaderDetailed = (0, _styledComponents2.default)(HelpHeaderDetailedImpl)(_templateObject8, _FICColors2.default.white, _FICColors2.default.white, _FICColors2.default.white, _FICColors2.default.white);

var Separator = exports.Separator = _styledComponents2.default.div.withConfig({
  displayName: 'customComponents__Separator',
  componentId: 'und8mt-2'
})(_templateObject9);

var ChatImpl = function ChatImpl(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'h3',
      null,
      'Non trovi quello che stai cercando?'
    ),
    _react2.default.createElement(
      'div',
      { className: 'averageResponseTime' },
      _react2.default.createElement(_FAIcon.FALIcon, { name: 'exclamation-triangle' }),
      _react2.default.createElement(
        'span',
        null,
        htmlToReactParser.parse(props.warning)
      )
    ),
    _react2.default.createElement(_FICTextButton2.default, { text: 'Contatta l\'assistenza', iconLeft: ['fal', 'envelope'], onClick: function onClick() {
        return chatOpening(props.type, props.id);
      } })
  );
};

var Chat = exports.Chat = (0, _styledComponents2.default)(ChatImpl)(_templateObject10, _FICColors2.default.white, _FICColors2.default.defaultBlue, _FICColors2.default.defaultBlue, _FICColors2.default.white, _FICColors2.default.defaultBlue);

var chatOpening = function chatOpening(type, id) {
  customerly.open();

  _FICRestV2.default.post({
    request: 'help/chat',
    postData: { data: _defineProperty({}, type + '_id', id) }
  });
};

var ElementNotFoundImpl = function ElementNotFoundImpl(_ref4) {
  var type = _ref4.type,
      onClick = _ref4.onClick,
      className = _ref4.className;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement('img', { srcSet: '/img/no-results.png 3x' }),
    _react2.default.createElement(
      'div',
      { style: { margin: '20px 0' } },
      type === 'section' ? 'La sezione cercata non esiste.' : 'L\'articolo cercato non esiste.'
    ),
    _react2.default.createElement(_FICButton2.default, { text: 'Torna alla home', onClick: onClick })
  );
};

var ElementNotFound = exports.ElementNotFound = (0, _styledComponents2.default)(ElementNotFoundImpl)(_templateObject11);

var FBCommunityBanner = exports.FBCommunityBanner = function (_Component) {
  _inherits(FBCommunityBanner, _Component);

  function FBCommunityBanner(props) {
    _classCallCheck(this, FBCommunityBanner);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.goToFBPage = function () {
      window.open('http://bit.ly/fic-fb', '_blank');
      _this.hideFacebookBanner();
    };

    _this.hideFacebookBanner = function () {
      localStorage.setItem('helpFacebookBannerIsVisible', 'false');
      _this.setState({ isFacebookBannerVisible: false });
    };

    _this.state = { isFacebookBannerVisible: false };
    return _this;
  }

  FBCommunityBanner.prototype.componentDidMount = function componentDidMount() {
    this.setState({ isFacebookBannerVisible: !localStorage.getItem('helpFacebookBannerIsVisible') });
  };

  FBCommunityBanner.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      FBCommunityBannerContainer,
      {
        isVisible: this.state.isFacebookBannerVisible,
        isExternal: this.props.isExternal
      },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: '/img/logo-fb-circle.png', alt: 'facebook-logo' }),
        _react2.default.createElement(
          'span',
          null,
          'Migliaia di utenti utilizzano la nostra community su Facebook per aiutarsi tra di loro e per ricevere supporto.',
          _react2.default.createElement(_FICLink2.default, {
            target: '_blank',
            onClick: function onClick() {
              _this2.goToFBPage();
            },
            text: 'Iscriviti anche te!',
            style: { marginLeft: 5 }
          })
        ),
        _react2.default.createElement(_FICIcon2.default, {
          name: 'times',
          onClick: function onClick() {
            _this2.hideFacebookBanner();
          }
        })
      )
    );
  };

  return FBCommunityBanner;
}(_react.Component);

var FBCommunityBannerContainer = _styledComponents2.default.div.withConfig({
  displayName: 'customComponents__FBCommunityBannerContainer',
  componentId: 'und8mt-3'
})(_templateObject12, _FICColors2.default.lightGray, _FICColors2.default.textDefault, function (props) {
  return props.isVisible && (0, _styledComponents.css)(_templateObject13);
}, function (props) {
  return props.isExternal && (0, _styledComponents.css)(_templateObject14);
});

var PrivacyMessageImpl = function PrivacyMessageImpl(_ref5) {
  var className = _ref5.className,
      isFic = _ref5.isFic;

  return _react2.default.createElement(
    'div',
    { className: className },
    isFic ? _react2.default.createElement(
      _react.Fragment,
      null,
      'Fatture in Cloud \xE8 finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti contabili e amministrativi relativi alle fatture elettroniche. Tale trattamento richiede che Fatture in Cloud sia utilizzato in conformit\xE0 con i principi di minimizzazione, integrit\xE0 e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile, ad esempio limitando la descrizione della prestazione professionale svolta a quanto strettamente necessario a fini fiscali per evitare di includere dati di minori o relativi a prestazioni sanitarie, condanne penali e reati'
    ) : _react2.default.createElement(
      _react.Fragment,
      null,
      'Dipendenti in Cloud \xE8 finalizzato a consentire il trattamento dei Dati Personali strettamente necessari ai fini della gestione degli adempimenti relativi alla gestione dei dipendenti. Tale trattamento richiede che Dipendenti in Cloud sia utilizzato in conformit\xE0 con i principi di minimizzazione, integrit\xE0 e riservatezza previsti dalla normativa in materia di protezione dei dati personali applicabile.'
    )
  );
};

var PrivacyMessage = exports.PrivacyMessage = (0, _styledComponents2.default)(PrivacyMessageImpl)(_templateObject15);

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border: 2px dashed #d5d5d563;\n  border-radius: 8px;\n  display: table;\n  padding: 20px;\n  box-sizing: border-box;\n  cursor: pointer;\n  ', '\n\n  ', ';\n\n  ', ';\n\n  div.description {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n  }\n  div.files {\n    display: table-row;\n    vertical-align: middle;\n    margin-top: 10px;\n    text-align: center;\n    >div {\n      text-align: center;\n      margin-top: 16px;\n    }\n  }\n'], ['\n  width: 100%;\n  border: 2px dashed #d5d5d563;\n  border-radius: 8px;\n  display: table;\n  padding: 20px;\n  box-sizing: border-box;\n  cursor: pointer;\n  ', '\n\n  ', ';\n\n  ', ';\n\n  div.description {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n  }\n  div.files {\n    display: table-row;\n    vertical-align: middle;\n    margin-top: 10px;\n    text-align: center;\n    >div {\n      text-align: center;\n      margin-top: 16px;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    cursor: not-allowed;\n  '], ['\n    color: ', ';\n    cursor: not-allowed;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    border-color: #007ce4;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 124, 228, 0.1);\n    b.fa.fa-cloud-upload {\n      color: #007ce4;\n    }\n  '], ['\n    border-color: #007ce4;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 124, 228, 0.1);\n    b.fa.fa-cloud-upload {\n      color: #007ce4;\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    border-color: #f46e65;\n    box-shadow: inset 0 1px 1px rgba(240, 65, 52, .1), 0 0 0 3px rgba(240, 65, 52, .1);\n    b.fa.fa-cloud-upload {\n      color: #f46e65;\n    }\n  '], ['\n    border-color: #f46e65;\n    box-shadow: inset 0 1px 1px rgba(240, 65, 52, .1), 0 0 0 3px rgba(240, 65, 52, .1);\n    b.fa.fa-cloud-upload {\n      color: #f46e65;\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n'], ['\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    cursor: pointer;\n'], ['\n    cursor: pointer;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;      \n  width: ', 'px;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;      \n  width: ', 'px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  cursor: default;\n  display: inline-block;\n'], ['\n  cursor: default;\n  display: inline-block;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  width: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n    overflow: hidden;\n'], ['\n  width: 100px;\n  display: inline-block;\n  vertical-align: middle;\n  ', '\n    overflow: hidden;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = __webpack_require__(123);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

var _FICAlert = __webpack_require__(14);

var _FICAlert2 = _interopRequireDefault(_FICAlert);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _mimeTypes = __webpack_require__(124);

var _mimeTypes2 = _interopRequireDefault(_mimeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var typesMap = {
  unknown: {
    mimeTypes: ['*'],
    extensions: [],
    icon: 'file'
  },
  pdf: {
    mimeTypes: ['application/pdf'],
    extensions: ['pdf'],
    icon: 'file-pdf'
  },
  image: {
    mimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
    extensions: ['png', 'gif', 'jpg', 'jpeg'],
    icon: 'file-image-o'
  },
  zip: {
    mimeTypes: ['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'],
    extensions: ['zip'],
    icon: 'file-archive'
  },
  /* rar: {
    mimeTypes: [ 'application/x-rar-compressed', 'application/octet-stream' ],
    extensions: [ 'rar' ],
    icon: 'file-archive'
  }, */
  archive: {
    mimeTypes: ['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip', 'application/x-rar-compressed'],
    extensions: ['zip'],
    icon: 'file-archive'
  },
  text: {
    mimeTypes: ['text/plain', 'application/rtf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text'],
    extensions: ['doc', 'docx'],
    icon: 'file-word'
  },
  document: {
    mimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text'],
    extensions: ['doc', 'docx', 'docm'],
    icon: 'file-word'
  },
  spreadsheet: {
    mimeTypes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.spreadsheet'],
    extensions: ['xls', 'xlsx', 'xlsm'],
    icon: 'file-excel'
  },
  presentation: {
    mimeTypes: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.oasis.opendocument.presentation'],
    extensions: ['ppt', 'pptx', 'odp'],
    icon: 'file-powerpoint'
  },
  xml: {
    mimeTypes: ['text/xml', 'application/xml'],
    extensions: ['xml'],
    icon: ['file-code']
  },
  csv: {
    mimeTypes: ['text/csv', 'text/plain', 'text/x-csv', 'application/vnd.ms-excel', 'application/csv', 'application/x-csv', 'text/comma-separated-values', 'text/x-comma-separated-values', 'text/tab-separated-values'],
    extensions: ['csv'],
    icon: ['file-csv']
  }
};

var getIconForMimeType = function getIconForMimeType(type) {
  var typeName = Object.keys(typesMap).find(function (typeName) {
    return typesMap[typeName].mimeTypes.includes(type);
  });
  if (typeName) {
    return typesMap[typeName].icon;
  }
  return 'file';
};

var FICFileUploader = function (_Component) {
  _inherits(FICFileUploader, _Component);

  function FICFileUploader(props) {
    _classCallCheck(this, FICFileUploader);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var allowedTypes = props.allowedTypes,
        allowedExtensions = props.allowedExtensions;

    var mimeTypes = [];
    var extensions = [];
    allowedTypes.forEach(function (type) {
      if (typesMap.hasOwnProperty(type)) {
        mimeTypes = [].concat(_toConsumableArray(mimeTypes), _toConsumableArray(typesMap[type].mimeTypes));
        extensions = [].concat(_toConsumableArray(extensions), _toConsumableArray(typesMap[type].extensions));
      } else {
        mimeTypes.push(type);
      }
    });
    mimeTypes = mimeTypes.join(', ');
    extensions = [].concat(_toConsumableArray(extensions), _toConsumableArray(allowedExtensions)).join(', ').toUpperCase();
    _this.state = {
      accept: mimeTypes,
      extensions: extensions,
      selectedFiles: [],
      uploading: false
    };
    return _this;
  }

  FICFileUploader.prototype.componentDidMount = function componentDidMount() {
    if (this.props.preloadedFiles.length > 0 && this.state.selectedFiles.length === 0) {
      this.setState({ selectedFiles: this.props.preloadedFiles });
    }
  };

  FICFileUploader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (JSON.stringify(prevProps.preloadedFiles) !== JSON.stringify(this.props.preloadedFiles) && this.state.selectedFiles.length === 0 && this.props.preloadedFiles.length > 0) {
      this.setState({ selectedFiles: this.props.preloadedFiles });
    }
    // Make sure to revoke the data uris to avoid memory leaks
    setTimeout(function () {
      _this2.state.selectedFiles.forEach(function (file) {
        return URL.revokeObjectURL(file.preview);
      });
    }, 100);
  };

  FICFileUploader.prototype.render = function render() {
    var _state = this.state,
        accept = _state.accept,
        extensions = _state.extensions,
        selectedFiles = _state.selectedFiles,
        uploading = _state.uploading;

    var _props = this.props,
        className = _props.className,
        allowedTypes = _props.allowedTypes,
        allowedExtensions = _props.allowedExtensions,
        onDrop = _props.onDrop,
        uploadPath = _props.uploadPath,
        onUploadSuccess = _props.onUploadSuccess,
        onUploadError = _props.onUploadError,
        preloadedFiles = _props.preloadedFiles,
        disabled = _props.disabled,
        innerProps = _objectWithoutProperties(_props, ['className', 'allowedTypes', 'allowedExtensions', 'onDrop', 'uploadPath', 'onUploadSuccess', 'onUploadError', 'preloadedFiles', 'disabled']);

    return _react2.default.createElement(StyledDropzone, _extends({
      accept: accept,
      extensions: extensions,
      selectedFiles: selectedFiles,
      onDrop: this.handleFileDrop,
      multiple: false,
      removeFile: this.removeFile,
      uploading: uploading,
      disabled: disabled
    }, innerProps));
  };

  return FICFileUploader;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleFileDrop = function (accepted, rejected) {
    var props = _this3.props;
    if (accepted.length > 0) {
      _this3.setState({ uploading: true });

      if (props.uploadPath) {
        var alertId = _FICAlert2.default.info('Caricamento in corso....', 0);
        _FICRestV2.default.post({
          request: props.uploadPath,
          formData: {
            filename: accepted[0].name,
            attachment: accepted[0]
          },
          onSuccess: function onSuccess(response) {
            _FICAlert2.default.close(alertId);
            if (response.data.attachment_token) {
              var newFiles = accepted.slice();

              newFiles[0].attachment_token = response.data.attachment_token;
              newFiles[0].preview = URL.createObjectURL(accepted[0]);

              _this3.setState({ selectedFiles: newFiles, uploading: false }, function () {
                if (props.onChange) {
                  props.onChange(_this3.state.selectedFiles);
                }
              });
            }
            if (props.onUploadSuccess) {
              props.onUploadSuccess(response);
            }
          },
          onError: function onError(response) {
            _FICAlert2.default.close(alertId);
            _FICAlert2.default.error('Questo file non può essere allegato.');
            _this3.setState({ selectedFiles: [], uploading: false }, function () {
              if (props.onChange) {
                props.onChange(_this3.state.selectedFiles);
              }
            });
            if (props.onUploadError) {
              props.onUploadError(response);
            }
          }
        });
      }
    } else if (rejected.length > 0) {
      if (rejected.length > 1) {
        _FICAlert2.default.error('Puoi caricare un solo file.');
      } else {
        if (rejected[0].size > props.maxSize) {
          _FICAlert2.default.error('Questo file supera la dimensione massima consentita (' + Math.round(props.maxSize / 1024 / 1024) + 'MB).');
        } else {
          _FICAlert2.default.error('Questo tipo di file non è supportato.');
        }
      }
    }
    if (props.onDrop) {
      props.onDrop(accepted, rejected);
    }
  };

  this.removeFile = function (e, idx) {
    e.stopPropagation();

    var props = _this3.props;
    var newFiles = _this3.state.selectedFiles.slice();

    newFiles.splice(idx, 1);
    _this3.setState({
      selectedFiles: newFiles
    }, function () {
      if (props.onChange) {
        props.onChange(_this3.state.selectedFiles);
      }
    });
  };
};

function StyledDropzone(_ref) {
  var className = _ref.className,
      accept = _ref.accept,
      extensions = _ref.extensions,
      selectedFiles = _ref.selectedFiles,
      onDrop = _ref.onDrop,
      multiple = _ref.multiple,
      removeFile = _ref.removeFile,
      uploading = _ref.uploading,
      previewMaxHeight = _ref.previewMaxHeight,
      text = _ref.text,
      disabled = _ref.disabled;

  var _useDropzone = (0, _reactDropzone.useDropzone)({ accept: accept, multiple: multiple, onDrop: onDrop, disabled: disabled }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      isDragAccept = _useDropzone.isDragAccept,
      isDragReject = _useDropzone.isDragReject;

  var uploadFileRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(1000000),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useEffect)(function () {
    if (uploadFileRef.current && uploadFileRef.current.offsetWidth < width) {
      setWidth(uploadFileRef.current.offsetWidth);
    }
  });

  return _react2.default.createElement(
    Container,
    getRootProps({ className: className, isDragActive: isDragActive, isDragAccept: isDragAccept, isDragReject: isDragReject, disabled: disabled }),
    _react2.default.createElement('input', getInputProps()),
    _react2.default.createElement(
      'div',
      { className: 'description', ref: uploadFileRef },
      uploading ? _react2.default.createElement('img', { src: 'img/ajax-loader.gif', style: { width: 150 } }) : _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_FICIcon2.default, { name: 'cloud-upload', type: 'solid', size: 48 })
        ),
        text ? _react2.default.createElement(
          'div',
          null,
          text
        ) : _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            null,
            'Puoi allegare un documento trascinandolo o premendo qui.'
          ),
          extensions && extensions.length > 0 && _react2.default.createElement(
            'div',
            null,
            'Sono accettati file di tipo ',
            extensions,
            '.'
          )
        )
      )
    ),
    selectedFiles.length > 0 && _react2.default.createElement(
      'div',
      { className: 'files' },
      selectedFiles.map(function (file, idx) {
        return _react2.default.createElement(FileItem, {
          key: idx,
          idx: idx,
          file: file,
          width: width,
          onRemoveClick: removeFile,
          previewMaxHeight: previewMaxHeight,
          disabled: disabled
        });
      })
    )
  );
}

var FileItem = function FileItem(_ref2) {
  var file = _ref2.file,
      onRemoveClick = _ref2.onRemoveClick,
      idx = _ref2.idx,
      width = _ref2.width,
      disabled = _ref2.disabled,
      props = _objectWithoutProperties(_ref2, ['file', 'onRemoveClick', 'idx', 'width', 'disabled']);

  var fileName = file.name || file.substring(file.lastIndexOf('/') + 1);

  return _react2.default.createElement(
    FileItemContainer,
    _extends({ onClick: function onClick(e) {
        return e.stopPropagation();
      } }, props),
    file instanceof File && !file.attachment_token ? _react2.default.createElement(FileItemLoading, {
      name: 'circle-notch',
      size: 20,
      color: _FICColors2.default.primary,
      spin: true
    }) : _react2.default.createElement(
      _react.Fragment,
      null,
      !disabled && _react2.default.createElement(FileItemIcon, { onClick: function onClick(e) {
          return onRemoveClick(e, idx);
        }, name: 'times-circle' }),
      _react2.default.createElement(
        FilePreviewWrapper,
        { previewMaxHeight: props.previewMaxHeight },
        typeof file === 'string' && _mimeTypes2.default.lookup(file) && _mimeTypes2.default.lookup(file).includes('image') ? _react2.default.createElement('img', { src: file, onClick: function onClick(e) {
            return e.stopPropagation();
          } }) : file.type && file.type.includes('image') ? file.preview ? _react2.default.createElement('img', { src: file.preview, onClick: function onClick(e) {
            return e.stopPropagation();
          } }) : _react2.default.createElement(FileItemIcon, { name: file.icon || getIconForMimeType(file.type), size: 40 }) : _react2.default.createElement(FileItemIcon, { name: file.icon || getIconForMimeType(file.type || _mimeTypes2.default.lookup(file)), size: 40 })
      ),
      _react2.default.createElement(
        FileItemName,
        { width: width },
        fileName
      )
    )
  );
};

FICFileUploader.propTypes = {
  allowedTypes: _propTypes2.default.array,
  allowedExtensions: _propTypes2.default.array,
  multiple: _propTypes2.default.bool,
  maxSize: _propTypes2.default.number,
  onDrop: _propTypes2.default.func,
  uploadPath: _propTypes2.default.string,
  onUploadSuccess: _propTypes2.default.func,
  onUploadError: _propTypes2.default.func,
  preloadedFiles: _propTypes2.default.array,
  disabled: _propTypes2.default.bool,
  previewMaxHeight: _propTypes2.default.number
};

FICFileUploader.defaultProps = {
  allowedTypes: [],
  allowedExtensions: [],
  multiple: false,
  maxSize: undefined,
  onDrop: undefined,
  uploadPath: undefined,
  onUploadSuccess: undefined,
  onUploadError: undefined,
  preloadedFiles: [],
  disabled: undefined,
  previewMaxHeight: undefined

  /*
  const FICFileUploader = styled(FICFileUploaderImpl)`
    width: 100%;
    height: 200px;
    border: 2px dashed #d5d5d563;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    color: ${props => props.disabled ? FICColors.textDisabled : undefined};
    text-align: center !important;
    div.description {
      vertical-align: middle;
    }
    div.files {
      vertical-align: middle;
      margin-top: 10px;
      >div {
        margin-top: 16px;
      }
    }
    &.dropzone-accept {
      border-color: #007ce4;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 124, 228, 0.1);
      b.fa.fa-cloud-upload {
        color: #007ce4;
      }
    }
    &.dropzone-reject {
      border-color: #f46e65;
      box-shadow: inset 0 1px 1px rgba(240, 65, 52, .1), 0 0 0 3px rgba(240, 65, 52, .1);
      b.fa.fa-cloud-upload {
        color: #f46e65;
      }
    }
  `
   */

};var Container = _styledComponents2.default.div.withConfig({
  displayName: 'FICFileUploader__Container',
  componentId: 'c6fc2t-0'
})(_templateObject, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject2, _FICColors2.default.textDisabled);
}, function (props) {
  return (props.isDragActive || props.isDragAccept) && (0, _styledComponents.css)(_templateObject3);
}, function (props) {
  return props.isDragReject && (0, _styledComponents.css)(_templateObject4);
});

var FileItemLoading = (0, _styledComponents2.default)(_FICIcon2.default)(_templateObject5);

var FileItemIcon = (0, _styledComponents2.default)(_FICIcon2.default)(_templateObject6, function (props) {
  return props.onClick && (0, _styledComponents.css)(_templateObject7);
});

var FileItemName = _styledComponents2.default.div.withConfig({
  displayName: 'FICFileUploader__FileItemName',
  componentId: 'c6fc2t-1'
})(_templateObject8, function (props) {
  return props.width;
});

var FileItemContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FICFileUploader__FileItemContainer',
  componentId: 'c6fc2t-2'
})(_templateObject9);

var FilePreviewWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'FICFileUploader__FilePreviewWrapper',
  componentId: 'c6fc2t-3'
})(_templateObject10, function (props) {
  return props.previewMaxHeight && '\n    max-height: ' + props.previewMaxHeight + 'px;\n  ';
});

exports.default = FICFileUploader;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormController = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _FICFormNode = __webpack_require__(71);

var _FICFormNode2 = _interopRequireDefault(_FICFormNode);

var _defaults = __webpack_require__(72);

var _validate = __webpack_require__(51);

var _validate2 = _interopRequireDefault(_validate);

var _immutabilityHelper = __webpack_require__(88);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FICForm = function FICForm(_ref) {
  var className = _ref.className,
      style = _ref.style,
      config = _ref.config,
      validationRules = _ref.validationRules,
      validationResult = _ref.validationResult,
      formOptions = _ref.formOptions,
      nodeProps = _objectWithoutProperties(_ref, ['className', 'style', 'config', 'validationRules', 'validationResult', 'formOptions']);

  var validation = validationResult === undefined ? FICForm.validate(nodeProps.data, validationRules) : validationResult;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('FICForm', className),
      style: style
    },
    _react2.default.createElement(_FICFormNode2.default, _extends({}, nodeProps, {
      // config={_.merge({}, FICForm.defaultConfig, config)}
      config: config || FICForm.defaultConfig,
      validation: validation,
      formOptions: formOptions
    }))
  );
};

FICForm.defaultProps = {
  className: undefined,
  style: {},
  config: undefined,
  schema: {},
  validationRules: {},
  validationResult: undefined,
  data: {},
  onChange: undefined,
  formOptions: {}
};

FICForm.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  config: _propTypes2.default.object,
  schema: _propTypes2.default.object,
  validationRules: _propTypes2.default.object,
  validationResult: _propTypes2.default.object,
  data: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  formOptions: _propTypes2.default.object
};

FICForm.defaultConfig = {};

FICForm.createConfig = function (rawConfig) {
  var newConfig = _lodash2.default.merge({}, _defaults.defaultConfig, rawConfig);
  _lodash2.default.forEach(newConfig.customValidators, function (v, k) {
    _validate2.default.validators[k] = v;
  });
  return newConfig;
};

FICForm.init = function (config) {
  FICForm.defaultConfig = config;
};

FICForm.validate = function (data, validationRules) {
  var validationResults = (0, _validate2.default)(data, validationRules, { fullMessages: false });
  return validationResults || {};
};

exports.default = FICForm;

// Hook per gestire lo stato della form in modo easy

var useFormController = exports.useFormController = function useFormController(initialData, objectPath) {
  var _useState = (0, _react.useState)(initialData),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var handleDataChange = function handleDataChange(name, value) {
    var selectorPath = [objectPath, name].filter(function (t) {
      return t;
    }).join('.');
    var selector = _lodash2.default.set({}, selectorPath, { $set: value });
    var newData = (0, _immutabilityHelper2.default)(data, selector);
    setData(newData);
  };
  return [data, handleDataChange, setData];
};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  width: 100%;\n'], ['\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 4px;\n  width: 100%;\n'], ['\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 4px;\n  width: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  width: 100%;\n'], ['\n  position: relative;\n  display: inline-block;\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  ', '\n  ', ' {\n    line-height: 30px;\n    ', '\n   }\n  .FICInputText_Input{\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 4px;\n    //min-width: 258px;\n    width: 100%;\n    color: ', ';\n    height: 30px;\n    font-size: 14px;\n    font-weight: 400;\n    //line-height: 24px;\n    text-align: left;\n    padding: 4px 8px;\n    box-sizing: border-box;\n    ', '\n    ', '\n    ', '\n    &:focus{\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      ', '\n    }\n    &::placeholder{\n      color: ', ';\n      font-size: 14px;\n    }\n  }\n'], ['\n  display: block;\n  position: relative;\n  ', '\n  ', ' {\n    line-height: 30px;\n    ', '\n   }\n  .FICInputText_Input{\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 4px;\n    //min-width: 258px;\n    width: 100%;\n    color: ', ';\n    height: 30px;\n    font-size: 14px;\n    font-weight: 400;\n    //line-height: 24px;\n    text-align: left;\n    padding: 4px 8px;\n    box-sizing: border-box;\n    ', '\n    ', '\n    ', '\n    &:focus{\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      ', '\n    }\n    &::placeholder{\n      color: ', ';\n      font-size: 14px;\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n      width: ', '', '};\n  '], ['\n      width: ', '', '};\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      line-height: 30px;\n    '], ['\n      line-height: 30px;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      height: 40px;\n      font-size: 16px;\n      &::placeholder{ font-size: 16px; }\n    '], ['\n      height: 40px;\n      font-size: 16px;\n      &::placeholder{ font-size: 16px; }\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n    '], ['\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      cursor: not-allowed;\n    '], ['\n      background-color: ', ';\n      cursor: not-allowed;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n        border-color:', ';\n        box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      '], ['\n        border-color:', ';\n        box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICNumbers = __webpack_require__(19);

var _FICNumbers2 = _interopRequireDefault(_FICNumbers);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _icons = __webpack_require__(74);

var _sideText = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICInputTextImpl = function (_Component) {
  _inherits(FICInputTextImpl, _Component);

  function FICInputTextImpl(props) {
    _classCallCheck(this, FICInputTextImpl);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.textInput = null;
    _this.scheduledChange = null;
    _this.lastOnChangeValue = props.value || undefined;
    _this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined,
      clearableVisible: props.clearable && props.value
      // allowAutoFocusChange: true,
    };
    return _this;
  }

  FICInputTextImpl.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.props.autoFocus) {
      setTimeout(function () {
        _this2.focus();
        setTimeout(function () {
          _this2.setState({ useInternalValue: false });
        }, 0);
      }, 100);
    }
  };

  FICInputTextImpl.prototype.focus = function focus() {
    if (this.textInput) {
      this.textInput.focus();
    }
  };

  FICInputTextImpl.prototype.blur = function blur() {
    if (this.textInput) {
      this.textInput.blur();
    }
  };

  /*
  TODO: togliere jQuery e usare react
  nextInput () {
    let inputs = $(':input')
    let nextInput = inputs.get(inputs.index(this.textInput) + 1)
    if (nextInput) {
      nextInput.focus()
    }
  } */

  FICInputTextImpl.prototype.uncontrolledGetValue = function uncontrolledGetValue() {
    return this.textInput.value;
  };

  FICInputTextImpl.prototype.uncontrolledSetValue = function uncontrolledSetValue(value) {
    this.textInput.value = value;
  };

  FICInputTextImpl.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        leftIcon = _props.leftIcon,
        leftIconClick = _props.leftIconClick,
        leftText = _props.leftText,
        rightIcon = _props.rightIcon,
        rightIconClick = _props.rightIconClick,
        rightText = _props.rightText,
        style = _props.style,
        clearable = _props.clearable,
        onChange = _props.onChange,
        props = _objectWithoutProperties(_props, ['leftIcon', 'leftIconClick', 'leftText', 'rightIcon', 'rightIconClick', 'rightText', 'style', 'clearable', 'onChange']);

    var FICInputTextTag = props.type === 'multiline' ? 'textarea' : 'input';

    if (props.isValid === true) {
      rightIcon = 'check';
    }

    // Textarea
    var style2 = FICInputTextTag === 'textarea' && props.lines > 0 ? { height: 30 + 25 * (props.lines - 1) } : {};
    style = _extends({}, style, style2);
    // Clearable
    if (clearable) {
      rightIcon = this.state.clearableVisible ? 'close' : null;
      rightIconClick = onChange ? function () {
        var prevValue = _this3.uncontrolledGetValue();
        if (props.uncontrolled) {
          _this3.uncontrolledSetValue('');
        }
        if (prevValue !== '') {
          _this3.setState({ clearableVisible: false });
          _this3.executeOnChange('');
        }
      } : rightIconClick;
    }
    // Advanced options style
    if (leftIcon) {
      _extends(style, { paddingLeft: 28 });
    }
    if (rightIcon) {
      _extends(style, { paddingRight: 28 });
    }
    leftText = leftText && (typeof leftText === 'function' ? leftText() : leftText);
    if (leftText) {
      _extends(style, { paddingLeft: 14 + 6 * (typeof leftText === 'string' ? leftText.length : leftText.width) });
    }
    rightText = rightText && (typeof rightText === 'function' ? rightText() : rightText);
    if (rightText) {
      _extends(style, { paddingRight: 14 + 6 * (typeof rightText === 'string' ? rightText.length : rightText.width) });
    }
    // Display
    var value = this.getDisplayValue();
    var result = _react2.default.createElement(FICInputTextTag, {
      type: props.inputType,
      ref: function ref(input) {
        _this3.textInput = input;
      },
      value: value,
      placeholder: props.placeholder,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: props.onKeyPress,
      onKeyDown: props.onKeyDown,
      onKeyUp: props.onKeyUp,
      onClick: props.onClick,
      onMouseOver: props.onMouseOver,
      onMouseOut: props.onMouseOut,
      className: 'FICInputText_Input',
      maxLength: props.maxLength,
      style: style || props.style,
      disabled: props.isDisabled,
      readOnly: props.isReadOnly,
      autoComplete: 'new-password' // Disable Chrome autofill
    });

    // Advanced options wrap
    result = _react2.default.createElement(
      InputContainer,
      null,
      leftText && _react2.default.createElement(
        _sideText.LeftText,
        null,
        leftText
      ),
      leftIcon && _react2.default.createElement(_icons.LefIcon, {
        name: leftIcon,
        onClick: leftIconClick,
        style: leftIconClick ? { cursor: 'pointer' } : {},
        size: props.size,
        isDisabled: props.isDisabled,
        spin: props.leftIconSpin
      }),
      result,
      rightIcon && _react2.default.createElement(_icons.RightIcon, {
        name: rightIcon,
        onClick: rightIconClick,
        style: rightIconClick ? { cursor: 'pointer' } : {},
        size: props.size,
        isValid: props.isValid,
        isDisabled: props.isDisabled,
        spin: props.rightIconSpin
      }),
      rightText && _react2.default.createElement(
        _sideText.RightText,
        null,
        rightText
      )
    );

    if (props.errorText !== undefined) {
      result = _react2.default.createElement(
        ErrorTextContainer,
        null,
        result,
        props.errorText && _react2.default.createElement(
          ErrorText,
          null,
          props.errorText
        )
      );
    }

    return _react2.default.createElement(
      'div',
      { className: props.className },
      result
    );
  };

  return FICInputTextImpl;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.shouldUseInternalValue = function () {
    return _this4.props.changeOnBlur || !_this4.props.uncontrolled && _this4.props.changeDelay;
  };

  this.getDisplayValue = function () {
    var props = _this4.props;
    var state = _this4.state;
    return props.uncontrolled ? undefined : _this4.shouldUseInternalValue() && state.useInternalValue ? state.internalValue || '' : props.transform ? props.transform(props.value) : props.value != null ? props.value : '';
  };

  this.handleChange = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    // this.setState({ allowAutoFocusChange: false })
    if (props.clearable) {
      _this4.setState({ clearableVisible: value });
    }
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({ internalValue: value, useInternalValue: true });
    }
    if (props.changeDelay) {
      if (_this4.scheduledChange) {
        clearTimeout(_this4.scheduledChange);
      }
      _this4.scheduledChange = setTimeout(function () {
        _this4.executeOnChange(value);
      }, props.changeDelay);
    } else {
      _this4.executeOnChange(value);
    }
  };

  this.executeOnChange = function (value) {
    var props = _this4.props;
    if (props.onChange && (value !== _this4.lastOnChangeValue || value !== props.value)) {
      _this4.lastOnChangeValue = value;
      props.onChange(value);
    }
  };

  this.handleFocus = function (e) {
    var props = _this4.props;
    if (_this4.shouldUseInternalValue()) {
      _this4.setState({
        useInternalValue: true,
        internalValue: props.value
      });
    }
    if (props.onFocus) {
      props.onFocus(e);
    }
  };

  this.handleBlur = function (e) {
    var props = _this4.props;
    var value = e.target.value;
    _this4.setState({ useInternalValue: false });
    if (props.changeOnBlur) {
      _this4.executeOnChange(value);
    }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
};

var ErrorTextContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FICInputText__ErrorTextContainer',
  componentId: 'sc-1ecbqcy-0'
})(_templateObject);

var ErrorText = _styledComponents2.default.div.withConfig({
  displayName: 'FICInputText__ErrorText',
  componentId: 'sc-1ecbqcy-1'
})(_templateObject2, _FICColors2.default.red);

var InputContainer = _styledComponents2.default.div.withConfig({
  displayName: 'FICInputText__InputContainer',
  componentId: 'sc-1ecbqcy-2'
})(_templateObject3);

var FICInputText = (0, _styledComponents2.default)(FICInputTextImpl)(_templateObject4, function (props) {
  return props.width && (0, _styledComponents.css)(_templateObject5, props.width, typeof props.width === 'number' ? 'px' : undefined);
}, InputContainer, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject6);
}, _FICColors2.default.white, _FICColors2.default.borderColor, _FICColors2.default.black, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject7);
}, function (props) {
  return props.isValid === false && (0, _styledComponents.css)(_templateObject8, _FICColors2.default.red, _FICColors2.default.red, _FICColors2.default.red);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject9, _FICColors2.default.inputDisabled);
}, _FICColors2.default.blue, _FICColors2.default.blue, _FICColors2.default.blue, function (props) {
  return props.isValid === false && (0, _styledComponents.css)(_templateObject10, _FICColors2.default.red, _FICColors2.default.red, _FICColors2.default.red);
}, _FICColors2.default.placeholder);

FICInputText.dotsToCommasTransform = function (value) {
  return _FICNumbers2.default.dotsToCommas(value);
};

FICInputTextImpl.propTypes = FICInputText.propTypes = {
  type: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  placeholder: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  maxLength: _propTypes2.default.number,
  style: _propTypes2.default.object,
  uncontrolled: _propTypes2.default.bool,
  changeOnBlur: _propTypes2.default.bool,
  changeDelay: _propTypes2.default.number,
  lines: _propTypes2.default.number,
  transform: _propTypes2.default.func,
  inputType: _propTypes2.default.string,
  isDisabled: _propTypes2.default.bool,
  isReadOnly: _propTypes2.default.bool,
  clearable: _propTypes2.default.bool,
  leftIcon: _propTypes2.default.string,
  leftIconClick: _propTypes2.default.func,
  leftIconHover: _propTypes2.default.func,
  leftText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  rightIcon: _propTypes2.default.string,
  rightIconClick: _propTypes2.default.func,
  rightIconHover: _propTypes2.default.func,
  rightText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  leftIconSpin: _propTypes2.default.bool,
  rightIconSpin: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  isValid: _propTypes2.default.bool,
  errorText: _propTypes2.default.string,
  validator: _propTypes2.default.object,
  tooltipPlace: _propTypes2.default.string,
  tooltipEvent: _propTypes2.default.string,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  autoFocus: _propTypes2.default.bool
};

FICInputTextImpl.defaultProps = FICInputText.defaultProps = {
  type: 'text',
  value: undefined,
  placeholder: undefined,
  onChange: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onKeyPress: undefined,
  onKeyDown: undefined,
  onKeyUp: undefined,
  onClick: undefined,
  maxLength: undefined,
  style: {},
  uncontrolled: false,
  changeOnBlur: true,
  changeDelay: 500,
  lines: 1,
  transform: undefined,
  inputType: 'text',
  isDisabled: undefined,
  isReadOnly: undefined,
  clearable: false,
  leftIcon: undefined,
  leftIconClick: undefined,
  leftIconHover: undefined,
  leftText: undefined,
  rightIcon: undefined,
  rightIconClick: undefined,
  rightIconHover: undefined,
  leftIconSpin: false,
  rightIconSpin: false,
  rightText: undefined,
  size: undefined,
  isValid: undefined,
  errorText: undefined,
  validator: undefined,
  tooltipPlace: undefined,
  tooltipEvent: undefined,
  width: undefined,
  autoFocus: false
};

exports.default = FICInputText;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICBaseButton = function (_Component) {
  _inherits(FICBaseButton, _Component);

  function FICBaseButton(props) {
    _classCallCheck(this, FICBaseButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.clickable = true;
    return _this;
  }

  FICBaseButton.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        _onClick = _props.onClick,
        isDisabled = _props.isDisabled,
        isLoading = _props.isLoading,
        target = _props.target,
        className = _props.className,
        href = _props.href,
        style = _props.style,
        renderButton = _props.renderButton;


    return _react2.default.createElement(
      'a',
      {
        className: className,
        onClick: function onClick() {
          if (!_this2.clickable || isLoading || isDisabled) {
            return;
          }

          _this2.clickable = false;
          setTimeout(function () {
            _this2.clickable = true;
          }, 500);
          if (_onClick) {
            _onClick();
          }
        },
        href: !isDisabled ? href : undefined,
        target: target,
        style: style
      },
      renderButton(this.props, this.state)
    );
  };

  return FICBaseButton;
}(_react.Component);

exports.default = FICBaseButton;


FICBaseButton.propTypes = {
  className: _propTypes2.default.string,
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.object,
  isDisabled: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  renderButton: _propTypes2.default.func
};

FICBaseButton.defaultProps = {
  className: undefined,
  href: undefined,
  target: undefined,
  onClick: undefined,
  style: undefined,
  isDisabled: false,
  isLoading: false,
  renderButton: undefined
};

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n'], ['\n  height: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  box-sizing: border-box;\n  vertical-align: middle;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 4px;\n  width: ', ';\n  height: ', ';\n  line-height: ', ';\n  cursor: pointer;\n  text-align: center;\n  color:', ';\n  ', '\n  ', '\n'], ['\n  display: inline-block;\n  box-sizing: border-box;\n  vertical-align: middle;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 4px;\n  width: ', ';\n  height: ', ';\n  line-height: ', ';\n  cursor: pointer;\n  text-align: center;\n  color:', ';\n  ', '\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    background-color: ', ';\n  '], ['\n    background-color: ', ';\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    border-color: ', ';\n    cursor:not-allowed;\n    ', '\n  '], ['\n    background-color: ', ';\n    border-color: ', ';\n    cursor:not-allowed;\n    ', '\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: top;\n  color: ', ';\n  font-size: ', ';\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  margin-left: 8px;\n  cursor: pointer;\n  ', '\n'], ['\n  display: inline-block;\n  vertical-align: top;\n  color: ', ';\n  font-size: ', ';\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  margin-left: 8px;\n  cursor: pointer;\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    color: ', ';\n    cursor:not-allowed;\n'], ['\n    color: ', ';\n    cursor:not-allowed;\n']),
    _templateObject8 = _taggedTemplateLiteral([''], ['']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function FICCheckboxImpl(props) {
  return _react2.default.createElement(
    Container,
    { size: props.size, style: props.style },
    _react2.default.createElement(
      'span',
      { onClick: function onClick() {
          return onChange(props);
        } },
      props.renderCheckbox ? props.renderCheckbox(props) : renderCheckbox(props)
    )
  );
}

function renderCheckbox(props) {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      Checkbox,
      {
        isChecked: props.value,
        isDisabled: props.isDisabled,
        size: props.size
      },
      props.value && _react2.default.createElement(_FICIcon2.default, { name: props.isIndeterminate ? 'minus' : 'check', size: 12 })
    ),
    _react2.default.createElement(
      Label,
      {
        size: props.size,
        isDisabled: props.isDisabled
      },
      props.text
    )
  );
}

function onChange(props) {
  if (props.isDisabled || !props.onChange) {
    return;
  }

  props.onChange(!props.value);
}

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'FICCheckbox__Container',
  componentId: 'spdwrr-0'
})(_templateObject, function (props) {
  return props.size === 'large' ? '20px' : '16px';
});

var Checkbox = _styledComponents2.default.span.withConfig({
  displayName: 'FICCheckbox__Checkbox',
  componentId: 'spdwrr-1'
})(_templateObject2, _FICColors2.default.white, function (props) {
  return props.isChecked ? _FICColors2.default.blue : _FICColors2.default.borderColor;
}, function (props) {
  return props.size === 'large' ? '20px' : '16px';
}, function (props) {
  return props.size === 'large' ? '20px' : '16px';
}, function (props) {
  return props.size === 'large' ? '18px' : '14px';
}, _FICColors2.default.white, function (props) {
  return props.isChecked && (0, _styledComponents.css)(_templateObject3, _FICColors2.default.blue);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject4, _FICColors2.default.inputDisabled, _FICColors2.default.inputDisabled, function (props) {
    return props.isChecked && (0, _styledComponents.css)(_templateObject5, _FICColors2.default.button.primary.blue.disabled, _FICColors2.default.button.primary.blue.disabled);
  });
});

var Label = _styledComponents2.default.span.withConfig({
  displayName: 'FICCheckbox__Label',
  componentId: 'spdwrr-2'
})(_templateObject6, _FICColors2.default.black, function (props) {
  return props.size === 'large' ? '16px' : '14px';
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject7, _FICColors2.default.inputDisabledText);
});

var FICCheckbox = (0, _styledComponents2.default)(FICCheckboxImpl)(_templateObject8);

FICCheckbox.propTypes = {
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  value: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  isDisabled: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['medium', 'large']),
  renderCheckbox: _propTypes2.default.func,
  isIndeterminate: _propTypes2.default.bool,
  styled: _propTypes2.default.object
};

FICCheckbox.defaultProps = {
  text: '',
  value: false,
  onChange: null,
  isDisabled: false,
  size: 'medium',
  renderCheckbox: undefined,
  isIndeterminate: false,
  style: undefined
};

exports.default = FICCheckbox;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: ', ';\n  width: 100%;\n  max-width: 968px;\n  text-align: center;\n  @media (max-width: 425px) {\n    margin-top: 0;\n    table{\n      table-layout: fixed;\n      ul{\n        margin: 0 15px 15px 0;\n        list-style-position: inside;\n        overflow: scroll;\n        li{\n          text-align: left!important;\n          margin-bottom: 10px;  \n        }\n      }\n    }\n  }\n'], ['\n  margin: ', ';\n  width: 100%;\n  max-width: 968px;\n  text-align: center;\n  @media (max-width: 425px) {\n    margin-top: 0;\n    table{\n      table-layout: fixed;\n      ul{\n        margin: 0 15px 15px 0;\n        list-style-position: inside;\n        overflow: scroll;\n        li{\n          text-align: left!important;\n          margin-bottom: 10px;  \n        }\n      }\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 8px;\n  width: 8px;\n  background-color: #0294D3;\n  display: block;\n  border-radius: 100%;\n  position: absolute;\n  top:10px;\n  transition: height 100ms ease-out;\n'], ['\n  height: 8px;\n  width: 8px;\n  background-color: #0294D3;\n  display: block;\n  border-radius: 100%;\n  position: absolute;\n  top:10px;\n  transition: height 100ms ease-out;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  line-height: 24px;\n  display: block;\n  cursor: pointer;\n  position: relative;\n  &:not(:last-child){\n    a{padding-bottom: 16px}\n  }\n  &.active{\n    a{\n      color: #0294D3;\n      font-weight: bold;\n    }\n  }\n  a{\n    display: inline-block;\n    color: #333;\n    margin-left: 20px;\n    vert-align: top;\n    position: relative;\n    max-width: 244px;\n    &:hover{text-decoration: none}\n  }\n  ', '\n'], ['\n  font-size: 16px;\n  line-height: 24px;\n  display: block;\n  cursor: pointer;\n  position: relative;\n  &:not(:last-child){\n    a{padding-bottom: 16px}\n  }\n  &.active{\n    a{\n      color: #0294D3;\n      font-weight: bold;\n    }\n  }\n  a{\n    display: inline-block;\n    color: #333;\n    margin-left: 20px;\n    vert-align: top;\n    position: relative;\n    max-width: 244px;\n    &:hover{text-decoration: none}\n  }\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    .point{\n      height: 115%;\n      border-radius: 4px;\n    }\n  '], ['\n    .point{\n      height: 115%;\n      border-radius: 4px;\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 296px;\n  border-radius: 4px;\n  background-color: #F2F4F8;\n  padding: 16px;\n  box-sizing: border-box;\n  vertical-align: top;\n  margin-right: 24px;\n  display: inline-block;\n  text-align: left;\n  transition:visibility 0.1s linear,opacity 0.1s linear;\n  visibility: visible;\n  opacity: 1;\n  @media (max-width: 425px) {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 24px;\n  }\n  ', '\n  ', '\n  h2{\n    color: #333333;\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 40px;\n  }\n'], ['\n  width: 296px;\n  border-radius: 4px;\n  background-color: #F2F4F8;\n  padding: 16px;\n  box-sizing: border-box;\n  vertical-align: top;\n  margin-right: 24px;\n  display: inline-block;\n  text-align: left;\n  transition:visibility 0.1s linear,opacity 0.1s linear;\n  visibility: visible;\n  opacity: 1;\n  @media (max-width: 425px) {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 24px;\n  }\n  ', '\n  ', '\n  h2{\n    color: #333333;\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 40px;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    position: absolute;\n    top:', 'px;\n  '], ['\n    position: absolute;\n    top:', 'px;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    opacity: 0;\n    visibility: hidden;\n  '], ['\n    opacity: 0;\n    visibility: hidden;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: inline-block;  \n  max-width: ', ';\n  padding-left: 16px;\n  padding-right: 16px;\n  color: ', ';\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: top;\n  text-align: left;\n  ', '\n  li{line-height: 24px;}\n  p{margin: 0 0 10px;}\n  img{\n    border: 1px solid rgba(51,51,51,0.24);\n    padding:10px;\n    box-sizing: border-box;\n    height:auto!important;\n    border-radius: 4px;\n  }\n  h2,h3{line-height: 40px}\n  h3{margin-bottom: 16px}\n'], ['\n  display: inline-block;  \n  max-width: ', ';\n  padding-left: 16px;\n  padding-right: 16px;\n  color: ', ';\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: top;\n  text-align: left;\n  ', '\n  li{line-height: 24px;}\n  p{margin: 0 0 10px;}\n  img{\n    border: 1px solid rgba(51,51,51,0.24);\n    padding:10px;\n    box-sizing: border-box;\n    height:auto!important;\n    border-radius: 4px;\n  }\n  h2,h3{line-height: 40px}\n  h3{margin-bottom: 16px}\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    margin-left: 320px;\n  '], ['\n    margin-left: 320px;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n  border-top:1px solid rgba(51,51,51,0.08);\n  padding-top: 24px;\n  margin-top: 24px;\n  h3{\n    line-height: 40px;\n    margin-bottom: 16px;\n    font-size: 18px;\n  }\n  ul{\n    padding: 0;\n    -webkit-column-count: 2; /* Chrome, Safari, Opera */\n    -moz-column-count: 2; /* Firefox */\n    column-count: 2;\n    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */\n    -moz-column-gap: 40px; /* Firefox */\n    column-gap: 40px;\n    margin-left: 10px;\n    li{\n      color: ', ';\n      margin-bottom: 20px;\n      margin-left:10px;\n      font-size: 16px;\n      width: 100%;\n      -webkit-column-break-inside: avoid;\n      page-break-inside: avoid;\n      break-inside: avoid;\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n'], ['\n  border-top:1px solid rgba(51,51,51,0.08);\n  padding-top: 24px;\n  margin-top: 24px;\n  h3{\n    line-height: 40px;\n    margin-bottom: 16px;\n    font-size: 18px;\n  }\n  ul{\n    padding: 0;\n    -webkit-column-count: 2; /* Chrome, Safari, Opera */\n    -moz-column-count: 2; /* Firefox */\n    column-count: 2;\n    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */\n    -moz-column-gap: 40px; /* Firefox */\n    column-gap: 40px;\n    margin-left: 10px;\n    li{\n      color: ', ';\n      margin-bottom: 20px;\n      margin-left:10px;\n      font-size: 16px;\n      width: 100%;\n      -webkit-column-break-inside: avoid;\n      page-break-inside: avoid;\n      break-inside: avoid;\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  height:160px;  \n  width: 100%;\n  margin: 0 auto;\n  max-width: 940px;\n  svg{width: 300px}\n  ', '\n'], ['\n  height:160px;  \n  width: 100%;\n  margin: 0 auto;\n  max-width: 940px;\n  svg{width: 300px}\n  ', '\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    margin: 15px auto;\n  '], ['\n    margin: 15px auto;\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n  padding: 12px;\n  border: 1px solid rgba(51,51,51,0.24);\n  border-radius: 4px;\n  margin: 24px auto;\n  .fa, .faicon{\n    padding-right: 12px;\n    font-size: 23px;\n    display: table-cell;\n    vertical-align: middle;\n  }\n  &.hint{\n    border-color: #0078CD;\n    background-color: rgba(0,120,205,0.08);\n    .fa, .faicon{color:#0078CD}\n  }\n  &.note{\n    border-color: #23C499;\n    background-color: rgba(35,196,153,0.08);\n    .fa, .faicon{color:#23C499}\n  }\n  &.warning{\n    border-color: #FFBE2D;\n    background-color: rgba(255,190,45,0.08);\n    .fa, .faicon{color:#FFBE2D}\n  }\n  .text{\n    display: table-cell;\n    vertical-align: top;\n    width: calc(100% - 35px);\n  }\n  &.section{\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid rgba(51,51,51,0.24);\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 30px;\n    padding: 24px 0 5px 0;\n    margin-top: 0!important;\n    box-shadow: none;\n    &:first-child{padding-top: 0;}\n    &:not(:first-child){margin-top: 32px}\n    .fa, .faicon{display: none}\n  }\n'], ['\n  padding: 12px;\n  border: 1px solid rgba(51,51,51,0.24);\n  border-radius: 4px;\n  margin: 24px auto;\n  .fa, .faicon{\n    padding-right: 12px;\n    font-size: 23px;\n    display: table-cell;\n    vertical-align: middle;\n  }\n  &.hint{\n    border-color: #0078CD;\n    background-color: rgba(0,120,205,0.08);\n    .fa, .faicon{color:#0078CD}\n  }\n  &.note{\n    border-color: #23C499;\n    background-color: rgba(35,196,153,0.08);\n    .fa, .faicon{color:#23C499}\n  }\n  &.warning{\n    border-color: #FFBE2D;\n    background-color: rgba(255,190,45,0.08);\n    .fa, .faicon{color:#FFBE2D}\n  }\n  .text{\n    display: table-cell;\n    vertical-align: top;\n    width: calc(100% - 35px);\n  }\n  &.section{\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid rgba(51,51,51,0.24);\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 30px;\n    padding: 24px 0 5px 0;\n    margin-top: 0!important;\n    box-shadow: none;\n    &:first-child{padding-top: 0;}\n    &:not(:first-child){margin-top: 32px}\n    .fa, .faicon{display: none}\n  }\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  padding: 24px 0 0;\n  border-top: 1px solid rgba(51,51,51,0.08);\n  h3{\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 32px;\n    text-align: center;\n    margin: 0;\n    color: ', ';\n  }\n  .buttons{\n    text-align: center;\n    margin: 24px auto;\n    .fic-text-button {\n      height: 40px!important;\n      max-height: unset!important;\n      padding-top: 10px!important;\n      box-sizing: border-box;\n      border: 2px solid #0294D3;\n      font-size: 16px;\n      text-transform: unset;\n      font-weight: normal;\n      width: 160px;\n      @media all and (-ms-high-contrast: none) {\n        & { padding:5px 14px 14px!important; }  \n     }\n      &.yes{\n        background-color: ', ';\n        color:#0294D3;\n        margin-right: 12px;\n        @media (max-width: 425px) {\n          width: 152px;\n          margin-right: 16px;\n        }\n        @media (max-width: 350px) {\n          margin-right: 0;\n          margin-bottom: 16px;\n        }\n        &:hover{\n          background-color: #0294D3;\n          color: ', ';\n          .fa, .faicon{color: ', ';}\n        }\n      }\n      &.no{\n        background-color: #0294D3;\n        border-color: #0294D3;\n        margin-left: 12px;\n        @media (max-width: 425px) {\n          width: 152px;\n          margin-left: 0;\n        }\n        &:hover{\n          background-color: ', ';\n          color:#0294D3;\n        }\n      }\n    }\n  }\n  .comment{\n    padding-bottom: 38px;\n    .fic-input-text-input{\n      width: 100%;\n      height: 140px!important;\n      margin-bottom: 16px;   \n      box-sizing: border-box; \n    }\n    .fic-text-button{\n      height: 40px!important;\n      max-height: unset!important;\n      padding-top: 10px!important;\n      box-sizing: border-box;\n      font-weight: normal;\n      font-size: 16px;\n      text-transform: unset;     \n      border: 2px solid #F2F4F8;\n      background-color: #F2F4F8;\n      color: rgba(51,51,51,0.16);\n      cursor: auto;\n      float: right;\n      ', ' \n    }\n  }\n'], ['\n  padding: 24px 0 0;\n  border-top: 1px solid rgba(51,51,51,0.08);\n  h3{\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 32px;\n    text-align: center;\n    margin: 0;\n    color: ', ';\n  }\n  .buttons{\n    text-align: center;\n    margin: 24px auto;\n    .fic-text-button {\n      height: 40px!important;\n      max-height: unset!important;\n      padding-top: 10px!important;\n      box-sizing: border-box;\n      border: 2px solid #0294D3;\n      font-size: 16px;\n      text-transform: unset;\n      font-weight: normal;\n      width: 160px;\n      @media all and (-ms-high-contrast: none) {\n        & { padding:5px 14px 14px!important; }  \n     }\n      &.yes{\n        background-color: ', ';\n        color:#0294D3;\n        margin-right: 12px;\n        @media (max-width: 425px) {\n          width: 152px;\n          margin-right: 16px;\n        }\n        @media (max-width: 350px) {\n          margin-right: 0;\n          margin-bottom: 16px;\n        }\n        &:hover{\n          background-color: #0294D3;\n          color: ', ';\n          .fa, .faicon{color: ', ';}\n        }\n      }\n      &.no{\n        background-color: #0294D3;\n        border-color: #0294D3;\n        margin-left: 12px;\n        @media (max-width: 425px) {\n          width: 152px;\n          margin-left: 0;\n        }\n        &:hover{\n          background-color: ', ';\n          color:#0294D3;\n        }\n      }\n    }\n  }\n  .comment{\n    padding-bottom: 38px;\n    .fic-input-text-input{\n      width: 100%;\n      height: 140px!important;\n      margin-bottom: 16px;   \n      box-sizing: border-box; \n    }\n    .fic-text-button{\n      height: 40px!important;\n      max-height: unset!important;\n      padding-top: 10px!important;\n      box-sizing: border-box;\n      font-weight: normal;\n      font-size: 16px;\n      text-transform: unset;     \n      border: 2px solid #F2F4F8;\n      background-color: #F2F4F8;\n      color: rgba(51,51,51,0.16);\n      cursor: auto;\n      float: right;\n      ', ' \n    }\n  }\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n        background-color: #0294D3;\n        color: ', ';\n        border: 2px solid #0294D3;\n        cursor: pointer;\n        &:hover{\n          background-color: ', ';\n          color:#0294D3;\n        }\n      '], ['\n        background-color: #0294D3;\n        color: ', ';\n        border: 2px solid #0294D3;\n        cursor: pointer;\n        &:hover{\n          background-color: ', ';\n          color:#0294D3;\n        }\n      ']),
    _templateObject16 = _taggedTemplateLiteral(['\n  color: rgba(51,51,51,0.72);\n  font-size: 12px;\n  line-height: 16px;\n  float: left;\n'], ['\n  color: rgba(51,51,51,0.72);\n  font-size: 12px;\n  line-height: 16px;\n  float: left;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  text-align: right;\n  margin-bottom: 10px;\n  a{\n    margin-left: 10px;\n    position: relative;\n    top:-5px;\n  }\n  a, a:hover, a:focus {\n    text-decoration: none;\n  }\n  .faicon{\n    display: inline-block;\n    color:#555!important;\n    font-size:22px;\n    cursor: pointer;\n    &:hover{color:', '!important;}\n  }\n'], ['\n  text-align: right;\n  margin-bottom: 10px;\n  a{\n    margin-left: 10px;\n    position: relative;\n    top:-5px;\n  }\n  a, a:hover, a:focus {\n    text-decoration: none;\n  }\n  .faicon{\n    display: inline-block;\n    color:#555!important;\n    font-size:22px;\n    cursor: pointer;\n    &:hover{color:', '!important;}\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _customComponents = __webpack_require__(298);

var _htmlToReact = __webpack_require__(181);

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _BreadCrumbs = __webpack_require__(407);

var _BreadCrumbs2 = _interopRequireDefault(_BreadCrumbs);

var _SubArticle = __webpack_require__(609);

var _reactContentLoader = __webpack_require__(334);

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _FAIcon = __webpack_require__(6);

var _reactScroll = __webpack_require__(989);

var _FICTextButton = __webpack_require__(21);

var _FICTextButton2 = _interopRequireDefault(_FICTextButton);

var _FICInputText = __webpack_require__(29);

var _FICInputText2 = _interopRequireDefault(_FICInputText);

var _FICActionButton = __webpack_require__(96);

var _FICActionButton2 = _interopRequireDefault(_FICActionButton);

var _FICTooltip = __webpack_require__(18);

var _FICTooltip2 = _interopRequireDefault(_FICTooltip);

var _lodash = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var sidebarOffsetTop = !localStorage.getItem('helpFacebookBannerIsVisible') ? 50 : 40;
var helpHeaderHeight = !localStorage.getItem('helpFacebookBannerIsVisible') ? 130 : 90;
var maxBottomOffset = 500;
var breadCrumbsHeight = 64;

var Article = function (_Component) {
  _inherits(Article, _Component);

  function Article(props) {
    _classCallCheck(this, Article);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateViewporWidth = function () {
      _this.setState({ viewportWidth: window.innerWidth });
    };

    _this.listenScrollEvent = function (e) {
      if (_this.state.viewportWidth <= 768) {
        if (_this.state.fixedSideBar) {
          _this.setState({ fixedSideBar: false });
        }
        return;
      }

      if (_.size(_this.sections) === 0) {
        return;
      }

      if (_this.container) {
        var containerNode = ReactDOM.findDOMNode(_this.container);

        if (containerNode) {
          var offset = containerNode.offsetTop + breadCrumbsHeight + _this.helpHeaderDetailed.offsetHeight - (_this.props.isExternal ? helpHeaderHeight : sidebarOffsetTop);
          var offsetBottom = _this.articleContainer.getBoundingClientRect().bottom;

          if (_this.parent.scrollTop > offset && !_this.state.fixedSideBar) {
            _this.setState({ fixedSideBar: true });
          } else if (_this.parent.scrollTop < offset && _this.state.fixedSideBar) {
            _this.setState({ fixedSideBar: false });
          }
          if (offsetBottom <= maxBottomOffset && !_this.state.fixedSideBarMaxBottom) {
            _this.setState({ fixedSideBarMaxBottom: true });
          } else if (offsetBottom > maxBottomOffset && _this.state.fixedSideBarMaxBottom) {
            _this.setState({ fixedSideBarMaxBottom: false });
          }
        }
      }

      var current = 0;
      _.forEach(_this.sections, function (section, sectionNumber) {
        if (section.node && section.node.offsetTop !== undefined) {
          section.top = section.node.offsetTop;
        }

        if (section.top < _this.parent.scrollTop + 200) {
          current = sectionNumber;
        }
      });

      if (current !== _this.state.currentSection) {
        _this.setState({ currentSection: current });
      }
    };

    _this.loadData = function (searchKey) {
      if (searchKey === undefined) {
        searchKey = _this.props.searchKey;
      }
      _FICRestV2.default.get({
        request: 'help/article/' + searchKey,
        queryData: { realm: _this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
        onSuccess: function onSuccess(response) {
          _this.setState({
            article: response.data,
            relatedArticles: response.related_articles,
            tree: response.tree,
            chat: response.chat,
            sidebar: response.sidebar
          });
        },
        onError: function onError() {
          _this.setState(_extends({}, _this.initialState, { elementNotFound: true }));
        }
      });
    };

    _this.getBreadCrumbs = function () {
      var breadCrumbPaths = [];
      var c = 3;
      while (c >= 1) {
        if (_this.state.tree && _this.state.tree['section' + c + '_permalink']) {
          (function () {
            var permalink = _this.state.tree['section' + c + '_permalink'];
            breadCrumbPaths.push({ text: _this.state.tree['section' + c + '_title'], onClick: function onClick() {
                return _this.props.changeView(permalink, 'sezione');
              } });
          })();
        }
        c--;
      }

      return breadCrumbPaths;
    };

    _this.handleChange = function (key, comment) {
      _this.setState({ feedbackComment: comment, counter: comment.length });
    };

    _this.saveFeedback = function (feedback) {
      _FICRestV2.default.post({
        request: 'help/feedback',
        postData: {
          data: {
            article_id: _this.state.article.id,
            feedback: feedback || _this.state.feedback,
            feedback_comment: _this.state.feedbackComment,
            feedback_id: _this.state.feedbackId
          }
        },
        onSuccess: function onSuccess(response) {
          _this.setState({
            feedback: feedback || _this.state.feedback,
            feedbackId: response.data.id,
            feedbackCompleted: response.data.commented
          });
        },
        onError: function onError() {
          // Do not show alert
          _this.setState({
            feedback: 'yes'
          });
        }
      });
    };

    _this.renderSideBar = function () {
      return _react2.default.createElement(
        SideBar,
        {
          fixedSideBar: _this.state.fixedSideBar,
          fixedSideBarMaxBottom: _this.state.fixedSideBarMaxBottom,
          isExternal: _this.props.isExternal
        },
        _react2.default.createElement(
          'h2',
          null,
          'In questa guida'
        ),
        _this.state.sidebar.map(function (link, idx) {
          return _react2.default.createElement(
            SectionLink,
            {
              key: idx,
              to: link.id,
              smooth: true,
              offset: -100,
              containerId: 'articleContainer',
              className: parseInt(_this.state.currentSection) === idx ? 'active' : undefined,
              isActive: _this.state.currentSection > idx ? true : undefined
            },
            link.title
          );
        })
      );
    };

    _this.renderFeedback = function () {
      return _react2.default.createElement(
        Feedback,
        { valid: _this.state.feedbackComment },
        _react2.default.createElement(
          'h3',
          null,
          'L\'articolo \xE8 stato utile?'
        ),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _this.state.feedback === undefined ? _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(_FICTextButton2.default, { onClick: function onClick() {
                return _this.saveFeedback('yes');
              }, iconLeft: ['fal', 'thumbs-up'], text: 'Si, Grazie!', className: 'yes' }),
            _react2.default.createElement(_FICTextButton2.default, { onClick: function onClick() {
                return _this.saveFeedback('no');
              }, iconLeft: ['fal', 'thumbs-down'], text: 'Non \xE8 servito', className: 'no' })
          ) : _this.state.feedback === 'yes' || _this.state.feedbackCompleted ? _react2.default.createElement(
            'p',
            null,
            'Grazie per aver lasciato il tuo feedback!'
          ) : _react2.default.createElement(
            'p',
            null,
            'Ci dispiace di non esserti stati di aiuto.',
            _react2.default.createElement('br', null),
            'Se vuoi puoi lasciare un commento per dirci come migliorare.'
          )
        ),
        _this.state.feedback === 'no' && !_this.state.feedbackCompleted && _react2.default.createElement(
          'div',
          { className: 'comment' },
          _react2.default.createElement(_FICInputText2.default, { type: 'multiline', name: 'feedbackComment', maxLength: 600, onChange: _this.handleChange, value: _this.state.feedbackComment }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              Counter,
              null,
              _this.state.counter ? _this.state.counter : '0',
              '/600'
            ),
            _react2.default.createElement(_FICTextButton2.default, { text: 'Invia feedback', onClick: _this.state.feedbackComment ? _this.saveFeedback : null })
          )
        )
      );
    };

    _this.renderRelatedArticles = function () {
      return _react2.default.createElement(
        RelatedArticles,
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Articoli correlati'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _this.state.relatedArticles.map(function (article, idx) {
            return _react2.default.createElement(
              'li',
              { key: idx, onClick: function onClick() {
                  return _this.props.changeView(article.permalink, 'articolo');
                } },
              _react2.default.createElement(
                'span',
                null,
                article.title
              )
            );
          })
        )
      );
    };

    _this.print = function () {
      var mywindow = window.open('', 'PRINT', 'height=800,width=1200');

      mywindow.document.write('<html><head><title>' + _this.state.article.title + '</title>');
      mywindow.document.write('<link href=\'https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,700italic,800italic,400,300,600,700,800\' rel=\'stylesheet\' type=\'text/css\' />');
      mywindow.document.write('<link rel="stylesheet" type="text/css" href="/assets/libs/font-awesome-4.7.0/css/font-awesome.min.css?" media="print, screen" />');
      mywindow.document.write('<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.11.2/css/all.css" integrity="sha384-zrnmn8R8KkWl12rAZFt4yKjxplaDaT7/EUkKm7AovijfrQItFWR7O/JJn4DAa/gx" crossorigin="anonymous">');
      mywindow.document.write('<link rel="stylesheet" type="text/css" href="/css/help-print-article.css?r=4" media="print, screen" />');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<h1>' + _this.state.article.title + '</h1>');
      mywindow.document.write(document.getElementById('printSection-' + _this.props.searchKey).innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10

      setTimeout(function () {
        mywindow.print();
        mywindow.close();
      }, 500);

      return true;
    };

    _this.renderActions = function () {
      return _react2.default.createElement(
        Actions,
        null,
        _this.state.viewportWidth > 768 && _react2.default.createElement(
          _FICTooltip2.default,
          { placement: 'top', text: 'Stampa', delayShow: 200 },
          _react2.default.createElement(_FAIcon.FALIcon, { name: 'print', onClick: _this.print })
        ),
        !_this.props.subArticle && !_this.props.isExternal && _react2.default.createElement(
          _FICTooltip2.default,
          { placement: 'top', text: 'Apri in nuova scheda', delayShow: 200 },
          _react2.default.createElement(_FICActionButton2.default, { icon: ['fal', 'external-link'], href: '/help/articolo/' + _this.state.article.permalink, target: '_blank' })
        )
      );
    };

    _this.state = _this.initialState;
    _this.sections = {};
    return _this;
  }

  Article.prototype.componentDidMount = function componentDidMount() {
    this.updateViewporWidth();
    this.loadData();
    this.parent = ReactDOM.findDOMNode(this);
    this.parent.addEventListener('scroll', this.listenScrollEvent);
    window.addEventListener('resize', (0, _lodash.debounce)(this.updateViewporWidth, 100));
    if (this.props.isExternal) {
      var mainContainer = this.parent.parentNode.parentNode.parentNode;
      mainContainer.scrollTop = 0;
    }
  };

  Article.prototype.componentDidUpdate = function componentDidUpdate(prevProp) {
    if (this.props.searchKey !== prevProp.searchKey) {
      this.sections = {};
      this.loadData(this.props.searchKey);

      var node = ReactDOM.findDOMNode(this);
      var mainContainer = node.parentNode.parentNode.parentNode;
      mainContainer.scrollTop = 0;
    }
  };

  Article.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', (0, _lodash.debounce)(this.updateViewporWidth, 100));
  };

  Article.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;
    var state = this.state;
    var htmlToReactParser = new _htmlToReact.Parser();
    var processNodeDefinitions = new _htmlToReact2.default.ProcessNodeDefinitions(_react2.default);
    var processingInstructions = [{
      shouldProcessNode: function shouldProcessNode(node) {
        return node.name === 'reactelement';
      },
      processNode: function processNode(node, children) {
        if (node.attribs.type === 'article') {
          return _react2.default.createElement(_SubArticle.SubArticle, {
            key: node.attribs.key,
            text: node.attribs.title,
            permalink: node.attribs.permalink,
            className: 'subArticle',
            realm: _this2.props.realm,
            changeView: props.changeView,
            parentsArticle: _this2.state.parentsArticle,
            isInternal: _this2.props.isInternal
          });
        } else {
          return _react2.default.createElement(CustomBlock, {
            key: node.attribs.key,
            type: node.attribs.type,
            text: node.attribs.text,
            color: node.attribs.color ? node.attribs.color : undefined,
            id: node.attribs.type === 'section' ? node.attribs.id : undefined,
            className: 'customBlock',
            ref: function ref(block) {
              if (block && node.attribs.type === 'section') {
                var sectionNode = ReactDOM.findDOMNode(block);
                _this2.sections[parseInt(node.attribs.section_number)] = { node: sectionNode, top: null };
              }
            }
          });
        }
      }
    }, {
      // Anything else
      shouldProcessNode: function shouldProcessNode(node) {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode
    }];

    return _react2.default.createElement(
      _customComponents.MainContainer,
      {
        className: props.className,
        id: 'articleContainer',
        isExternal: props.isExternal,
        ref: function ref(node) {
          return _this2.container = node;
        }
      },
      !props.subArticle && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_customComponents.HelpHeaderDetailed, {
          closeIcon: !this.props.embedded,
          onClickClose: props.onClickClose,
          onClick: function onClick() {
            return props.changeView(state.article.parent_section, 'sezione');
          },
          title: state.article.title,
          isExternal: props.isExternal,
          realm: this.props.realm,
          ref: function ref(headerRef) {
            return _this2.helpHeaderDetailed = headerRef;
          },
          embedded: this.props.embedded
        }),
        _react2.default.createElement(_BreadCrumbs2.default, {
          onSelect: props.changeView,
          paths: this.getBreadCrumbs(),
          className: 'breadCrumbs',
          realm: this.props.realm,
          embedded: this.props.embedded
        })
      ),
      !state.article ? this.state.elementNotFound ? _react2.default.createElement(_customComponents.ElementNotFound, { type: 'article', onClick: this.props.changeView }) : _react2.default.createElement(ArticleLoading, { className: 'articleContainer' }) : _react2.default.createElement(
        ArticleContainer,
        {
          className: 'articleContainer ' + (this.props.embedded ? 'embeddedArticle' : ''),
          subArticle: props.subArticle,
          ref: function ref(_ref) {
            return _this2.articleContainer = _ref;
          }
        },
        !props.subArticle && state.sidebar && this.renderSideBar(),
        _react2.default.createElement(
          ArticleContent,
          { fixedSideBar: state.fixedSideBar, embedded: this.props.embedded },
          this.renderActions(),
          _react2.default.createElement(
            'div',
            { id: 'printSection-' + this.props.searchKey },
            htmlToReactParser.parseWithInstructions(state.article.content, function () {
              return true;
            }, processingInstructions)
          ),
          !props.subArticle && !state.article.feedback && this.renderFeedback(),
          state.relatedArticles.length > 0 && !props.subArticle && this.renderRelatedArticles()
        )
      ),
      state.chat.open && reactGlobalParams.chat.help_visible && !props.subArticle && !this.state.elementNotFound && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_customComponents.Separator, null),
        _react2.default.createElement(_customComponents.Chat, { warning: state.chat.warning, type: 'article', id: state.article.id }),
        _react2.default.createElement(_customComponents.PrivacyMessage, { isFic: this.props.realm === 'fic' })
      )
    );
  };

  _createClass(Article, [{
    key: 'initialState',
    get: function get() {
      return {
        article: false,
        relatedArticles: [],
        chat: [],
        tree: false,
        feedbackText: '',
        fixedSideBar: false,
        fixedSideBarMaxBottom: false,
        currentSection: 0,
        parentsArticle: this.props.parentsArticle || [],
        elementNotFound: false,
        viewportWidth: 0
      };
    }
  }]);

  return Article;
}(_react.Component);

exports.default = Article;


var ArticleContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Article__ArticleContainer',
  componentId: 'z814zo-0'
})(_templateObject, function (props) {
  return props.subArticle ? undefined : '40px auto';
});

var LinkPoint = _styledComponents2.default.span.withConfig({
  displayName: 'Article__LinkPoint',
  componentId: 'z814zo-1'
})(_templateObject2);

var SectionLinkImpl = function SectionLinkImpl(_ref2) {
  var className = _ref2.className,
      isActive = _ref2.isActive,
      props = _objectWithoutProperties(_ref2, ['className', 'isActive']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(LinkPoint, { className: 'point' }),
    _react2.default.createElement(_reactScroll.Link, props)
  );
};
var SectionLink = (0, _styledComponents2.default)(SectionLinkImpl)(_templateObject3, function (props) {
  return props.isActive && (0, _styledComponents.css)(_templateObject4);
});

var SideBarImpl = function SideBarImpl(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    props.children
  );
};
var SideBar = (0, _styledComponents2.default)(SideBarImpl)(_templateObject5, function (props) {
  return props.fixedSideBar && (0, _styledComponents.css)(_templateObject6, sidebarOffsetTop + (props.isExternal ? helpHeaderHeight : 0));
}, function (props) {
  return props.fixedSideBarMaxBottom && (0, _styledComponents.css)(_templateObject7);
});

var ArticleContent = _styledComponents2.default.div.withConfig({
  displayName: 'Article__ArticleContent',
  componentId: 'z814zo-2'
})(_templateObject8, function (props) {
  return props.embedded ? '448px' : '616px';
}, _FICColors2.default.textDefault, function (props) {
  return props.fixedSideBar && (0, _styledComponents.css)(_templateObject9);
});

var RelatedArticlesImpl = function RelatedArticlesImpl(_ref4) {
  var className = _ref4.className,
      props = _objectWithoutProperties(_ref4, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    props.children
  );
};
var RelatedArticles = (0, _styledComponents2.default)(RelatedArticlesImpl)(_templateObject10, _FICColors2.default.textDefault, _FICColors2.default.defaultBlue);

var ArticleLoadingSvg = function ArticleLoadingSvg(_ref5) {
  var className = _ref5.className,
      props = _objectWithoutProperties(_ref5, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className + ' articleLoading' },
    _react2.default.createElement(
      _reactContentLoader2.default,
      {
        height: 160,
        width: 300,
        speed: 2,
        primaryColor: '#f3f3f3',
        secondaryColor: '#ecebeb',
        className: props.className
      },
      _react2.default.createElement('rect', { x: '5', y: '2', rx: '3', ry: '3', width: '70', height: '10' }),
      _react2.default.createElement('rect', { x: '85', y: '2', rx: '3', ry: '3', width: '100', height: '10' }),
      _react2.default.createElement('rect', { x: '195', y: '2', rx: '3', ry: '3', width: '10', height: '10' }),
      _react2.default.createElement('rect', { x: '20', y: '22', rx: '3', ry: '3', width: '130', height: '10' }),
      _react2.default.createElement('rect', { x: '160', y: '22', rx: '3', ry: '3', width: '130', height: '10' }),
      _react2.default.createElement('rect', { x: '20', y: '42', rx: '3', ry: '3', width: '90', height: '10' }),
      _react2.default.createElement('rect', { x: '120', y: '42', rx: '3', ry: '3', width: '60', height: '10' }),
      _react2.default.createElement('rect', { x: '190', y: '42', rx: '3', ry: '3', width: '60', height: '10' }),
      _react2.default.createElement('rect', { x: '5', y: '102', rx: '3', ry: '3', width: '30', height: '10' }),
      _react2.default.createElement('rect', { x: '19', y: '81', rx: '3', ry: '3', width: '90', height: '10' }),
      _react2.default.createElement('rect', { x: '119', y: '81', rx: '3', ry: '3', width: '60', height: '10' }),
      _react2.default.createElement('rect', { x: '189', y: '81', rx: '3', ry: '3', width: '60', height: '10' }),
      _react2.default.createElement('rect', { x: '20', y: '62', rx: '3', ry: '3', width: '130', height: '10' }),
      _react2.default.createElement('rect', { x: '173', y: '60', rx: '3', ry: '3', width: '130', height: '10' })
    )
  );
};
var ArticleLoading = (0, _styledComponents2.default)(ArticleLoadingSvg)(_templateObject11, function (props) {
  return !props.isExternal && (0, _styledComponents.css)(_templateObject12);
});

function customBlockIcon(type) {
  var icon = void 0;
  switch (type) {
    case 'hint':
      icon = 'magic';
      break;
    case 'note':
      icon = 'pencil';
      break;
    case 'warning':
      icon = 'exclamation-triangle';
      break;
  }
  if (icon !== '') {
    return _react2.default.createElement(_FAIcon.FALIcon, { name: icon });
  }
}

var CustomBlockImpl = function (_Component2) {
  _inherits(CustomBlockImpl, _Component2);

  function CustomBlockImpl() {
    _classCallCheck(this, CustomBlockImpl);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  CustomBlockImpl.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['className']);

    var htmlToReactParser = new _htmlToReact.Parser();

    return _react2.default.createElement(
      'div',
      { className: className + ' ' + props.type, id: props.id ? props.id : undefined },
      customBlockIcon(props.type),
      _react2.default.createElement(
        'div',
        { className: 'text' },
        htmlToReactParser.parse(props.text)
      )
    );
  };

  return CustomBlockImpl;
}(_react.Component);

var CustomBlock = (0, _styledComponents2.default)(CustomBlockImpl)(_templateObject13);

var Feedback = _styledComponents2.default.div.withConfig({
  displayName: 'Article__Feedback',
  componentId: 'z814zo-3'
})(_templateObject14, _FICColors2.default.textDefault, _FICColors2.default.white, _FICColors2.default.white, _FICColors2.default.white, _FICColors2.default.white, function (props) {
  return props.valid && (0, _styledComponents.css)(_templateObject15, _FICColors2.default.white, _FICColors2.default.white);
});

var Counter = _styledComponents2.default.div.withConfig({
  displayName: 'Article__Counter',
  componentId: 'z814zo-4'
})(_templateObject16);

var Actions = _styledComponents2.default.div.withConfig({
  displayName: 'Article__Actions',
  componentId: 'z814zo-5'
})(_templateObject17, _FICColors2.default.defaultBlue);

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICRadio = __webpack_require__(76);

var _FICRadio2 = _interopRequireDefault(_FICRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FICRadioGroup(props) {
  return _react2.default.createElement(
    'div',
    { style: props.style, className: props.className },
    props.options.map(function (option) {
      return _react2.default.createElement(_FICRadio2.default, {
        key: option[props.valueKey],
        label: option[props.labelKey],
        data: option,
        onClick: function onClick() {
          return props.onChange ? handleClick(props.onChange, option[props.valueKey], props.name, option) : undefined;
        },
        isChecked: props.value === option[props.valueKey],
        isDisabled: props.isDisabled,
        renderOption: props.renderOption,
        optionsSpacing: props.optionsSpacing,
        inline: props.inline
      });
    })
  );
}

function handleClick(onChange, value, name, option) {
  onChange(value, name, option);
}

FICRadioGroup.propTypes = {
  name: _propTypes2.default.string,
  options: _propTypes2.default.array,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
  valueKey: _propTypes2.default.string,
  labelKey: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  isDisabled: _propTypes2.default.bool,
  renderOption: _propTypes2.default.func,
  optionsSpacing: _propTypes2.default.number,
  style: _propTypes2.default.object,
  inline: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

FICRadioGroup.defaultProps = {
  name: '',
  options: [],
  value: undefined,
  valueKey: 'value',
  labelKey: 'label',
  onChange: undefined,
  isDisabled: false,
  renderOption: undefined,
  optionsSpacing: 0,
  style: undefined,
  inline: false,
  className: undefined
};

exports.default = FICRadioGroup;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerFilename = headerFilename;

var _downloadjs = __webpack_require__(57);

var _downloadjs2 = _interopRequireDefault(_downloadjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICNetwork = function FICNetwork() {
  _classCallCheck(this, FICNetwork);
};

FICNetwork.download = function (url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var params = arguments[2];
  var filename = arguments[3];

  var xhr = new XMLHttpRequest();
  xhr.open(method, url, true);
  xhr.responseType = 'blob';

  if (method === 'POST') {
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  }

  xhr.onload = function (e) {
    if (!filename) {
      var headers = xhr.getAllResponseHeaders().split('\n');

      var disposition = headers.filter(function (header) {
        return header.startsWith('content-disposition');
      });

      if (disposition.length > 0) {
        filename = headerFilename(disposition[0]);
      } else {
        filename = url.split('/').pop().split('?')[0];
      }
    }

    (0, _downloadjs2.default)(e.target.response, filename);
  };
  if (method === 'POST') {
    xhr.send($.param(params || {}));
  } else {
    xhr.send();
  }
};

function headerFilename(disposition) {
  var filename = '';
  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches !== null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  return filename;
}

FICNetwork.print = function (url) {
  if (!url.startsWith(window.location.origin)) {
    url = reactGlobalParams.api_host + '/download?url=' + url;
  }
  var w = window.open(url);
  setTimeout(function () {
    w.print();
  }, 1000);
}

// Redirect jQuery code

;(function ($) {
  $.redirect = function (target, values, method) {
    method = method && method.toUpperCase() === 'GET' ? 'GET' : 'POST';

    if (!values) {
      var obj = $.parse_url(target);
      target = obj.url;
      values = obj.params;
    }

    var form = $('<form>', {
      attr: {
        method: method,
        action: target
      }
    });

    for (var i in values) {
      $('<input>', {
        attr: {
          type: 'hidden',
          name: i,
          value: values[i]
        }
      }).appendTo(form);
    }

    $('body').append(form);
    form.submit();
  };

  $.parse_url = function (url) {
    if (url.indexOf('?') === -1) {
      return { url: url, params: {} };
    }

    var parts = url.split('?');
    var url = parts[0];
    var query_string = parts[1];

    var return_obj = {};
    var elems = query_string.split('&');

    var obj = {};

    for (var i in elems) {
      var elem = elems[i];
      var pair = elem.split('=');
      obj[pair[0]] = pair[1];
    }

    return_obj.url = url;
    return_obj.params = obj;

    return return_obj;
  };
})(jQuery);

exports.default = FICNetwork;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(40);

__webpack_require__(41);

__webpack_require__(42);

__webpack_require__(43);

__webpack_require__(44);

__webpack_require__(45);

__webpack_require__(46);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(49);

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      'use strict';

      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];

      for (var i = 0; i !== length; i++) {
        if (predicate.call(thisArg, this[i], i, list)) {
          return this[i];
        }
      }
      return undefined;
    }
  });
}

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  height: 63px;\n\twidth: 625px;\n\tmax-width: 100%;\n\t', ';\n\tborder-radius: 4px;\n\tbackground-color: ', ';\n\tbox-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\tposition: relative;\n\tmargin-top: 15px;\n\t-webkit-transition: all 200ms ease-out; /* For Safari 3.1 to 6.0 */\n  transition: all 200ms ease-out;\n\t.fa, .faicon{\n    font-size: 24px!important;\n    color: #333!important;\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    z-index: 100;\n    &.close{\n      right:5px;\n      left: auto;\n      opacity: 1;\n      display: none;\n    }\n\t}\n\t', '\n'], ['\n  height: 63px;\n\twidth: 625px;\n\tmax-width: 100%;\n\t', ';\n\tborder-radius: 4px;\n\tbackground-color: ', ';\n\tbox-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\tposition: relative;\n\tmargin-top: 15px;\n\t-webkit-transition: all 200ms ease-out; /* For Safari 3.1 to 6.0 */\n  transition: all 200ms ease-out;\n\t.fa, .faicon{\n    font-size: 24px!important;\n    color: #333!important;\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    z-index: 100;\n    &.close{\n      right:5px;\n      left: auto;\n      opacity: 1;\n      display: none;\n    }\n\t}\n\t', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 780px;\n  '], ['\n    width: 780px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 50px;\n    margin: 0;\n    max-height: 100%;\n    box-sizing: border-box;\n    box-shadow: none;\n    position: absolute;\n    top:0;\n    right: 0;\n    .fa, .faicon{\n      cursor: pointer;\n      ', '\n    }\n    ', '\n    '], ['\n    width: 50px;\n    margin: 0;\n    max-height: 100%;\n    box-sizing: border-box;\n    box-shadow: none;\n    position: absolute;\n    top:0;\n    right: 0;\n    .fa, .faicon{\n      cursor: pointer;\n      ', '\n    }\n    ', '\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        margin-left: 0!important;\n        left:5px;\n      '], ['\n        margin-left: 0!important;\n        left:5px;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      width: 100%;\n      .fa.close,\n      .faicon.close{\n        display: block;\n        margin-right: 0;  \n      } \n    '], ['\n      width: 100%;\n      .fa.close,\n      .faicon.close{\n        display: block;\n        margin-right: 0;  \n      } \n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  height: 100%;\n  input{\n    width: 99%;\n    box-sizing: border-box;\n    height: 63px;\n    border: none!important;\n    padding-left: 50px!important;\n    font-size: 16px!important;\n    &:focus{box-shadow: none!important;}\n    &::placeholder{font-size: 16px!important;}\n    ', '\n    ', '\n  }\n  .fic-autocomplete-menu-outer{\n    margin-top: 4px!important;\n  }\n'], ['\n  height: 100%;\n  input{\n    width: 99%;\n    box-sizing: border-box;\n    height: 63px;\n    border: none!important;\n    padding-left: 50px!important;\n    font-size: 16px!important;\n    &:focus{box-shadow: none!important;}\n    &::placeholder{font-size: 16px!important;}\n    ', '\n    ', '\n  }\n  .fic-autocomplete-menu-outer{\n    margin-top: 4px!important;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n      height: 100%;\n      padding-right:50px;\n      display:none;\n    '], ['\n      height: 100%;\n      padding-right:50px;\n      display:none;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      display: block;\n    '], ['\n      display: block;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: rgba(51,51,51,0.72);\n  background-color: ', ';\n  border-radius: 4px;\n  padding: 12px 0 12px 40px!important;\n  font-size: 16px!important;\n  line-height: 24px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  &:hover{\n    color: ', '!important;\n    background-color: #FAFAFA!important;\n  }\n'], ['\n  color: rgba(51,51,51,0.72);\n  background-color: ', ';\n  border-radius: 4px;\n  padding: 12px 0 12px 40px!important;\n  font-size: 16px!important;\n  line-height: 24px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  &:hover{\n    color: ', '!important;\n    background-color: #FAFAFA!important;\n  }\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  text-align: center;\n  background-color: ', ';\n  border-radius: 4px;\n\tbox-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\tmargin-top: 5px;\n\t', '\n  p{\n\t  padding-top: 10px;\n    font-weight: bold;\n    color:', ';\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n  .noResults{\n    p{\n      padding: 20px 0;\n      margin-bottom: 0;\n      font-size: 20px;\n      font-weight: 600;\n    }\n  }\n  .searchResultsHeader{\n    text-align: left;\n    margin-left: 40px;\n    text-transform: uppercase;\n    padding-top: 5px;\n    p{\n      font-size: 12px;\n      color: #0094D4!important;\n    }\n  }\n'], ['\n  text-align: center;\n  background-color: ', ';\n  border-radius: 4px;\n\tbox-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\tmargin-top: 5px;\n\t', '\n  p{\n\t  padding-top: 10px;\n    font-weight: bold;\n    color:', ';\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n  .noResults{\n    p{\n      padding: 20px 0;\n      margin-bottom: 0;\n      font-size: 20px;\n      font-weight: 600;\n    }\n  }\n  .searchResultsHeader{\n    text-align: left;\n    margin-left: 40px;\n    text-transform: uppercase;\n    padding-top: 5px;\n    p{\n      font-size: 12px;\n      color: #0094D4!important;\n    }\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    display: none;\n    color:red;\n  '], ['\n    display: none;\n    color:red;\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border-top:1px solid rgba(51,51,51,0.08);\n  padding: 24px 65px;\n  box-sizing: border-box;\n  text-align: left;\n  @media (max-width: 425px) {\n    padding: 16px 16px;\n  }\n  p{\n    margin-top: 0;\n    font-size: 18px;\n    margin-bottom: 24px;\n    \n  }\n  ul{\n    padding: 0;\n    -webkit-column-count: 2; /* Chrome, Safari, Opera */\n    -moz-column-count: 2; /* Firefox */\n    column-count: 2;\n    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */\n    -moz-column-gap: 40px; /* Firefox */\n    column-gap: 40px;\n    margin-left: 10px;\n    li{\n      color: ', ';\n      margin-bottom: 12px;\n      margin-left:10px;\n      font-size: 16px;\n      line-height: 25px;\n      width: 100%;\n      -webkit-column-break-inside: avoid;\n      page-break-inside: avoid;\n      break-inside: avoid;\n      @media (max-width: 425px) {\n        font-size: 14px;\n        line-height: 20px;\n      }\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n'], ['\n  border-top:1px solid rgba(51,51,51,0.08);\n  padding: 24px 65px;\n  box-sizing: border-box;\n  text-align: left;\n  @media (max-width: 425px) {\n    padding: 16px 16px;\n  }\n  p{\n    margin-top: 0;\n    font-size: 18px;\n    margin-bottom: 24px;\n    \n  }\n  ul{\n    padding: 0;\n    -webkit-column-count: 2; /* Chrome, Safari, Opera */\n    -moz-column-count: 2; /* Firefox */\n    column-count: 2;\n    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */\n    -moz-column-gap: 40px; /* Firefox */\n    column-gap: 40px;\n    margin-left: 10px;\n    li{\n      color: ', ';\n      margin-bottom: 12px;\n      margin-left:10px;\n      font-size: 16px;\n      line-height: 25px;\n      width: 100%;\n      -webkit-column-break-inside: avoid;\n      page-break-inside: avoid;\n      break-inside: avoid;\n      @media (max-width: 425px) {\n        font-size: 14px;\n        line-height: 20px;\n      }\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n\theight: 16px;\n\tcolor: rgba(51,51,51,0.72);\n\tfont-size: 12px;\n\tletter-spacing: -0.13px;\n\tline-height: 16px;\n\t.fa, .faicon{\n    position: unset;\n    font-size: 12px!important;\n    margin: 0 5px!important;\n    color: rgba(51,51,51,0.72)!important;\n\t}\n'], ['\n\theight: 16px;\n\tcolor: rgba(51,51,51,0.72);\n\tfont-size: 12px;\n\tletter-spacing: -0.13px;\n\tline-height: 16px;\n\t.fa, .faicon{\n    position: unset;\n    font-size: 12px!important;\n    margin: 0 5px!important;\n    color: rgba(51,51,51,0.72)!important;\n\t}\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICAutocomplete = __webpack_require__(126);

var _FICAutocomplete2 = _interopRequireDefault(_FICAutocomplete);

var _FAIcon = __webpack_require__(6);

var _htmlToReact = __webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Autocomplete = function (_Component) {
  _inherits(Autocomplete, _Component);

  function Autocomplete(props) {
    _classCallCheck(this, Autocomplete);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.search = function (filter, callback) {
      if (filter === null) {
        return;
      }

      if (filter.length < 3) {
        _this.setState({ searchResults: undefined });
        return;
      }

      var isDev = window.location.host.includes('-dev') ? 1 : 0;

      _FICRestV2.default.get({
        request: 'help/search',
        queryData: { query: filter, realm: _this.props.realm, is_dev: isDev },
        onSuccess: function onSuccess(response) {
          var results = response.data.map(function (item) {
            return { id: item.article_id, label: item.title, tree: item.tree };
          });
          _this.setState({ searchResults: results });
        }
      });
    };

    _this.handleChange = function (name, value) {
      var newValue = value.toString();
      newValue = newValue.replace(/<[^>]*>/g, '');
      _this.setState({ filter: newValue });
    };

    _this.handleSelect = function (label, data) {
      _this.props.onSelect(data.permalink || data.tree.permalink, 'articolo');
      _this.changeSize();
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.autocompleteRef.autocompleteRef.setState({ isOpen: true });
      }
    };

    _this.renderItem = function (item) {
      var htmlToReactParser = new _htmlToReact.Parser();
      return _react2.default.createElement(
        Option,
        { key: item.id },
        htmlToReactParser.parse(item.label),
        item.tree && _react2.default.createElement(
          Tree,
          null,
          item.tree.section3_title && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'span',
              null,
              item.tree.section3_title
            ),
            _react2.default.createElement(_FAIcon.FALIcon, { name: 'long-arrow-right' })
          ),
          item.tree.section2_title && _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'span',
              null,
              item.tree.section2_title
            ),
            _react2.default.createElement(_FAIcon.FALIcon, { name: 'long-arrow-right' })
          ),
          item.tree.section1_title && _react2.default.createElement(
            'span',
            null,
            item.tree.section1_title
          )
        )
      );
    };

    _this.changeSize = function () {
      _this.setState(function (currentStatus) {
        return { open: !currentStatus.open };
      }, function () {
        if (_this.state.open && _this.autocompleteRef) {
          setTimeout(function () {
            _this.autocompleteRef.focus();
          }, 200);
        }
      });
      if (_this.props.onOpen) {
        _this.props.onOpen(!_this.state.open);
      }
    };

    _this.getTopArticles = function () {
      _FICRestV2.default.get({
        request: 'help/top_articles',
        queryData: { realm: _this.props.realm },
        onSuccess: function onSuccess(response) {
          _this.setState({ topArticles: response.data });
        }
      });
    };

    _this.renderMenuContent = function (items) {
      return _react2.default.createElement(
        Results,
        { open: _this.state.open, internal: _this.props.internal },
        _this.state.searchResults ? _this.state.searchResults.length > 0 ? _react2.default.createElement(
          'div',
          { className: 'searchResultsHeader' },
          _react2.default.createElement(
            'p',
            null,
            'Risultati della ricerca'
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'noResults' },
          _react2.default.createElement(
            'p',
            null,
            'Nessun risultato!'
          ),
          _react2.default.createElement('img', { srcSet: '/img/no-results.png 3x' })
        ) : null,
        items.length > 0 && items,
        _this.state.topArticles.length > 0 && _react2.default.createElement(
          TopArticles,
          null,
          _react2.default.createElement(
            'p',
            null,
            'Ti potrebbe interessare'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _this.state.topArticles.map(function (article, idx) {
              return _react2.default.createElement(
                'li',
                { key: idx, onClick: function onClick() {
                    return _this.handleSelect(undefined, article);
                  } },
                _react2.default.createElement(
                  'span',
                  null,
                  article.title
                )
              );
            })
          )
        )
      );
    };

    _this.state = {
      filter: '',
      searchResults: undefined,
      open: false,
      topArticles: []
    };
    _this.autocompleteRef = null;
    _this.getTopArticles();
    return _this;
  }

  Autocomplete.prototype.render = function render() {
    var _this2 = this;

    var placeholder = this.props.internal ? 'Cerca in Fatture in Cloud' : 'Cosa stai cercando? (Fatturazione elettronica, prima nota etc.)';
    if (this.props.realm === 'dic') {
      placeholder = this.props.internal ? 'Cerca in Dipendenti in Cloud' : 'Cosa stai cercando? (Giustificativi, dipendente etc.)';
    }

    return _react2.default.createElement(
      AutocompleteContainer,
      {
        internal: this.props.internal,
        open: this.state.open,
        isExternal: this.props.isExternal,
        className: (this.state.open ? 'open ' : '') + this.props.className
      },
      _react2.default.createElement(_FAIcon.FALIcon, { name: 'search', onClick: this.props.internal ? function () {
          return _this2.changeSize();
        } : null }),
      _react2.default.createElement(AutocompleteStyled, {
        ref: function ref(_ref) {
          return _this2.autocompleteRef = _ref;
        },
        placeholder: placeholder,
        value: this.state.filter,
        options: this.state.searchResults,
        loadOptions: this.search,
        loadOptionsDelay: 200,
        renderItem: this.renderItem,
        onSelect: this.handleSelect,
        onChange: this.handleChange,
        renderMenuContent: this.renderMenuContent,
        internal: this.props.internal,
        open: this.state.open,
        shouldItemRender: function shouldItemRender() {
          return true;
        },
        onKeyPress: this.handleKeyPress
      }),
      this.props.internal && _react2.default.createElement(_FAIcon.FALIcon, { name: 'times-circle', className: 'close', onClick: this.props.internal ? function () {
          return _this2.changeSize();
        } : null })
    );
  };

  return Autocomplete;
}(_react.Component);

exports.default = Autocomplete;


var AutocompleteContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Autocomplete__AutocompleteContainer',
  componentId: 'atcpxr-0'
})(_templateObject, function (props) {
  return props.isExternal && (0, _styledComponents.css)(_templateObject2);
}, _FICColors2.default.white, function (props) {
  return props.internal && (0, _styledComponents.css)(_templateObject3, function (props) {
    return props.open && (0, _styledComponents.css)(_templateObject4);
  }, function (props) {
    return props.open && (0, _styledComponents.css)(_templateObject5);
  });
});

var AutocompleteStyled = (0, _styledComponents2.default)(_FICAutocomplete2.default)(_templateObject6, function (props) {
  return props.internal && (0, _styledComponents.css)(_templateObject7);
}, function (props) {
  return props.open && (0, _styledComponents.css)(_templateObject8);
});
var Option = _styledComponents2.default.div.withConfig({
  displayName: 'Autocomplete__Option',
  componentId: 'atcpxr-1'
})(_templateObject9, _FICColors2.default.white, _FICColors2.default.defaultBlue);

var Results = _styledComponents2.default.div.withConfig({
  displayName: 'Autocomplete__Results',
  componentId: 'atcpxr-2'
})(_templateObject10, _FICColors2.default.white, function (props) {
  return props.internal && !props.open && (0, _styledComponents.css)(_templateObject11);
}, _FICColors2.default.textDefault);

var TopArticles = _styledComponents2.default.div.withConfig({
  displayName: 'Autocomplete__TopArticles',
  componentId: 'atcpxr-3'
})(_templateObject12, _FICColors2.default.textDefault, _FICColors2.default.defaultBlue);

var Tree = _styledComponents2.default.div.withConfig({
  displayName: 'Autocomplete__Tree',
  componentId: 'atcpxr-4'
})(_templateObject13);

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\theight: 64px;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tbackground-color: ', ';\n\tborder-bottom:1px solid rgba(51,51,51,0.08);\n\tposition: relative;\n\tcolor:', ';\n\tfont-size: 16px;\n\tz-index: 100;\n\t@media (max-width: 425px) {\n\t  font-size: 14px;\n\t}\n\t', '\n\t.breadCrumbsContainer{\n\t  max-width: 940px;\n\t  margin: 0 auto;\n\t  position: relative;\n    ', '\n\t}\n  .embeddedbreadCrumbs {\n    max-width: 800px;\n  }\n\t.FICLink{\n\t  display: inline-block;\n\t  padding: 20px 0;\n\t  @media (max-width: 425px) {\n\t    padding: 17px 0;\n\t  }\n    a{\n      color: ', ';\n      line-height: 24px;\n      text-decoration: underline;\n    }\n  }\n  .faicon{\n    margin: 0 8px;\n    color: ', ';\n    font-size: 14px;\n  }\n  .internalAutocomplete{\n    float: right;\n    width: 50px;    \n    margin: 0;\n    max-height: 100%;\n    box-sizing: border-box;\n    box-shadow: none;\n    .faicon{\n      font-size: 24px;\n      color: #333;\n    }\n    input{height: 100%}\n  }\n'], ['\n\theight: 64px;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tbackground-color: ', ';\n\tborder-bottom:1px solid rgba(51,51,51,0.08);\n\tposition: relative;\n\tcolor:', ';\n\tfont-size: 16px;\n\tz-index: 100;\n\t@media (max-width: 425px) {\n\t  font-size: 14px;\n\t}\n\t', '\n\t.breadCrumbsContainer{\n\t  max-width: 940px;\n\t  margin: 0 auto;\n\t  position: relative;\n    ', '\n\t}\n  .embeddedbreadCrumbs {\n    max-width: 800px;\n  }\n\t.FICLink{\n\t  display: inline-block;\n\t  padding: 20px 0;\n\t  @media (max-width: 425px) {\n\t    padding: 17px 0;\n\t  }\n    a{\n      color: ', ';\n      line-height: 24px;\n      text-decoration: underline;\n    }\n  }\n  .faicon{\n    margin: 0 8px;\n    color: ', ';\n    font-size: 14px;\n  }\n  .internalAutocomplete{\n    float: right;\n    width: 50px;    \n    margin: 0;\n    max-height: 100%;\n    box-sizing: border-box;\n    box-shadow: none;\n    .faicon{\n      font-size: 24px;\n      color: #333;\n    }\n    input{height: 100%}\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    transition: box-shadow 0.3s ease-in-out;\n    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n  '], ['\n    transition: box-shadow 0.3s ease-in-out;\n    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      max-width: 800px;\n    '], ['\n      max-width: 800px;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  @media (max-width: 425px) {\n    width: calc(100% - 50px);\n  }\n'], ['\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  @media (max-width: 425px) {\n    width: calc(100% - 50px);\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Autocomplete = __webpack_require__(406);

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICLink = __webpack_require__(91);

var _FICLink2 = _interopRequireDefault(_FICLink);

var _FAIcon = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var BreadCrumbs = function (_Component) {
  _inherits(BreadCrumbs, _Component);

  function BreadCrumbs(props) {
    _classCallCheck(this, BreadCrumbs);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleOpen = function (value) {
      _this.setState({ shadow: value });
    };

    _this.state = {};
    return _this;
  }

  BreadCrumbs.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      BreadCrumbsImp,
      { shadow: this.state.shadow, className: this.props.className },
      _react2.default.createElement(
        'div',
        { className: 'breadCrumbsContainer ' + (this.props.embedded ? 'embeddedbreadCrumbs' : '') },
        _react2.default.createElement(
          BreadCrumbsText,
          null,
          _react2.default.createElement(_FICLink2.default, { text: 'Supporto clienti', onClick: function onClick() {
              return _this2.props.onSelect(undefined, 'main');
            } }),
          _react2.default.createElement(_FAIcon.FALIcon, { name: 'angle-right' }),
          this.props.paths.map(function (path, idx) {
            return _react2.default.createElement(
              _react.Fragment,
              { key: idx },
              path.onClick ? _react2.default.createElement(_FICLink2.default, { text: path.text, onClick: function onClick() {
                  return path.onClick();
                } }) : _react2.default.createElement(
                'span',
                { style: { fontWeight: 600 } },
                path.text
              ),
              idx < _this2.props.paths.length - 1 && _react2.default.createElement(_FAIcon.FALIcon, { name: 'angle-right' })
            );
          })
        ),
        _react2.default.createElement(_Autocomplete2.default, {
          internal: true,
          onSelect: this.props.onSelect,
          onOpen: this.handleOpen,
          className: 'autocomplete',
          realm: this.props.realm
        })
      )
    );
  };

  return BreadCrumbs;
}(_react.Component);

exports.default = BreadCrumbs;


var BreadCrumbsImp = _styledComponents2.default.div.withConfig({
  displayName: 'BreadCrumbs__BreadCrumbsImp',
  componentId: 'sc-1acwimu-0'
})(_templateObject, _FICColors2.default.white, _FICColors2.default.textDefault, function (props) {
  return props.shadow && (0, _styledComponents.css)(_templateObject2);
}, function (props) {
  return props.embedded && (0, _styledComponents.css)(_templateObject3);
}, _FICColors2.default.defaultBlue, _FICColors2.default.textDefault);
var BreadCrumbsText = _styledComponents2.default.div.withConfig({
  displayName: 'BreadCrumbs__BreadCrumbsText',
  componentId: 'sc-1acwimu-1'
})(_templateObject4);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.includes called on null or undefined');
    }

    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.prototype.indexOf) Array.prototype.indexOf = function (Object, max, min) {
    "use strict";

    return function indexOf(member, fromIndex) {
        if (this === null || this === undefined) throw TypeError("Array.prototype.indexOf called on null or undefined");

        var that = Object(this),
            Len = that.length >>> 0,
            i = min(fromIndex | 0, Len);
        if (i < 0) i = max(0, Len + i);else if (i >= Len) return -1;

        if (member === void 0) {
            for (; i !== Len; ++i) {
                if (that[i] === void 0 && i in that) return i;
            } // undefined
        } else if (member !== member) {
            for (; i !== Len; ++i) {
                if (that[i] !== that[i]) return i;
            } // NaN
        } else for (; i !== Len; ++i) {
            if (that[i] === member) return i;
        } // all else

        return -1; // if the value was not found, then return -1
    };
}(Object, Math.max, Math.min);

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Number.isNaN = Number.isNaN || function (value) {
  return value !== value;
};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i); // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n\tmargin: 30px 0;\n\t.fic-page-section-block{\n\t  width: auto;\n\t  max-width: 840px;\n\t  @media all and (-ms-high-contrast: none) {\n\t    max-width: 945px;\n\t  }\n\t  margin: 0 auto;\n\t  display: flex;\n\t  @media screen and (max-width: 799px){\n\t    justify-content: center;  \n\t  }\n\t  flex-flow: row wrap;\n\t  justify-content: left;\n\t  &:after {\n      content: "";\n      flex: 0 0 255px;\n      margin: 25px 12.5px 0;\n    }\n\t}\n'], ['\n\tmargin: 30px 0;\n\t.fic-page-section-block{\n\t  width: auto;\n\t  max-width: 840px;\n\t  @media all and (-ms-high-contrast: none) {\n\t    max-width: 945px;\n\t  }\n\t  margin: 0 auto;\n\t  display: flex;\n\t  @media screen and (max-width: 799px){\n\t    justify-content: center;  \n\t  }\n\t  flex-flow: row wrap;\n\t  justify-content: left;\n\t  &:after {\n      content: "";\n      flex: 0 0 255px;\n      margin: 25px 12.5px 0;\n    }\n\t}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: auto;\n  background-color: ', ';\n  border: 1px solid rgba(51,51,51,0.08);\n  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n  flex: 0 0 255px;\n  @media screen and (max-width: 560px){\n    flex: 0 0 96%;\n  }\n  margin: 25px 12.5px 0;\n  padding:16px;\n  box-sizing: border-box;\n  vertical-align: top;\n  text-align: left;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: box-shadow 0.3s ease-in-out;\n  &:hover{\n    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n  }\n  h2{\n    font-size: 17px;\n    font-weight: bold;\n    line-height: 32px;\n    margin-bottom: 5px;\n    margin-top: 8px;\n    @media (max-width: 425px) {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n  p{\n    color: rgba(51,51,51,0.64);\n    font-size: 16px;\n    line-height: 24px;\n    @media (max-width: 425px) {\n      font-size: 14px;\n      line-height: 21px;\n    }\n  }\n'], ['\n  height: auto;\n  background-color: ', ';\n  border: 1px solid rgba(51,51,51,0.08);\n  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n  flex: 0 0 255px;\n  @media screen and (max-width: 560px){\n    flex: 0 0 96%;\n  }\n  margin: 25px 12.5px 0;\n  padding:16px;\n  box-sizing: border-box;\n  vertical-align: top;\n  text-align: left;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: box-shadow 0.3s ease-in-out;\n  &:hover{\n    box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n  }\n  h2{\n    font-size: 17px;\n    font-weight: bold;\n    line-height: 32px;\n    margin-bottom: 5px;\n    margin-top: 8px;\n    @media (max-width: 425px) {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n  p{\n    color: rgba(51,51,51,0.64);\n    font-size: 16px;\n    line-height: 24px;\n    @media (max-width: 425px) {\n      font-size: 14px;\n      line-height: 21px;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 48px;\n  height: 48px;\n  border-radius: 100%;\n  background-color: #D6E9F7;\n  text-align: center;\n  display: inline-table;\n  .fa, .faicon{\n    margin-top: 7px;\n    font-size: 23px;\n    color:#319be6; \n    display: table-cell;\n    vertical-align: middle; \n  }\n'], ['\n  width: 48px;\n  height: 48px;\n  border-radius: 100%;\n  background-color: #D6E9F7;\n  text-align: center;\n  display: inline-table;\n  .fa, .faicon{\n    margin-top: 7px;\n    font-size: 23px;\n    color:#319be6; \n    display: table-cell;\n    vertical-align: middle; \n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _customComponents = __webpack_require__(298);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _FICPageSection = __webpack_require__(27);

var _FICPageSection2 = _interopRequireDefault(_FICPageSection);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _reactContentLoader = __webpack_require__(334);

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _FAIcon = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var MainPage = function (_Component) {
  _inherits(MainPage, _Component);

  function MainPage(props) {
    _classCallCheck(this, MainPage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.renderLoadingBoxes = function () {
      var data = [1, 2, 3, 4, 5, 6];
      return data.map(function (content, idx) {
        return _react2.default.createElement(
          Section,
          { key: idx },
          _react2.default.createElement(SectionLoading, null)
        );
      });
    };

    _this.renderCategories = function () {
      return _this.state.sections.map(function (content, idx) {
        return _react2.default.createElement(
          Section,
          { key: idx, onClick: function onClick() {
              return _this.props.changeView(content.permalink, 'sezione');
            } },
          _react2.default.createElement(SectionIcon, { name: content.icon, size: 30 }),
          _react2.default.createElement(
            'h2',
            null,
            content.title
          ),
          _react2.default.createElement(
            'p',
            null,
            content.description
          )
        );
      });
    };

    _this.loadCategories = function () {
      _FICRestV2.default.get({
        request: 'help/list',
        queryData: { realm: _this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
        onSuccess: function onSuccess(response) {
          _this.setState({ sections: response.data.sections, chat: response.data.chat, loading: false });
        }
      });
    };

    _this.state = { loading: true, chat: {} };
    _this.loadCategories();
    return _this;
  }

  MainPage.prototype.render = function render() {
    return _react2.default.createElement(
      _customComponents.MainContainer,
      { className: this.props.className ? this.props.className : undefined },
      this.props.realm === 'fic' && _react2.default.createElement(_customComponents.FBCommunityBanner, { isExternal: this.props.isExternal }),
      _react2.default.createElement(_customComponents.HelpHeader, {
        closeIcon: !this.props.embedded,
        onClickClose: this.props.onClickClose,
        onSelect: this.props.changeView,
        className: 'helpHeader',
        isExternal: this.props.isExternal,
        realm: this.props.realm,
        embedded: this.props.embedded
      }),
      _react2.default.createElement(
        SectionsBoxes,
        null,
        _react2.default.createElement(
          _FICPageSection.FICPageSectionBlock,
          null,
          this.state.loading ? this.renderLoadingBoxes() : this.renderCategories()
        )
      ),
      this.state.chat.open && reactGlobalParams.chat.help_visible && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_customComponents.Separator, null),
        _react2.default.createElement(_customComponents.Chat, { warning: this.state.chat.warning }),
        _react2.default.createElement(_customComponents.PrivacyMessage, { isFic: this.props.realm === 'fic' })
      )
    );
  };

  return MainPage;
}(_react.Component);

exports.default = MainPage;


var SectionsBoxes = (0, _styledComponents2.default)(_FICPageSection2.default)(_templateObject);

var SectionImpl = function SectionImpl(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className, onClick: props.onClick },
    props.children
  );
};

var Section = (0, _styledComponents2.default)(SectionImpl)(_templateObject2, _FICColors2.default.white);

var SectionLoading = function SectionLoading() {
  return _react2.default.createElement(
    _reactContentLoader2.default,
    {
      height: 170,
      width: 256,
      speed: 2,
      primaryColor: '#f3f3f3',
      secondaryColor: '#ecebeb'
    },
    _react2.default.createElement('rect', { x: '16.03', y: '101', rx: '3', ry: '3', width: '210', height: '6.4' }),
    _react2.default.createElement('rect', { x: '16.03', y: '122', rx: '3', ry: '3', width: '228', height: '6.4' }),
    _react2.default.createElement('rect', { x: '16.03', y: '142', rx: '3', ry: '3', width: '120.6', height: '6.4' }),
    _react2.default.createElement('circle', { cx: '42', cy: '34', r: '30' }),
    _react2.default.createElement('rect', { x: '16.14', y: '76.61', rx: '0', ry: '0', width: '158.87', height: '13.02' })
  );
};

var SectionIconImpl = function SectionIconImpl(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(_FAIcon.FALIcon, _extends({}, props, { size: props.size, color: '#0078CD' }))
  );
};

var SectionIcon = (0, _styledComponents2.default)(SectionIconImpl)(_templateObject3);

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!String.prototype.repeat) {
  String.prototype.repeat = function (count) {
    'use strict';

    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
      str += str;
      count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  };
}

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 24px 16px;\n  border-bottom:1px solid rgba(51,51,51,0.08);\n  &:last-child{\n    border: none;\n  }\n'], ['\n  max-width: 940px;\n  margin: 0 auto;\n  padding: 24px 16px;\n  border-bottom:1px solid rgba(51,51,51,0.08);\n  &:last-child{\n    border: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  .sectionList{margin-top: 35px}\n  h2{\n    font-size: 30px;\n    font-weight: bold;\n    @media (max-width: 425px) {\n      font-size: 22px;\n    }\n  }\n  h3{\n    font-size: 20px;\n    font-weight: bold;\n  }\n  ul{\n    margin:20px 0 0 10px;\n    li{\n      color: ', ';\n      margin-bottom: 20px;\n      margin-left:10px;\n      font-size: 16px;\n      line-height: 24px;\n      &:last-child{margin-bottom: 0}\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n'], ['\n  .sectionList{margin-top: 35px}\n  h2{\n    font-size: 30px;\n    font-weight: bold;\n    @media (max-width: 425px) {\n      font-size: 22px;\n    }\n  }\n  h3{\n    font-size: 20px;\n    font-weight: bold;\n  }\n  ul{\n    margin:20px 0 0 10px;\n    li{\n      color: ', ';\n      margin-bottom: 20px;\n      margin-left:10px;\n      font-size: 16px;\n      line-height: 24px;\n      &:last-child{margin-bottom: 0}\n      span{\n        cursor: pointer;\n        color: ', ';\n        &:hover{\n          text-decoration: underline;\n          &::before {text-decoration: none;}\n        }\n      }\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height:160px;\n  margin: 35px auto;\n  max-width: 940px;\n  display: block;\n  .bulletList{width: 400px}\n'], ['\n  width: 100%;\n  height:160px;\n  margin: 35px auto;\n  max-width: 940px;\n  display: block;\n  .bulletList{width: 400px}\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _customComponents = __webpack_require__(298);

var _FICRestV = __webpack_require__(15);

var _FICRestV2 = _interopRequireDefault(_FICRestV);

var _BreadCrumbs = __webpack_require__(407);

var _BreadCrumbs2 = _interopRequireDefault(_BreadCrumbs);

var _reactContentLoader = __webpack_require__(334);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Section = function (_Component) {
  _inherits(Section, _Component);

  function Section(props) {
    _classCallCheck(this, Section);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.loadData = function (id) {
      var searchedId = id || _this.props.searchKey;
      _FICRestV2.default.get({
        request: 'help/list/' + searchedId,
        queryData: { realm: _this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
        onSuccess: function onSuccess(response) {
          var newData = _extends({}, response.data);
          newData.elementNotFound = !response.data.section;
          _this.setState(newData);
        }
      });
    };

    _this.getBreadCrumbs = function () {
      var breadCrumbPaths = [];
      var c = 2;
      while (c >= 1) {
        if (_this.state.tree && _this.state.tree['section' + c + '_permalink']) {
          (function () {
            var permalink = _this.state.tree['section' + c + '_permalink'];
            breadCrumbPaths.push({ text: _this.state.tree['section' + c + '_title'], onClick: function onClick() {
                return _this.props.changeView(permalink, 'sezione');
              } });
          })();
        }
        c--;
      }
      if (_this.state.section) {
        breadCrumbPaths.push({ text: _this.state.section.title });
      }
      return breadCrumbPaths;
    };

    _this.state = {
      section: false,
      articles: [],
      chat: [],
      elementNotFound: false
    };
    _this.loadData();
    return _this;
  }

  Section.prototype.componentDidMount = function componentDidMount() {
    var node = ReactDOM.findDOMNode(this);

    if (this.props.isExternal) {
      var mainContainer = node.parentNode.parentNode.parentNode;
      mainContainer.scrollTop = 0;
    }
  };

  Section.prototype.componentDidUpdate = function componentDidUpdate(prevProp) {
    if (this.props.searchKey !== prevProp.searchKey) {
      this.loadData(this.props.searchKey);
    }
  };

  Section.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      _customComponents.MainContainer,
      {
        className: this.props.className,
        isExternal: this.props.isExternal
      },
      _react2.default.createElement(_customComponents.HelpHeaderDetailed, {
        closeIcon: !this.props.embedded,
        onClickClose: this.props.onClickClose,
        onClick: function onClick() {
          return _this2.props.changeView(undefined, 'main');
        },
        title: this.state.section ? this.state.section.title : '',
        description: this.state.section && this.state.section.description ? this.state.section.description : '',
        isExternal: this.props.isExternal,
        realm: this.props.realm,
        embedded: this.props.embedded
      }),
      _react2.default.createElement(_BreadCrumbs2.default, {
        onSelect: this.props.changeView,
        paths: this.getBreadCrumbs(),
        className: 'breadCrumbs',
        realm: this.props.realm,
        embedded: this.props.embedded
      }),
      !this.state.section ? this.state.elementNotFound ? _react2.default.createElement(_customComponents.ElementNotFound, { type: 'section', onClick: this.props.changeView }) : _react2.default.createElement(SectionLoading, { isExternal: this.props.isExternal }) : _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.articles && this.state.articles.length > 0 && _react2.default.createElement(
          SectionContainer,
          {
            isExternal: this.props.isExternal,
            className: 'sectionContainer ' + (this.props.embedded ? 'embeddedSection' : '') + ' '
          },
          _react2.default.createElement(
            SectionList,
            null,
            _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                'h2',
                null,
                'Generali'
              ),
              _react2.default.createElement(
                'ul',
                null,
                this.state.articles.map(function (article, idx) {
                  return _react2.default.createElement(
                    'li',
                    { key: idx, onClick: function onClick() {
                        return _this2.props.changeView(article.permalink, 'articolo');
                      } },
                    _react2.default.createElement(
                      'span',
                      null,
                      article.title
                    )
                  );
                })
              )
            )
          )
        ),
        this.state.subSections && this.state.subSections.length > 0 && this.state.subSections.map(function (subSection, idx) {
          return _react2.default.createElement(
            SectionContainer,
            {
              isExternal: _this2.props.isExternal,
              key: idx,
              className: 'sectionContainer ' + (_this2.props.embedded ? 'embeddedSection' : '')
            },
            _react2.default.createElement(
              SectionList,
              null,
              _react2.default.createElement(
                'h2',
                null,
                subSection.title
              ),
              subSection.articles && _react2.default.createElement(
                'ul',
                null,
                subSection.articles.map(function (article, idx) {
                  return _react2.default.createElement(
                    'li',
                    { key: idx, onClick: function onClick() {
                        return _this2.props.changeView(article.permalink, 'articolo');
                      } },
                    _react2.default.createElement(
                      'span',
                      null,
                      article.title
                    )
                  );
                })
              ),
              subSection.subSections.length > 0 && subSection.subSections.map(function (subSubSection, subIdx) {
                return _react2.default.createElement(
                  SectionList,
                  { key: subIdx },
                  _react2.default.createElement(
                    'h3',
                    null,
                    subSubSection.title
                  ),
                  subSubSection.articles && _react2.default.createElement(
                    'ul',
                    null,
                    subSubSection.articles.map(function (subArticle, subAIdx) {
                      return _react2.default.createElement(
                        'li',
                        { key: subAIdx, onClick: function onClick() {
                            return _this2.props.changeView(subArticle.permalink, 'articolo');
                          } },
                        _react2.default.createElement(
                          'span',
                          null,
                          subArticle.title
                        )
                      );
                    })
                  )
                );
              })
            )
          );
        })
      ),
      this.state.chat.open && reactGlobalParams.chat.help_visible && !this.state.elementNotFound && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_customComponents.Chat, { warning: this.state.chat.warning, type: 'section', id: this.state.section.id }),
        _react2.default.createElement(_customComponents.PrivacyMessage, { isFic: this.props.realm === 'fic' })
      )
    );
  };

  return Section;
}(_react.Component);

exports.default = Section;


var SectionsContainerImpl = function SectionsContainerImpl(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    props.children
  );
};
var SectionContainer = (0, _styledComponents2.default)(SectionsContainerImpl)(_templateObject);

var SectionListImpl = function SectionListImpl(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className + ' sectionList' },
    props.children
  );
};
var SectionList = (0, _styledComponents2.default)(SectionListImpl)(_templateObject2, _FICColors2.default.textDefault, _FICColors2.default.textLink);

var SectionLoadingSvg = function SectionLoadingSvg(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className + ' sectionListLoading' },
    _react2.default.createElement(_reactContentLoader.BulletList, { className: 'bulletList' })
  );
};
var SectionLoading = (0, _styledComponents2.default)(SectionLoadingSvg)(_templateObject3);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICColors = function FICColors() {
  _classCallCheck(this, FICColors);
};

FICColors.white = '#FFFFFF';
FICColors.blue = '#0D97D5';
FICColors.lightBlue = '#E0EAF9';
FICColors.deepBlue = '#007CE4';
FICColors.green = '#13CE64';
FICColors.darkGreen = '#00875A';
FICColors.black = '#333333';
FICColors.gray = '#EBEDEE';
FICColors.darkGray = '#7B8B93';
FICColors.borderColor = '#AAB4B9';
FICColors.inputDisabled = '#EBEDEE';
FICColors.inputDisabledText = '#BDC5C8';
FICColors.placeholder = '#94A1A7';
FICColors.boxBackgroundColor = '#F8F9F9';

// black
FICColors.black100 = '#333333';

// blue
FICColors.blue50 = '#E4F3FA';
FICColors.blue100 = '#C6E7F5';
FICColors.blue200 = '#A4D8EF';
FICColors.blue300 = '#7DC8E8';
FICColors.blue400 = '#4DB4E0';
FICColors.blue500 = '#0D97D5';
FICColors.blue600 = '#0B8AC0';
FICColors.blue700 = '#0A79A8';
FICColors.blue800 = '#08648B';
FICColors.blue900 = '#064763';

// grey
FICColors.grey50 = '#FAFAFA';
FICColors.grey100 = '#EBEDEE';
FICColors.grey300 = '#A8B3B8';
FICColors.grey500 = '#6F7E86';
FICColors.grey600 = '#65747B';
FICColors.grey700 = '#5A676D';
FICColors.grey900 = '#22282B';

// red
FICColors.red = '#FF4949';
FICColors.red500 = '#DE350B';
FICColors.red600 = '#DA300A';

// yellow / orange
FICColors.yellow300 = '#FFB862';

FICColors.form = {
  field: {
    label: FICColors.black,
    validationMessage: FICColors.red,
    description: FICColors.darkGray
  }
};

FICColors.button = {
  primary: {
    blue: {
      normal: FICColors.blue,
      hover: '#0B8AC0',
      active: '#08648b',
      disabled: '#C6E7F5',
      text: FICColors.white,
      textHover: FICColors.white
    },
    red: {
      normal: FICColors.red,
      hover: '#ca3839',
      active: '#a72f2f',
      disabled: '#FFD8D8',
      text: FICColors.white,
      textHover: FICColors.white
    },
    green: {
      normal: FICColors.green,
      hover: '#0fa34e',
      active: '#0c8742',
      disabled: '#C7F3DA',
      text: FICColors.white,
      textHover: FICColors.white
    },
    white: {
      normal: FICColors.white,
      hover: FICColors.grey100,
      active: '#ebedee',
      disabled: '#F8F9F9',
      text: FICColors.black,
      textHover: FICColors.black
    },
    whiteBlue: {
      normal: FICColors.white,
      hover: FICColors.grey100,
      active: '#ebedee',
      disabled: '#F8F9F9',
      text: FICColors.blue,
      textHover: FICColors.black
    }
  },
  secondary: {
    blue: {
      normal: FICColors.lightBlue,
      hover: '#B3CBF0',
      active: '#80A9E6',
      disabled: FICColors.boxBackgroundColor,
      text: '#0052CC',
      textHover: '#0052CC'
    },
    red: {
      normal: '#ffecec',
      hover: '#ffd8d8',
      active: '#ffc1c1',
      disabled: '#ffecec',
      text: FICColors.red,
      textHover: FICColors.red
    },
    green: {
      normal: '#e4f9ed',
      hover: '#c7f3da',
      active: '#a6ecc5',
      disabled: '#e4f9ed',
      text: FICColors.green,
      textHover: FICColors.green
    },
    white: {
      normal: FICColors.gray,
      hover: '#ebedee',
      active: '#dde1e3',
      disabled: FICColors.gray,
      text: FICColors.black,
      textHover: FICColors.black
    }
  }
};

FICColors.link = {
  normal: FICColors.blue,
  hover: '#0B8AC0',
  gray: '#5C6E77'
};

FICColors.text = {
  gray: '#5C6E77'
};

exports.default = FICColors;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FICModalHtml = exports.FICModalContainer = exports.default = exports.FICModalRawFooter = exports.FICModalRawTitle = exports.FICModalRawHeader = exports.FICModalBody = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.FICModalHeader = FICModalHeader;
exports.FICModalFooter = FICModalFooter;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__(54);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Modal = __webpack_require__(55);

var _Modal2 = _interopRequireDefault(_Modal);

var _FIC = __webpack_require__(11);

var _FIC2 = _interopRequireDefault(_FIC);

var _FICUtils = __webpack_require__(9);

var _FICUtils2 = _interopRequireDefault(_FICUtils);

var _FICButton = __webpack_require__(23);

var _FICButton2 = _interopRequireDefault(_FICButton);

__webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var FICModalBody = exports.FICModalBody = _Modal2.default.Body;
var FICModalRawHeader = exports.FICModalRawHeader = _Modal2.default.Header;
var FICModalRawTitle = exports.FICModalRawTitle = _Modal2.default.Title;
var FICModalRawFooter = exports.FICModalRawFooter = _Modal2.default.Footer;

var FICModalV2 = function (_Component) {
  _inherits(FICModalV2, _Component);

  function FICModalV2(props) {
    _classCallCheck(this, FICModalV2);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.hideInBG = function () {
      _this.setState({ _visible: 'hidden' });
    };

    _this.showFromBG = function () {
      if (_this.state._visible === 'hidden') {
        _this.setState({ _visible: 'visible' }, function () {
          _this.focus();
        });
      }
    };

    _this.hide = function () {
      // Sarebbe close
      var id = _this.props.id;
      _this.setState({ _visible: 'closed' }, function () {
        if (_this._container) {
          _this._container.remove(id);
        }
      });
    };

    _this.focus = function () {
      setTimeout(function () {
        $('.fic-modal-' + _this.props.id).focus();
      }, 10); // Delay necessario
    };

    _this.renderChildren = function (props) {
      if (!_this.props.children) return null;
      return _react2.default.Children.map(_this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          hide: _this.hide
        });
      });
    };

    _this.state = {
      _visible: 'pre-show'
    };
    _this._mounted = true;
    _this._container = props.container;
    return _this;
  }

  FICModalV2.prototype.componentDidCatch = function componentDidCatch(error, info) {
    if (_FIC2.default.browser && _FIC2.default.browser.name === 'ie' && _FIC2.default.browser.version < '11') {
      alert('Si è verificato un errore. Aggiorna il browser alla versione più recente.');
    }
  };

  FICModalV2.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2.setState({ _visible: 'visible' }, function () {
        _this2.focus();
      });
    }, 0);
  };

  FICModalV2.prototype.componentWillUnmount = function componentWillUnmount() {
    this._mounted = false;
  };

  FICModalV2.prototype.render = function render() {
    var style = { content: {} };
    if (this.props.width) {
      style.content.width = this.props.width;
    }
    if (this.props.maxWidth) {
      style.content.maxWidth = this.props.maxWidth;
    }
    var className = 'fic-modal fic-modal-' + this.props.id;
    if (this.props.scrollable) {
      className += ' scrollable';
    }
    return _react2.default.createElement(
      _reactModal2.default,
      {
        id: this.props.id,
        className: className,
        overlayClassName: 'FICModal2_Overlay fic-modal-' + this.state._visible,
        isOpen: true,
        contentLabel: 'Finestra di dialogo',
        onHide: this.hide,
        style: style,
        onRequestClose: this.hide,
        tabindex: '-1',
        ariaHideApp: false },
      this.renderChildren() || _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(FICModalHeader, { html: this.props.htmlTitle }),
        _react2.default.createElement(
          FICModalBody,
          null,
          this.props.htmlBody
        ),
        _react2.default.createElement(FICModalFooter, { modal: this, html: this.props.htmlFooter, buttons: this.props.footerButtons })
      )
    );
  };

  return FICModalV2;
}(_react.Component);

exports.default = FICModalV2;

var FICModalContainer = exports.FICModalContainer = function (_Component2) {
  _inherits(FICModalContainer, _Component2);

  function FICModalContainer(props) {
    _classCallCheck(this, FICModalContainer);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.add = function (properties) {
      _this3.setState(function (prevState) {
        var newStack = prevState.propsStack.slice();
        var newId = new Date().getTime() + '-' + _FICUtils2.default.randomBetween(0, 10000);
        properties.id = newId;
        for (var key in _this3.modalRefs) {
          if (!_this3.modalRefs.hasOwnProperty(key)) continue;
          _this3.modalRefs[key].hideInBG();
        }
        newStack.push(properties);
        return { propsStack: newStack };
      });
    };

    _this3.remove = function (id) {
      delete _this3.modalRefs[id];
      setTimeout(function () {
        _this3.setState(function (prevState) {
          var newStack = prevState.propsStack.slice();
          newStack = newStack.filter(function (item) {
            return item.id !== id;
          });
          return { propsStack: newStack };
        });
      }, 500);
      if (Object.keys(_this3.modalRefs).length > 0) {
        var lastKey = void 0;
        // do not change or you'll get fired
        // seriously
        for (lastKey in _this3.modalRefs) {
          // do nothing
        }
        _this3.modalRefs[lastKey].showFromBG();
      }
    };

    _this3.state = {
      propsStack: []
    };
    _this3.modalRefs = {};
    return _this3;
  }

  FICModalContainer.prototype.render = function render() {
    var _this4 = this;

    return _react2.default.createElement(
      'div',
      null,
      this.state.propsStack.map(function (item, idx) {
        return _react2.default.createElement(
          FICModalV2,
          _extends({
            id: item.id,
            key: item.id,
            container: _this4,
            ref: function ref(modal) {
              if (modal && modal.state._visible !== 'closed') {
                _this4.modalRefs[item.id] = modal;
              }
            }
          }, item.props),
          item.content
        );
      })
    );
  };

  return FICModalContainer;
}(_react.Component);

FICModalV2.init = function (container) {
  FICModalV2.container = ReactDOM.render(_react2.default.createElement(FICModalContainer, null), container);
};

/*

USAGE:

FICModal.show({
  title: "Ciao",
  body: "Miao",
  actions: [
    {text: "Conferma", color: "success", onClick: null},
    {text: "Chiudi", color: "gray", onClick: null},
  ]
})

*/

FICModalV2.show = function (options) {
  FICModalV2.container.add({
    content: null,
    props: {
      width: options.width,
      htmlTitle: options.title,
      htmlBody: options.body,
      htmlFooter: options.footer,
      footerButtons: options.actions
    }
  });
};

FICModalV2.showMessage = function (title, message, smallMessage) {
  FICModalV2.show({
    title: title,
    body: _react2.default.createElement(
      'span',
      null,
      message,
      smallMessage && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'span',
          { className: 'small-gray-message' },
          smallMessage
        )
      )
    ),
    actions: [{ text: 'Chiudi', color: 'gray', onClick: null }]
  });
};

/*

USAGE:

FICModal.showCustom(<Component/>, {propName: "Abc"})

*/

FICModalV2.showCustom = function (content) {
  FICModalV2.showCustom(content, null);
};

FICModalV2.showCustom = function (content, modalProps) {
  FICModalV2.container.add({ content: content, props: modalProps });
};

function FICModalHeader(props) {
  return _react2.default.createElement(
    FICModalRawHeader,
    null,
    _react2.default.createElement(
      FICModalRawTitle,
      null,
      props.html
    )
  );
}

function itemsWithType(items, type) {
  if (!items) return [];else return items.map(function (item) {
    return _extends(item, { type: type });
  });
}

function FICModalFooter(props) {
  var footer = props.html;
  var items = [].concat(_toConsumableArray(itemsWithType(props.leftItems, 'left')), _toConsumableArray(itemsWithType(props.centerItems, 'center')), _toConsumableArray(itemsWithType([].concat(_toConsumableArray(props.rightItems), _toConsumableArray(props.buttons)).reverse(), 'right')));
  if (items) {
    footer = items.map(function (_ref, idx) {
      var hide = _ref.hide,
          html = _ref.html,
          type = _ref.type,
          icon = _ref.icon,
          _onClick = _ref.onClick,
          keepOpen = _ref.keepOpen,
          item = _objectWithoutProperties(_ref, ['hide', 'html', 'type', 'icon', 'onClick', 'keepOpen']);

      if (hide) {
        return null;
      }
      if (html) {
        return _react2.default.createElement(
          'div',
          {
            className: 'footer-item ' + type,
            key: idx,
            style: { display: 'inline-block', height: '31px' } },
          html
        );
      }
      return _react2.default.createElement(_FICButton2.default, _extends({
        className: 'footer-item ' + type,
        key: idx,
        iconLeft: icon,
        onClick: function onClick() {
          if (_onClick !== undefined) {
            _onClick();
          }
          if (props.modal && !keepOpen) {
            props.modal.hide();
          }
        }
      }, item));
    });
  }
  return _react2.default.createElement(
    FICModalRawFooter,
    null,
    footer
  );
}

FICModalFooter.propTypes = {
  leftItems: _propTypes2.default.array,
  centerItems: _propTypes2.default.array,
  rightItems: _propTypes2.default.array,
  buttons: _propTypes2.default.array
};

FICModalFooter.defaultProps = {
  leftItems: [],
  centerItems: [],
  rightItems: [],
  buttons: []
};

FICModalHeader.propTypes = {
  html: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])

  /*
  Modal html sporco
   */
  /*
  modalUrl = (url, params = {}) => {
    $.get(url, (data) => {
      if (FICModalHtml.lastHideCallback)
        FICModalHtml.lastHideCallback()
  
      FICModal.showCustom(<FICModalHtml html={data}/>, params)
    })
  }
  */

};
var FICModalHtml = exports.FICModalHtml = function (_Component3) {
  _inherits(FICModalHtml, _Component3);

  function FICModalHtml(props) {
    _classCallCheck(this, FICModalHtml);

    var _this5 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this5.body = null;
    FICModalHtml.lastHideCallback = props.hide;
    return _this5;
  }

  FICModalHtml.prototype.componentDidMount = function componentDidMount() {
    var _this6 = this;

    $(this.body).html(this.props.html);
    $(this.body).find('a[data-dismiss=\'modal\']').click(function () {
      _this6.props.hide();
    });
  };

  FICModalHtml.prototype.render = function render() {
    var _this7 = this;

    return _react2.default.createElement('div', { ref: function ref(element) {
        return _this7.body = element;
      } });
  };

  return FICModalHtml;
}(_react.Component);

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  ', ';\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 4px;\n  #react-select-2-input{\n    line-height: 30px;\n    height: 30px;\n    display: inline-block;\n    padding: 4px 0px;\n    margin-bottom: 0;\n    color: #555555;\n    vertical-align: middle;\n  }\n  textarea:hover, \n  input:hover, \n  textarea:active, \n  input:active, \n  textarea:focus, \n  input:focus,\n  button:focus,\n  button:active,\n  button:hover,\n  label:focus,\n  .btn:active,\n  .btn.active\n  {\n      outline:0px !important;\n      -webkit-appearance:none;\n      box-shadow: none !important;\n  }\n  .ReactSelect__value-container > div {\n    margin: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n'], ['\n  width: ', ';\n  height: ', ';\n  ', ';\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 4px;\n  #react-select-2-input{\n    line-height: 30px;\n    height: 30px;\n    display: inline-block;\n    padding: 4px 0px;\n    margin-bottom: 0;\n    color: #555555;\n    vertical-align: middle;\n  }\n  textarea:hover, \n  input:hover, \n  textarea:active, \n  input:active, \n  textarea:focus, \n  input:focus,\n  button:focus,\n  button:active,\n  button:hover,\n  label:focus,\n  .btn:active,\n  .btn.active\n  {\n      outline:0px !important;\n      -webkit-appearance:none;\n      box-shadow: none !important;\n  }\n  .ReactSelect__value-container > div {\n    margin: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    height: ', ';\n  '], ['\n    height: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: calc(100% - 70px);\n  cursor: ', ';\n  padding: 0!important;\n'], ['\n  width: calc(100% - 70px);\n  cursor: ', ';\n  padding: 0!important;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  box-shadow: none!important;\n  >div{\n    max-height: unset;\n  }\n'], ['\n  box-shadow: none!important;\n  >div{\n    max-height: unset;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(122);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

var _style = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * https://react-select.com/props
 * Ogni componente interno può essere sovrascritto con la prop Components
 * @param props
 * @returns {*}
 * @constructor
 */
function FICSelectImpl(props) {
  var componentsStyles = (0, _style.getComponentsStyles)(props);
  var renderComponents = getRenderComponents(props);

  var defaultValue = void 0;
  props.options.forEach(function (option) {
    if (option.value === props.value) {
      defaultValue = option;
    }
  });

  return _react2.default.createElement(_reactSelect2.default, {
    className: props.className,
    classNamePrefix: 'ReactSelect',
    placeholder: props.placeholder,
    isClearable: props.isClearable,
    isDisabled: props.isDisabled,
    isLoading: props.isLoading,
    value: defaultValue,
    backspaceRemoves: false,
    deleteRemoves: false,
    autosize: false,
    filterOption: props.filterOption || (0, _reactSelect.createFilter)(getFilterConfig(props)),
    isOptionDisabled: props.isOptionDisabled,
    isOptionSelected: props.isOptionSelected,
    isSearchable: props.isSearchable,
    menuIsOpen: props.menuIsOpen,
    defaultMenuIsOpen: props.defaultMenuIsOpen,
    autoFocus: props.autoFocus,
    options: props.options,
    onChange: function onChange(option) {
      props.onChange(option ? option.value : undefined, option || null);
    },
    noOptionsMessage: function noOptionsMessage() {
      return 'Nessuna corrispondenza trovata';
    },
    styles: componentsStyles,
    components: renderComponents,
    maxMenuHeight: props.maxMenuHeight
  });
}

function getRenderComponents(props) {
  var renderComponents = {};
  renderComponents.IndicatorSeparator = function () {
    return null;
  };
  renderComponents.DropdownIndicator = function () {
    return _react2.default.createElement(_FICIcon2.default, { name: 'angle-down', style: {
        marginRight: '8px',
        color: props.isDisabled ? _FICColors2.default.inputDisabledText : _FICColors2.default.black,
        position: 'relative',
        top: props.size === 'large' ? '5px' : undefined,
        cursor: 'pointer'
      } });
  };
  renderComponents.clearIndicator = function () {
    return _react2.default.createElement(_FICIcon2.default, { name: 'times', style: {
        marginRight: '5px',
        color: props.isDisabled ? _FICColors2.default.inputDisabledText : _FICColors2.default.black,
        position: 'relative',
        top: props.size === 'large' ? '5px' : undefined,
        cursor: 'pointer'
      } });
  };

  renderComponents.Option = function (props) {
    return _react2.default.createElement(
      _reactSelect.components.Option,
      props,
      props.children,
      _react2.default.createElement(_FICIcon2.default, { name: 'check', style: { position: 'absolute', right: 10, marginTop: 5, display: 'none' } })
    );
  };

  if (props.isSearchable) {
    renderComponents.ValueContainer = function (props) {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_FICIcon2.default, { name: 'search', style: { margin: '0 10px' } }),
        _react2.default.createElement(
          IsSearchableContainer,
          props,
          props.children
        )
      );
    };
  }

  if (props.menuIsOpen) {
    renderComponents.DropdownIndicator = function () {
      return null;
    };
    renderComponents.Menu = function (props) {
      return _react2.default.createElement(
        MenuOpenContainer,
        _extends({ style: { color: 'red' } }, props),
        props.children
      );
    };
  }

  if (props.renderOption) {
    renderComponents.Option = function (_ref) {
      var children = _ref.children,
          innerProps = _ref.innerProps;
      return props.renderOption(children, innerProps);
    };
  }

  return renderComponents;
}

function getFilterConfig(props) {
  var ignoreCase = props.ignoreCase || true;
  var ignoreAccents = props.ignoreAccents || true;
  return {
    ignoreCase: ignoreCase,
    ignoreAccents: ignoreAccents
  };
}

var FICSelect = (0, _styledComponents2.default)(FICSelectImpl)(_templateObject, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.size === 'large' ? '40px' : '30px';
}, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject2, props.height);
}, _FICColors2.default.white, _FICColors2.default.borderColor);

var IsSearchableContainer = (0, _styledComponents2.default)(_reactSelect.components.ValueContainer)(_templateObject3, function (props) {
  return !props.hasValue ? 'text' : 'auto';
});

var MenuOpenContainer = (0, _styledComponents2.default)(_reactSelect.components.Menu)(_templateObject4);

FICSelectImpl.propTypes = FICSelect.propTypes = {
  options: _propTypes2.default.array,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  valueKey: _propTypes2.default.string,
  emptyLabel: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  clearable: _propTypes2.default.bool,
  maxMenuHeight: _propTypes2.default.number,
  style: _propTypes2.default.object,
  filterOption: _propTypes2.default.func,
  getOptionLabel: _propTypes2.default.string,
  getOptionValue: _propTypes2.default.string,
  isOptionDisabled: _propTypes2.default.bool,
  isOptionSelected: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  isSearchable: _propTypes2.default.bool,
  menuIsOpen: _propTypes2.default.bool,
  defaultMenuIsOpen: _propTypes2.default.bool,
  size: _propTypes2.default.string
};

FICSelectImpl.defaultProps = FICSelect.defaultProps = {
  options: [],
  value: '',
  valueKey: 'value',
  emptyLabel: '',
  placeholder: '',
  onChange: undefined,
  clearable: false,
  maxMenuHeight: null,
  style: {},
  filterOption: undefined,
  getOptionLabel: '',
  getOptionValue: undefined,
  isOptionDisabled: false,
  isOptionSelected: false,
  isValid: undefined,
  isDisabled: false,
  isSearchable: false,
  menuIsOpen: undefined,
  defaultMenuIsOpen: undefined,
  size: undefined
};

getRenderComponents.propTypes = {
  isDisabled: _propTypes2.default.bool,
  size: _propTypes2.default.string
};

exports.default = FICSelect;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function FICMultilineTextView(props) {
  return React.createElement(
    'div',
    { style: { whiteSpace: 'pre-line' } },
    props.children
  );
}

exports.default = FICMultilineTextView;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FICUtils = __webpack_require__(9);

var _FICUtils2 = _interopRequireDefault(_FICUtils);

var _FICValidator = __webpack_require__(28);

var _FICValidator2 = _interopRequireDefault(_FICValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FICValidation = {};
exports.default = FICValidation;


FICValidation.itTaxCode = function (value) {
  var allowVatNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return _FICUtils2.default.controllaCF(value) === '' || allowVatNumbers && _FICUtils2.default.controllaPIVA(value) === '';
};

FICValidation.itVatNumber = function (value) {
  return _FICUtils2.default.controllaPIVA(value) === '';
};

FICValidation.isEmail = function (value) {
  return _FICValidator2.default.email(value, true).valid;
};

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(59);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./General.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./General.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}input::-ms-clear{display:none}:focus{outline:none!important}p{margin:0}p+p{margin-top:10px}@keyframes pulse_animation{0%{transform:scale(1)}30%{transform:scale(1)}40%{transform:scale(1.08)}50%{transform:scale(1)}60%{transform:scale(1)}70%{transform:scale(1.05)}80%{transform:scale(1)}to{transform:scale(1)}}.pulse{animation-name:pulse_animation;animation-delay:2s;animation-duration:1s;transform-origin:70% 70%;animation-iteration-count:1;animation-timing-function:linear}", ""]);

// exports


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICColors = __webpack_require__(13);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

__webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function FAIconF(props) {
  var name = props.name,
      className = props.className,
      spin = props.spin,
      color = props.color,
      size = props.size,
      fixedWidth = props.fixedWidth,
      iconProps = _objectWithoutProperties(props, ['name', 'className', 'spin', 'color', 'size', 'fixedWidth']);

  var prefix = 'fa';
  var icon = name;

  if (Array.isArray(name)) {
    if (name.length === 1) {
      icon = name[0];
    } else if (name.length > 1) {
      prefix = name[0];
      icon = name[1];
    }
  }

  className = prefix + ' faicon fa-' + icon + ' ' + className;
  if (spin) {
    className += ' fa-spin';
  }
  if (fixedWidth) {
    className += ' fa-fw';
  }
  return _react2.default.createElement('b', _extends({ className: className }, iconProps));
}

var FAIcon = (0, _styledComponents2.default)(FAIconF)(_templateObject, function (props) {
  return _FICColors2.default[props.color] || props.color || undefined;
}, function (props) {
  return props.size ? props.size + 'px' : undefined;
});

FAIcon.propTypes = FAIconF.propTypes = {
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  spin: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  fixedWidth: _propTypes2.default.bool
};

FAIconF.defaultProps = {
  name: undefined,
  className: '',
  style: {},
  spin: false,
  color: undefined,
  size: undefined,
  fixedWidth: false
};

var FALIcon = function FALIcon(_ref) {
  var name = _ref.name,
      props = _objectWithoutProperties(_ref, ['name']);

  return _react2.default.createElement(FAIcon, _extends({ name: ['fal', name] }, props));
};

exports.FALIcon = FALIcon;
exports.default = FAIcon;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FAIcon.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FAIcon.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubArticle = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tborder: 1px solid rgba(51,51,51,0.24);\n\tborder-radius: 4px;\n\tbox-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n\tmargin: 15px 0;\n\ttransition: box-shadow 0.3s ease-in-out;\n\tpadding: 0 20px;\n\tbox-sizing: border-box;\n\t&:hover{\n\t  box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\t}\n\tspan.title{\n\t  cursor: pointer;\n\t  display:table-cell;\n\t  vertical-align: middle;\n\t  margin-bottom: 0;\n\t  font-size: 18px;\n\t  font-weight: 600;\n\t  padding: 15px 0 15px 15px;\n\t  width: calc(100% - 15px);\n\t  box-sizing: border-box;\n\t}\n\t.fa,.faicon{\n\t  font-size: 20px;\n\t  display: table-cell;\n\t  vertical-align: middle;\n\t  transition: transform 400ms ease-out;\n\t}\n\t.titleContent{\n\t  border-bottom:1px solid rgba(51,51,51,0.24);\n\t  cursor: pointer;\n\t  .fa,.faicon{\n\t    transform: rotate(90deg);\n\t  }\n\t}\n\t.articleContent{\n    max-width: 100%!important;\n    box-sizing: border-box;\n\t}\n\t.subArticleContent{\n\t  margin-top: 10px;\n\t}\n'], ['\n\tborder: 1px solid rgba(51,51,51,0.24);\n\tborder-radius: 4px;\n\tbox-shadow: 0 1px 1px 0 rgba(0,0,0,0.05);\n\tmargin: 15px 0;\n\ttransition: box-shadow 0.3s ease-in-out;\n\tpadding: 0 20px;\n\tbox-sizing: border-box;\n\t&:hover{\n\t  box-shadow: 0 9px 16px 0 rgba(0,0,0,0.1);\n\t}\n\tspan.title{\n\t  cursor: pointer;\n\t  display:table-cell;\n\t  vertical-align: middle;\n\t  margin-bottom: 0;\n\t  font-size: 18px;\n\t  font-weight: 600;\n\t  padding: 15px 0 15px 15px;\n\t  width: calc(100% - 15px);\n\t  box-sizing: border-box;\n\t}\n\t.fa,.faicon{\n\t  font-size: 20px;\n\t  display: table-cell;\n\t  vertical-align: middle;\n\t  transition: transform 400ms ease-out;\n\t}\n\t.titleContent{\n\t  border-bottom:1px solid rgba(51,51,51,0.24);\n\t  cursor: pointer;\n\t  .fa,.faicon{\n\t    transform: rotate(90deg);\n\t  }\n\t}\n\t.articleContent{\n    max-width: 100%!important;\n    box-sizing: border-box;\n\t}\n\t.subArticleContent{\n\t  margin-top: 10px;\n\t}\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FAIcon = __webpack_require__(6);

var _Article = __webpack_require__(368);

var _Article2 = _interopRequireDefault(_Article);

var _immutabilityHelper = __webpack_require__(88);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SubArticleClass = function (_Component) {
  _inherits(SubArticleClass, _Component);

  function SubArticleClass(props) {
    _classCallCheck(this, SubArticleClass);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.showContent = function () {
      if (_this.parentsArticle.length > 3) {
        if (_this.props.isInternal) {
          window.open('/help/articolo/' + _this.props.permalink, '_blank');
        } else {
          _this.props.changeView(_this.props.permalink, 'articolo');
        }
      } else {
        _this.setState(function (prevState) {
          return { showContent: !prevState.showContent };
        });
      }
    };

    _this.state = {
      showContent: false
    };
    _this.parentsArticle = (0, _immutabilityHelper2.default)(props.parentsArticle, { $push: [props.permalink] });
    return _this;
  }

  SubArticleClass.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.props.className },
      _react2.default.createElement(
        'div',
        { className: this.state.showContent ? 'titleContent' : undefined, onClick: this.showContent, style: { cursor: 'pointer' } },
        _react2.default.createElement(_FAIcon.FALIcon, { name: 'angle-right' }),
        _react2.default.createElement(
          'span',
          { className: 'title' },
          this.props.text
        )
      ),
      this.state.showContent && _react2.default.createElement(_Article2.default, {
        searchKey: this.props.permalink,
        subArticle: true,
        className: 'subArticleContent',
        realm: this.props.realm,
        parentsArticle: this.parentsArticle,
        changeView: this.props.changeView,
        isInternal: this.props.isInternal
      })
    );
  };

  return SubArticleClass;
}(_react.Component);

var SubArticle = exports.SubArticle = (0, _styledComponents2.default)(SubArticleClass)(_templateObject);

SubArticleClass.propTypes = {
  changeView: _propTypes2.default.func,
  parentsArticle: _propTypes2.default.array,
  isInternal: _propTypes2.default.bool
};

SubArticleClass.defaultProps = {
  changeView: undefined,
  parentsArticle: [],
  isInternal: false
};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".btn-flat [class*=\" icon-\"],.btn-flat [class^=icon-]{margin-left:0;margin-right:0}", ""]);

// exports


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Section = __webpack_require__(480);

var _Section2 = _interopRequireDefault(_Section);

var _MainPage = __webpack_require__(479);

var _MainPage2 = _interopRequireDefault(_MainPage);

var _Article = __webpack_require__(368);

var _Article2 = _interopRequireDefault(_Article);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var HelpInternal = function (_Component) {
  _inherits(HelpInternal, _Component);

  function HelpInternal(props) {
    _classCallCheck(this, HelpInternal);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChangeView = function (searchKey, page) {
      _this.setState({ searchKey: searchKey, page: page });
    };

    _this.selectView = function () {
      if (_this.state.page === 'sezione') {
        return _react2.default.createElement(_Section2.default, {
          realm: _this.props.realm,
          changeView: _this.handleChangeView,
          onClickClose: _this.props.close,
          searchKey: _this.state.searchKey,
          embedded: _this.props.embedded
        });
      } else if (_this.state.page === 'articolo') {
        return _react2.default.createElement(_Article2.default, {
          realm: _this.props.realm,
          changeView: _this.handleChangeView,
          onClickClose: _this.props.close,
          searchKey: _this.state.searchKey,
          isInternal: _this.props.isInternal,
          embedded: _this.props.embedded
        });
      } else {
        return _react2.default.createElement(_MainPage2.default, {
          realm: _this.props.realm,
          changeView: _this.handleChangeView,
          onClickClose: _this.props.close,
          embedded: _this.props.embedded
        });
      }
    };

    if (props.embedded && props.params.type && props.params.id) {
      _this.state = {
        page: props.params.type,
        searchKey: props.params.id
      };
    } else {
      _this.state = {
        page: 'main'
      };
    }
    return _this;
  }

  HelpInternal.prototype.render = function render() {
    return this.props.loadData && this.selectView();
  };

  return HelpInternal;
}(_react.Component);

exports.default = HelpInternal;


HelpInternal.propTypes = {
  isInternal: _propTypes2.default.bool,
  realm: _propTypes2.default.string,
  close: _propTypes2.default.func,
  loadData: _propTypes2.default.bool,
  embedded: _propTypes2.default.bool
};

HelpInternal.defaultProps = {
  isInternal: false,
  realm: 'fic',
  close: undefined,
  loadData: false,
  embedded: false
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(63);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICTextButton.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICTextButton.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".btn-flat.fic-text-button{cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:12px}.btn-flat.fic-text-button.small{border-radius:4px;padding:3px 6px}.btn-flat.fic-text-button.medium{border-radius:4px;padding:5px 9px}.btn-flat.fic-text-button.large{border-radius:4px;padding:7px 14px;height:14px;max-height:14px}.btn-disabled{opacity:.6;pointer-events:none}", ""]);

// exports


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var buildDataSetObject = exports.buildDataSetObject = function buildDataSetObject(dataSet) {
  return _.mapKeys(dataSet || [], function (value, key) {
    return 'data-' + key;
  });
};

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICModal.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICModal.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "h4.modal-title{margin:0}.fic-modal{position:fixed;width:560px;background-color:#fff;border:1px solid rgba(0,0,0,.16);-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;outline:none;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.26);-moz-box-shadow:0 3px 15px rgba(0,0,0,.26);box-shadow:0 3px 15px rgba(0,0,0,.26);-webkit-background-clip:padding-box;-moz-background-clip:padding-box;background-clip:padding-box;padding:0;top:10%;left:0;right:0;bottom:auto;margin:auto;pointer-events:all;color:#555;top:-10%;-webkit-transition:opacity .3s linear,top .3s ease-out;-moz-transition:opacity .3s linear,top .3s ease-out;-o-transition:opacity .3s linear,top .3s ease-out;transition:opacity .3s linear,top .3s ease-out;visibility:hidden;opacity:0;transition:visibility .3s linear .3s,opacity .3s linear,top .3s ease-out;z-index:1050}.fic-modal-overlay.fic-modal-visible .fic-modal{top:10%;visibility:visible;opacity:1;transition-delay:0s}.fic-modal-overlay.fic-modal-hidden .fic-modal{top:30%;visibility:hidden;opacity:0;transition-delay:0s}.fic-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(55,55,55,.6);-webkit-transition:opacity .3s linear,top .3s ease-out;-moz-transition:opacity .3s linear,top .3s ease-out;-o-transition:opacity .3s linear,top .3s ease-out;transition:opacity .3s linear,top .3s ease-out;visibility:hidden;opacity:0;transition:visibility .3s linear .3s,opacity .3s linear,top .3s ease-out;z-index:1050;pointer-events:all}.fic-modal-overlay.fic-modal-visible{visibility:visible;opacity:1;transition-delay:0s}.fic-modal-overlay.fic-modal-closed,.fic-modal-overlay.fic-modal-hidden{visibility:hidden;opacity:0;transition-delay:0s}.fic-modal .modal-header{padding:15px}.fic-modal .modal-body{font-size:14px;z-index:1051;padding-bottom:20px;overflow-y:visible}.fic-modal.scrollable .modal-body{overflow:auto}.fic-modal .modal-footer{text-align:center;z-index:1051}.fic-modal .modal-footer .footer-item.left{float:left}.fic-modal .modal-footer .footer-item.left+.footer-item.left{margin-left:8px}.fic-modal .modal-footer .footer-item.center{float:none}.fic-modal .modal-footer .footer-item.center+.footer-item.center{margin-left:8px}.fic-modal .modal-footer .footer-item.right{float:right}.fic-modal .modal-footer .footer-item.right+.footer-item.right{margin-right:8px}.fic-modal .nav-tabs>li,.nav-pills>li{float:right}.fic-modal .modal-body .small-gray-message{font-size:12px;color:#888}", ""]);

// exports


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(68);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./FICModal.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./FICModal.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".FICModal2_Overlay{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(55,55,55,.6);-webkit-transition:opacity .3s linear,top .3s ease-out;-moz-transition:opacity .3s linear,top .3s ease-out;-o-transition:opacity .3s linear,top .3s ease-out;transition:opacity .3s linear,top .3s ease-out;visibility:hidden;opacity:0;transition:visibility .3s linear .3s,opacity .3s linear,top .3s ease-out;z-index:1050;pointer-events:all}.FICModal2_Overlay.fic-modal-visible .fic-modal{top:10%;visibility:visible;opacity:1;transition-delay:0s}.FICModal2_Overlay.fic-modal-hidden .fic-modal{top:30%;visibility:hidden;opacity:0;transition-delay:0s}.FICModal2_Overlay.fic-modal-visible{visibility:visible;opacity:1;transition-delay:0s}.FICModal2_Overlay.fic-modal-closed,.FICModal2_Overlay.fic-modal-hidden{visibility:hidden;opacity:0;transition-delay:0s}.FICModal2_Overlay .modal-header{border-bottom:1px solid #ebedee;padding:12px 16px}.FICModal2_Overlay .modal-header h4.modal-title{font-size:16px;margin:0;line-height:normal}.FICModal2_Overlay .fic-modal{position:fixed;z-index:1050;width:560px;background-color:#fff;border:1px solid rgba(0,0,0,.16);-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;outline:none;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.26);-moz-box-shadow:0 3px 15px rgba(0,0,0,.26);box-shadow:0 3px 15px rgba(0,0,0,.26);-webkit-background-clip:padding-box;-moz-background-clip:padding-box;background-clip:padding-box;padding:0;left:0;right:0;bottom:auto;margin:auto;pointer-events:all;color:#555;top:-10%;-webkit-transition:opacity .3s linear,top .3s ease-out;-moz-transition:opacity .3s linear,top .3s ease-out;-o-transition:opacity .3s linear,top .3s ease-out;transition:visibility .3s linear .3s,opacity .3s linear,top .3s ease-out;visibility:hidden;opacity:0}.FICModal2_Overlay .fic-modal .modal-header{padding:15px}.FICModal2_Overlay .fic-modal .modal-body{font-size:14px;z-index:1051;overflow-y:visible;padding:35px}.FICModal2_Overlay .fic-modal.scrollable .modal-body{overflow:auto}.FICModal2_Overlay .fic-modal .modal-footer{text-align:center;z-index:1051}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.left{float:left}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.left+.footer-item.left{margin-left:8px}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.center{float:none}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.center+.footer-item.center{margin-left:8px}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.right{float:right}.FICModal2_Overlay .fic-modal .modal-footer .footer-item.right+.footer-item.right{margin-right:8px}.FICModal2_Overlay .fic-modal .modal-footer .nav-pills>li,.FICModal2_Overlay .fic-modal .modal-footer .nav-tabs>li{float:right}.FICModal2_Overlay .fic-modal .modal-body .small-gray-message{font-size:12px;color:#888}.FICModal2_Overlay .modal-footer{border-top:1px solid #ebedee;padding:12px 16px;min-height:32px}.FICModal2_Overlay .modal-footer .footer-item{font-size:14px}", ""]);

// exports


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./Alert.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/cjs.js!./Alert.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".s-alert-box,.s-alert-box *{box-sizing:border-box}.s-alert-box{position:fixed;padding:22px 30px 22px 22px;line-height:1.4;pointer-events:none;font-size:13px;max-width:300px;-webkit-transition:top .4s,bottom .4s;transition:top .4s,bottom .4s;font-family:inherit;width:auto;z-index:1050;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;outline:none;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.26);-moz-box-shadow:0 3px 15px rgba(0,0,0,.26);box-shadow:0 3px 15px rgba(0,0,0,.26);-webkit-background-clip:padding-box;-moz-background-clip:padding-box;background-clip:padding-box;background-color:#fff;border:none;border-left-width:6px;border-left-style:solid;color:#555;font-weight:600}.s-alert-box .s-alert-box-inner{display:flex;flex-direction:row;align-items:center}.s-alert-box .icon{width:30px}.s-alert-box .text{width:calc(100% - 30px)}.s-alert-box .icon,.s-alert-box .text{display:inline-block;vertical-align:top}.s-alert-box .fa{font-size:19px;margin-right:5px}.s-alert-box.s-alert-show{pointer-events:auto}.s-alert-box a{color:inherit;opacity:.7;font-weight:700}.s-alert-box a:focus,.s-alert-box a:hover{opacity:1}.s-alert-box p{margin:0}.s-alert-box.s-alert-show,.s-alert-box.s-alert-visible{pointer-events:auto}.s-alert-close{width:20px;height:20px;position:absolute;right:4px;top:4px;overflow:hidden;text-indent:100%;cursor:pointer;-webkit-backface-visibility:hidden;backface-visibility:hidden}.s-alert-close:focus,.s-alert-close:hover{outline:none}.s-alert-close:after,.s-alert-close:before{content:\"\";position:absolute;width:3px;height:60%;top:50%;left:50%;background:#333}.s-alert-close:before{-webkit-transform:translate(-50%,-50%) rotate(45deg);transform:translate(-50%,-50%) rotate(45deg)}.s-alert-close:after{-webkit-transform:translate(-50%,-50%) rotate(-45deg);transform:translate(-50%,-50%) rotate(-45deg)}.s-alert-bottom-left{top:auto;right:auto;bottom:30px;left:30px}.s-alert-top-left{top:30px;right:auto;bottom:auto;left:30px}.s-alert-top-right{top:30px;right:30px;bottom:auto;left:auto}.s-alert-bottom-right{top:auto;right:30px;bottom:30px;left:auto}.s-alert-bottom{bottom:0;top:auto}.s-alert-bottom,.s-alert-top{width:100%;max-width:100%;left:0;right:0}.s-alert-top{top:0;bottom:auto}.s-alert-info{border-left-color:#5087a2}.s-alert-info b.fa{color:#5087a2}.s-alert-success{border-left-color:#4cbe00}.s-alert-success b.fa{color:#4cbe00}.s-alert-warning{border-left-color:#ffb800}.s-alert-warning b.fa{color:#ffb800}.s-alert-error{border-left-color:#e72500}.s-alert-error b.fa{color:#e72500}.s-alert-info>.s-alert-close:after,.s-alert-info>.s-alert-close:before,.s-alert-info>.s-alert-close:hover:after,.s-alert-info>.s-alert-close:hover:before{background:#5087a2}.s-alert-success>.s-alert-close:after,.s-alert-success>.s-alert-close:before,.s-alert-success>.s-alert-close:hover:after,.s-alert-success>.s-alert-close:hover:before{background:#4cbe00}.s-alert-warning>.s-alert-close:after,.s-alert-warning>.s-alert-close:before,.s-alert-warning>.s-alert-close:hover:after,.s-alert-warning>.s-alert-close:hover:before{background:#ffb800}.s-alert-error>.s-alert-close:after,.s-alert-error>.s-alert-close:before,.s-alert-error>.s-alert-close:hover:after,.s-alert-error>.s-alert-close:hover:before{background:#e72500}[class*=\" s-alert-effect-\"].s-alert-hide,[class^=s-alert-effect-].s-alert-hide{-webkit-animation-direction:reverse;animation-direction:reverse}.s-alert-box-height{visibility:hidden;position:fixed}", ""]);

// exports


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FICFormField = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FICFormNode = function FICFormNode(props) {
  var config = props.config,
      schema = props.schema;

  var nodeProps = _extends({}, props);
  // Load config
  var nodeConfig = config.components[schema.type];
  if (!nodeConfig) {
    console.error('FICForm: Component config not found for type \'' + schema.type + '\'.');
    return null;
  }
  // Generate items if list
  if (nodeConfig.role === 'list') {
    var ItemComponent = nodeConfig.itemComponent;
    var items = schema.items.map(function (itemSchema, idx) {
      var itemProps = _extends({}, nodeProps, { schema: itemSchema });

      var validationFields = [];
      if (itemSchema.handleChildrenValidation) {
        itemProps.hideValidation = true;

        if (itemSchema.items) {
          validationFields = itemSchema.items.map(function (item) {
            return item.name;
          });
        }
      }

      return _react2.default.createElement(
        ItemComponent,
        {
          key: idx,
          flex: itemSchema.flex || undefined,
          style: { display: itemSchema.isVisible === false ? 'none' : 'block' },
          className: itemSchema.className,
          validation: itemSchema.handleChildrenValidation ? nodeProps.validation : undefined,
          validationFields: itemSchema.handleChildrenValidation ? validationFields : undefined
        },
        _react2.default.createElement(FICFormNode, itemProps)
      );
    });

    // Wrap list into component
    var Component = nodeConfig.component;
    var LabelComponent = nodeConfig.labelComponent;
    return _react2.default.createElement(
      Component,
      null,
      _react2.default.createElement(LabelComponent, { schema: schema }),
      items
    );
  }

  // Return form field if field
  if (nodeConfig.role === 'field') {
    var FieldComponent = nodeConfig.fieldComponent || _FICFormField.FICFormField;
    return _react2.default.createElement(FieldComponent, nodeProps);
  }
};

FICFormNode.defaultProps = {
  config: {},
  schema: {},
  data: {},
  onChange: undefined,
  validation: {},
  formOptions: {}
};

FICFormNode.propTypes = {
  config: _propTypes2.default.object,
  schema: _propTypes2.default.object,
  data: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  validation: _propTypes2.default.object,
  formOptions: _propTypes2.default.object
};

exports.default = FICFormNode;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = exports.FICFormBlockItem = exports.FICFormBlock = exports.FICFormRowItem = exports.FICFormRow = exports.FICFormColumnItem = exports.FICFormColumn = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 6px;\n'], ['\n  display: block;\n  color: ', ';\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  margin-top: 6px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: block;\n  // flex-direction: column;  \n'], ['\n  display: block;\n  // flex-direction: column;  \n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  // flex: ', ';\n  display: ', ';\n  & + & {\n    margin-top: 16px;\n  }\n'], ['\n  // flex: ', ';\n  display: ', ';\n  & + & {\n    margin-top: 16px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n'], ['\n  display: flex;\n  flex-direction: row;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  flex: ', ';\n  display: ', ';\n  & + & {\n    margin-left: 16px;\n  }\n'], ['\n  flex: ', ';\n  display: ', ';\n  & + & {\n    margin-left: 16px;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  flex: ', ';\n  &:first-child{\n    input{\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  & + &:not(:last-child) {\n    input{\n      margin-left: 0;\n      border-radius: 0;\n      border-left: none;\n    }\n  }\n  &:last-child{\n    input{\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-left: none;\n    }\n  }\n'], ['\n  flex: ', ';\n  &:first-child{\n    input{\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  & + &:not(:last-child) {\n    input{\n      margin-left: 0;\n      border-radius: 0;\n      border-left: none;\n    }\n  }\n  &:last-child{\n    input{\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-left: none;\n    }\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _validate = __webpack_require__(51);

var _validate2 = _interopRequireDefault(_validate);

var _FICFormField = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ValidationMessage = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__ValidationMessage',
  componentId: 'tmtkte-0'
})(_templateObject, _FICColors2.default.form.field.validationMessage);

var renderValidationMessage = function renderValidationMessage(validations, validationFields) {
  if (!validations) {
    return null;
  }
  return _lodash2.default.map(validationFields, function (field) {
    return _react2.default.createElement(
      ValidationMessage,
      { key: 'message_' + field },
      validations[field]
    );
  });
};

var FICFormListLabel = function FICFormListLabel(_ref) {
  var schema = _ref.schema;

  if (!schema || !schema.label) {
    return null;
  }
  return _react2.default.createElement(
    _FICFormField.Label,
    { key: 'label' },
    schema.label === '' ? _react2.default.createElement(
      'span',
      null,
      '\xA0'
    ) : schema.label
  );
};

/** ---- Default layout elements ---- **/

/** Column - Stampa elementi in colonna **/

var FICFormColumnItemImpl = function FICFormColumnItemImpl(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    props.children,
    renderValidationMessage(props.validation, props.validationFields)
  );
};

FICFormColumnItemImpl.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  validation: _propTypes2.default.object,
  validationFields: _propTypes2.default.array
};

var FICFormColumn = exports.FICFormColumn = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__FICFormColumn',
  componentId: 'tmtkte-1'
})(_templateObject2);

var FICFormColumnItem = exports.FICFormColumnItem = (0, _styledComponents2.default)(FICFormColumnItemImpl)(_templateObject3, function (props) {
  return props.flex || 1;
}, function (props) {
  return props.style.display || 'block';
});

/** Row - Stampa elementi in riga **/

var FICFormRow = exports.FICFormRow = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__FICFormRow',
  componentId: 'tmtkte-2'
})(_templateObject4);

var FICFormRowItem = exports.FICFormRowItem = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__FICFormRowItem',
  componentId: 'tmtkte-3'
})(_templateObject5, function (props) {
  return props.flex || 1;
}, function (props) {
  return props.style.display || 'block';
});

/** Block - [MOLTO CUSTOM] Serve per appiccicare input in riga **/

var FICFormBlock = exports.FICFormBlock = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__FICFormBlock',
  componentId: 'tmtkte-4'
})(_templateObject6);

var FICFormBlockItem = exports.FICFormBlockItem = _styledComponents2.default.div.withConfig({
  displayName: 'defaults__FICFormBlockItem',
  componentId: 'tmtkte-5'
})(_templateObject7, function (props) {
  return props.flex || 1;
});

/** ---- Default config ---- **/

var defaultConfig = exports.defaultConfig = {
  components: {
    column: {
      role: 'list',
      component: FICFormColumn,
      itemComponent: FICFormColumnItem,
      labelComponent: FICFormListLabel
    },
    row: {
      role: 'list',
      component: FICFormRow,
      itemComponent: FICFormRowItem,
      labelComponent: FICFormListLabel
    },
    block: {
      role: 'list',
      component: FICFormBlock,
      itemComponent: FICFormBlockItem,
      labelComponent: FICFormListLabel
    }
  },
  customValidators: {}
};

_validate2.default.validators.presence.message = '^Il campo è obbligatorio';

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FICInputText = __webpack_require__(34);

var _FICInputText2 = _interopRequireDefault(_FICInputText);

var _FICRadioGroup = __webpack_require__(37);

var _FICRadioGroup2 = _interopRequireDefault(_FICRadioGroup);

var _FICCheckbox = __webpack_require__(36);

var _FICCheckbox2 = _interopRequireDefault(_FICCheckbox);

var _validation = __webpack_require__(56);

var _validation2 = _interopRequireDefault(_validation);

var _FICAutocomplete = __webpack_require__(26);

var _FICAutocomplete2 = _interopRequireDefault(_FICAutocomplete);

var _FICSelect = __webpack_require__(52);

var _FICSelect2 = _interopRequireDefault(_FICSelect);

var _FICFileUploader = __webpack_require__(31);

var _FICFileUploader2 = _interopRequireDefault(_FICFileUploader);

var _FICButton = __webpack_require__(23);

var _FICButton2 = _interopRequireDefault(_FICButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

var LargeInputText = function LargeInputText(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ['size']);

  return _react2.default.createElement(_FICInputText2.default, _extends({}, props, {
    size: 'large'
  }));
};

/* eslint-enable react/prop-types */

var config = exports.config = {
  components: {
    'text': {
      role: 'field',
      component: _FICInputText2.default
    },
    'text-large': {
      role: 'field',
      component: LargeInputText
    },
    'radio': {
      role: 'field',
      component: _FICRadioGroup2.default
    },
    'checkbox': {
      role: 'field',
      component: _FICCheckbox2.default
    },
    'autocomplete': {
      role: 'field',
      component: _FICAutocomplete2.default
    },
    'select': {
      role: 'field',
      component: _FICSelect2.default
    },
    'uploader': {
      role: 'field',
      component: _FICFileUploader2.default
    },
    'button': {
      role: 'field',
      component: _FICButton2.default
    }
  },
  customValidators: {
    itTaxCode: function itTaxCode(value) {
      if (!value) return '';
      return !_validation2.default.itTaxCode(value) ? '^Codice fiscale non corretto' : '';
    },
    itVatNumber: function itVatNumber(value) {
      if (!value) return '';
      return !_validation2.default.itVatNumber(value) ? '^Partita IVA non corretta' : '';
    },
    isEmail: function isEmail(value) {
      if (!value) return '';
      return !_validation2.default.isEmail(value) ? '^Email non valida' : '';
    }
  }
};

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightIcon = exports.LefIcon = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute !important;\n  color: ', ';\n  line-height: ', 'px;\n  font-size: 12px;\n  ', '\n'], ['\n  position: absolute !important;\n  color: ', ';\n  line-height: ', 'px;\n  font-size: 12px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    cursor: not-allowed;\n  '], ['\n    color: ', ';\n    cursor: not-allowed;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  left: 10px !important;\n  right: auto;\n  z-index: 1;\n'], ['\n  left: 10px !important;\n  right: auto;\n  z-index: 1;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  right: 10px !important;\n  ', '\n  ', '\n'], ['\n  right: 10px !important;\n  ', '\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    color:', ';\n  '], ['\n    color:', ';\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputTextIcon = (0, _styledComponents2.default)(function (_ref) {
  var size = _ref.size,
      isDisabled = _ref.isDisabled,
      props = _objectWithoutProperties(_ref, ['size', 'isDisabled']);

  return _react2.default.createElement(_FICIcon2.default, props);
})(_templateObject, _FICColors2.default.text.gray, function (props) {
  return props.size !== 'large' ? 30 : 40;
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject2, _FICColors2.default.inputDisabledText);
});

var LefIcon = exports.LefIcon = (0, _styledComponents2.default)(InputTextIcon)(_templateObject3);

var RightIcon = (0, _styledComponents2.default)(function (_ref2) {
  var isValid = _ref2.isValid,
      props = _objectWithoutProperties(_ref2, ['isValid']);

  return _react2.default.createElement(InputTextIcon, props);
})(_templateObject4, function (props) {
  return props.isValid === true && (0, _styledComponents.css)(_templateObject5, _FICColors2.default.blue);
}, function (props) {
  return props.isValid === false && (0, _styledComponents.css)(_templateObject5, _FICColors2.default.red);
});
exports.RightIcon = RightIcon;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightText = exports.LeftText = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute!important;\n  color: ', ';\n  cursor: default;\n  ', '\n'], ['\n  position: absolute!important;\n  color: ', ';\n  cursor: default;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    top:28%;\n  '], ['\n    top:28%;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  left: 7px!important;\n  right: auto;\n  z-index: 1;\n'], ['\n  left: 7px!important;\n  right: auto;\n  z-index: 1;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  right: 7px!important;\n'], ['\n  right: 7px!important;\n']);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sidetext = _styledComponents2.default.span.withConfig({
  displayName: 'sideText__Sidetext',
  componentId: 'sc-1cficlw-0'
})(_templateObject, _FICColors2.default.placeholder, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject2);
});

var LeftText = exports.LeftText = (0, _styledComponents2.default)(Sidetext)(_templateObject3);

var RightText = exports.RightText = (0, _styledComponents2.default)(Sidetext)(_templateObject4);

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  & + & {\n    margin-top:', 'px;\n  }\n  ', '\n'], ['\n  & + & {\n    margin-top:', 'px;\n  }\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: top;\n    &:not(:first-child){\n      margin-left: 25px;\n    }\n  '], ['\n    display: inline-block;\n    vertical-align: top;\n    &:not(:first-child){\n      margin-left: 25px;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-bottom: 4px;\n  cursor: pointer;\n  display: inline-block;\n'], ['\n  margin-bottom: 4px;\n  cursor: pointer;\n  display: inline-block;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n  padding-left: 8px;\n  vertical-align: top;\n  ', '\n'], ['\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n  padding-left: 8px;\n  vertical-align: top;\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    color: ', ';\n    cursor: not-allowed;\n  '], ['\n    color: ', ';\n    cursor: not-allowed;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: inline-block;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 8px;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  ', '\n  ', '\n'], ['\n  display: inline-block;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 8px;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  ', '\n  ', '\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    border: 5px solid ', ';\n  '], ['\n    border: 5px solid ', ';\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    border-color: ', ';\n    cursor: not-allowed;\n    ', '\n  '], ['\n    background-color: ', ';\n    border-color: ', ';\n    cursor: not-allowed;\n    ', '\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n    ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function FICRadioImpl(props) {
  return _react2.default.createElement(
    'div',
    {
      className: props.className,
      onClick: function onClick() {
        return !props.isDisabled ? props.onClick() : undefined;
      }
    },
    props.renderOption ? props.renderOption(props) : renderOption(props)
  );
}

function renderOption(props) {
  return _react2.default.createElement(
    Option,
    null,
    _react2.default.createElement(Radio, { isChecked: props.isChecked, isDisabled: props.isDisabled }),
    _react2.default.createElement(
      Label,
      { isDisabled: props.isDisabled },
      props.label
    )
  );
}

var FICRadio = (0, _styledComponents2.default)(FICRadioImpl)(_templateObject, function (props) {
  return props.optionsSpacing;
}, function (props) {
  return props.inline && (0, _styledComponents.css)(_templateObject2);
});

var Option = _styledComponents2.default.div.withConfig({
  displayName: 'FICRadio__Option',
  componentId: 'sc-12aayqv-0'
})(_templateObject3);

var Label = _styledComponents2.default.span.withConfig({
  displayName: 'FICRadio__Label',
  componentId: 'sc-12aayqv-1'
})(_templateObject4, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject5, _FICColors2.default.inputDisabledText);
});

var Radio = _styledComponents2.default.span.withConfig({
  displayName: 'FICRadio__Radio',
  componentId: 'sc-12aayqv-2'
})(_templateObject6, _FICColors2.default.white, _FICColors2.default.borderColor, function (props) {
  return props.isChecked && (0, _styledComponents.css)(_templateObject7, _FICColors2.default.blue);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject8, _FICColors2.default.inputDisabled, _FICColors2.default.inputDisabled, function (props) {
    return props.isChecked && (0, _styledComponents.css)(_templateObject9, _FICColors2.default.white, _FICColors2.default.button.primary.blue.disabled);
  });
});

FICRadioImpl.propTypes = FICRadio.propTypes = renderOption.propTypes = {
  isDisabled: _propTypes2.default.bool,
  isChecked: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  inline: _propTypes2.default.bool
  /* data: PropTypes.object,
  onClick: PropTypes.func,
  optionsSpacing: PropTypes.number */
};

FICRadioImpl.defaultProps = FICRadio.defaultProps = renderOption.defaultProps = {
  isDisabled: false,
  isChecked: false,
  data: undefined,
  onClick: undefined,
  optionsSpacing: 0,
  label: '',
  inline: false
};

exports.default = FICRadio;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutocompleteOption = exports.AutocompleteMenu = exports.MenuOuter = exports.FICAutocomplete = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  input{\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 4px;\n    width: 100%;\n    color: ', ';\n    height: 30px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    padding: 4px 8px;\n    box-sizing: border-box;\n    ', '\n    ', '\n    ', '\n    &:focus{\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      ', '\n    }\n    &::placeholder{\n      color: ', ';\n      font-size: 14px;\n    }\n  }\n'], ['\n  input{\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 4px;\n    width: 100%;\n    color: ', ';\n    height: 30px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    text-align: left;\n    padding: 4px 8px;\n    box-sizing: border-box;\n    ', '\n    ', '\n    ', '\n    &:focus{\n      border-color:', ';\n      box-shadow: 0 0 0 2px ', '3D,0 0 0 0px ', ',inset 0 1px 2px 0 rgba(51,51,51,0.12);\n      ', '\n    }\n    &::placeholder{\n      color: ', ';\n      font-size: 14px;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      height: 40px;\n      font-size: 16px;\n    '], ['\n      height: 40px;\n      font-size: 16px;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      border-color:', ';\n      box-shadow: 0 0 2px ', ';\n    '], ['\n      border-color:', ';\n      box-shadow: 0 0 2px ', ';\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      cursor: not-allowed;\n    '], ['\n      background-color: ', ';\n      cursor: not-allowed;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        border-color:', ';\n        box-shadow: 0 0 2px ', ';\n      '], ['\n        border-color:', ';\n        box-shadow: 0 0 2px ', ';\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  border: ', ';\n  background-color: ', ';\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: 0;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n  overflow-x: hidden;\n  overflow-y: visible;\n'], ['\n  border: ', ';\n  background-color: ', ';\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: 0;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n  overflow-x: hidden;\n  overflow-y: visible;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n'], ['\n  box-sizing: border-box;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  padding: 5px 10px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  ', '\n  &:active{\n    background-color: rgba(0, 124, 228, 0.1);\n  }\n'], ['\n  padding: 5px 10px;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  ', '\n  &:active{\n    background-color: rgba(0, 124, 228, 0.1);\n  }\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    background-color: ', ';\n    color: ', ';\n  '], ['\n    background-color: ', ';\n    color: ', ';\n  ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FICAutocomplete = __webpack_require__(26);

var _FICStyles = __webpack_require__(24);

var _FICStyles2 = _interopRequireDefault(_FICStyles);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FICAutocomplete = exports.FICAutocomplete = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(_FICAutocomplete.FICAutocompleteImpl, props);
})(_templateObject, _FICColors2.default.white, _FICColors2.default.borderColor, _FICColors2.default.black, function (props) {
  return props.size === 'large' && (0, _styledComponents.css)(_templateObject2);
}, function (props) {
  return props.isValid === false && (0, _styledComponents.css)(_templateObject3, _FICColors2.default.red, _FICColors2.default.red);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(_templateObject4, _FICColors2.default.inputDisabled);
}, _FICColors2.default.blue, _FICColors2.default.blue, _FICColors2.default.blue, function (props) {
  return props.isValid === false && (0, _styledComponents.css)(_templateObject5, _FICColors2.default.red, _FICColors2.default.red);
}, _FICColors2.default.placeholder);

var MenuOuter = exports.MenuOuter = _styledComponents2.default.div.withConfig({
  displayName: 'style__MenuOuter',
  componentId: 'jj23v0-0'
})(_templateObject6, _FICStyles2.default.border, _FICColors2.default.white);

var AutocompleteMenu = exports.AutocompleteMenu = _styledComponents2.default.div.withConfig({
  displayName: 'style__AutocompleteMenu',
  componentId: 'jj23v0-1'
})(_templateObject7);

var AutocompleteOption = exports.AutocompleteOption = _styledComponents2.default.div.withConfig({
  displayName: 'style__AutocompleteOption',
  componentId: 'jj23v0-2'
})(_templateObject8, function (props) {
  return props.focus && (0, _styledComponents.css)(_templateObject9, _FICColors2.default.deepBlue, _FICColors2.default.white);
});

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getComponentsStyles = getComponentsStyles;
exports.getControlComponentStyle = getControlComponentStyle;

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComponentsStyles(props) {
  var componentsFixedStyle = {
    container: { border: 'none' },
    control: {
      height: '100%',
      minHeight: 'unset',
      lineHeight: '24px',
      '>div': { height: 30 }
    },
    singleValue: { margin: 0 },
    menu: { zIndex: 99 },
    menuList: {},
    option: {
      paddingRight: 30,
      cursor: 'pointer',
      '&:hover, &:active': {
        backgroundColor: _FICColors2.default.gray
      }
    },
    clearIndicator: {
      marginTop: '8px',
      cursor: 'pointer'
    }
  };

  return {
    container: function container(baseStyle) {
      return _extends({}, baseStyle, props.style, componentsFixedStyle.container);
    },
    control: function control(baseStyle, state) {
      return _extends({}, baseStyle, componentsFixedStyle.control, getControlComponentStyle(state, props));
    },
    singleValue: function singleValue(baseStyle) {
      return _extends({}, baseStyle, componentsFixedStyle.singleValue);
    },
    menu: function menu(baseStyle) {
      return _extends({}, baseStyle, componentsFixedStyle.menu);
    },
    menuList: function menuList(baseStyle) {
      return _extends({}, baseStyle, componentsFixedStyle.menuList);
    },
    option: function option(baseStyle, state) {
      return _extends({}, baseStyle, componentsFixedStyle.option, getOptionComponentStyle(state));
    },
    clearIndicator: function clearIndicator(baseStyle) {
      return _extends({}, baseStyle, componentsFixedStyle.clearIndicator);
    }
  };
}

function getControlComponentStyle(state, props) {
  var style = {};
  if (props.isValid === false) {
    style = _extends({}, style, {
      borderColor: _FICColors2.default.red,
      boxShadow: '0 0 4px ' + _FICColors2.default.red,
      ':focus': {
        borderColor: _FICColors2.default.red,
        boxShadow: '0 0 4px ' + _FICColors2.default.red
      }
    });
  }

  var disabledControlStyle = {
    backgroundColor: _FICColors2.default.inputDisabled,
    cursor: 'not-allowed',
    borderColor: _FICColors2.default.inputDisabled,
    pointerEvents: 'all',
    ':hover': {
      borderColor: _FICColors2.default.inputDisabled
    }
  };

  var borderColor = props.isValid === false ? _FICColors2.default.red : _FICColors2.default.blue;

  var customControlStyle = {
    borderColor: state.isFocused ? borderColor : props.isValid === false ? _FICColors2.default.red : _FICColors2.default.borderColor,
    boxShadow: props.isValid === false || state.isFocused ? '0 0 0 2px ' + borderColor + '3D,0 0 0 0px ' + borderColor + ',inset 0 1px 2px 0 rgba(51,51,51,0.12);' : 'none',
    ':hover': {
      borderColor: state.isFocused ? borderColor : props.isValid === false ? _FICColors2.default.red : _FICColors2.default.borderColor
    }
  };

  style = state.isDisabled ? _extends({}, style, disabledControlStyle) : _extends({}, style, customControlStyle);

  return style;
}

function getOptionComponentStyle(state) {
  var style = {};

  if (state.isFocused) {
    style.backgroundColor = 'transparent';
  }

  if (state.isSelected) {
    style.backgroundColor = _FICColors2.default.lightBlue;
    style.color = _FICColors2.default.blue;
    style.display = 'flex';
    style.alignItems = 'center';
    style['&:hover'] = { backgroundColor: _FICColors2.default.lightBlue };
    style['.fa, .icon'] = { display: 'inline!important' };
  }

  return style;
}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MixPanelTracker = function () {
  function MixPanelTracker() {
    var _this = this;

    _classCallCheck(this, MixPanelTracker);

    this.optOutTracking = function () {
      _this.execute('opt_out_tracking');
    };

    this.hasOptedOutTracking = function () {
      _this.execute('has_opted_out_tracking');
    };

    this.setConfig = function (config) {
      _this.execute('set_config', config);
    };

    this.register = function (data) {
      _this.execute('register', data);
    };

    this.registerOnce = function (data) {
      _this.execute('register_once', data);
    };

    this.track = function (name, data) {
      _this.execute('track', name, data);
    };

    this.trackWithDelay = function (name, data, delay) {
      if (!delay) {
        delay = 2000;
      }

      setTimeout(_this.track(name, data), delay);
    };

    this.trackLinks = function (selector, name, data) {
      _this.execute('track_links', selector, name, data);
    };
  }

  MixPanelTracker.prototype.execute = function execute(method) {
    var _mixpanel;

    // debugger
    if (typeof mixpanel === 'undefined') {
      console.info('MixPanel is not initialized.');
      return;
    }

    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return (_mixpanel = mixpanel)[method].apply(_mixpanel, params);
  };

  return MixPanelTracker;
}();

exports.default = MixPanelTracker;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandIcon = exports.LightIcon = exports.RegularIcon = exports.SolidIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = __webpack_require__(22);

var _classnames2 = _interopRequireDefault(_classnames);

var _FICColors = __webpack_require__(5);

var _FICColors2 = _interopRequireDefault(_FICColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var prefixMapping = {
  solid: 'fas',
  regular: 'far',
  light: 'fal',
  brand: 'fab',
  duotone: 'fad'

  // TODO: dove vengono usati style, className e onClick? Li lasciamo?

};var FICIconImpl = function FICIconImpl(_ref) {
  var name = _ref.name,
      type = _ref.type,
      className = _ref.className,
      spin = _ref.spin,
      fixedWidth = _ref.fixedWidth,
      style = _ref.style,
      domProps = _ref.domProps,
      onClick = _ref.onClick,
      iconProps = _objectWithoutProperties(_ref, ['name', 'type', 'className', 'spin', 'fixedWidth', 'style', 'domProps', 'onClick']);

  var prefix = prefixMapping[type];
  if (spin) {
    name = 'circle-notch';
  }

  var classes = ['Icon', prefix, 'fa-' + name, spin ? 'fa-spin' : undefined, fixedWidth ? 'fa-fw' : undefined, className];
  return _react2.default.createElement('b', _extends({
    className: (0, _classnames2.default)(classes),
    style: style,
    onClick: onClick
  }, domProps, iconProps));
};

var FICIcon = (0, _styledComponents2.default)(FICIconImpl)(_templateObject, function (props) {
  return _FICColors2.default[props.color] || props.color || undefined;
}, function (props) {
  return props.size ? props.size + 'px' : undefined;
});

FICIcon.propTypes = FICIconImpl.propTypes = {
  type: _propTypes2.default.oneOf(['solid', 'regular', 'light', 'brand', 'duotone']),
  /** According to font-awensome set the name */
  name: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  /** Set true to enable spin */
  spin: _propTypes2.default.bool,
  fixedWidth: _propTypes2.default.bool,
  domProps: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  /** Set the color of the icon */
  color: _propTypes2.default.string,
  /** Set the size in px */
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

FICIcon.defaultProps = FICIconImpl.defaultProps = {
  type: 'regular',
  name: '',
  className: '',
  style: {},
  spin: false,
  fixedWidth: false,
  domProps: {},
  onClick: undefined,
  color: undefined,
  size: undefined
};

var SolidIcon = exports.SolidIcon = function SolidIcon(props) {
  return _react2.default.createElement(FICIcon, _extends({ type: 'solid' }, props));
};

var RegularIcon = exports.RegularIcon = function RegularIcon(props) {
  return _react2.default.createElement(FICIcon, _extends({ type: 'regular' }, props));
};

var LightIcon = exports.LightIcon = function LightIcon(props) {
  return _react2.default.createElement(FICIcon, _extends({ type: 'light' }, props));
};

var BrandIcon = exports.BrandIcon = function BrandIcon(props) {
  return _react2.default.createElement(FICIcon, _extends({ type: 'brand' }, props));
};

exports.default = FICIcon;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HotjarTracker = function () {
  function HotjarTracker() {
    var _this = this;

    _classCallCheck(this, HotjarTracker);

    this.trigger = function (name) {
      _this.execute('trigger', name);
    };
  }

  HotjarTracker.prototype.execute = function execute(method) {
    if (typeof hj === 'undefined') {
      console.info('Hotjar is not initialized.');
      return;
    }

    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    return hj.apply(undefined, [method].concat(params));
  };

  return HotjarTracker;
}();

exports.default = HotjarTracker;

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TagManagerTracker = function () {
  function TagManagerTracker() {
    var _this = this;

    _classCallCheck(this, TagManagerTracker);

    this.view = function (category, label) {
      _this.execute('visualizzazione', category, label);
    };

    this.click = function (category, label, action) {
      _this.execute(action || 'click', category, label);
    };
  }

  TagManagerTracker.prototype.execute = function execute(action, category, label) {
    // debugger
    if (typeof dataLayer === 'undefined') {
      console.info('Tag Manager is not initialized.');
      return;
    }
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      category: category,
      action: action,
      label: label
    });
  };

  return TagManagerTracker;
}();

exports.default = TagManagerTracker;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _deepEqual = __webpack_require__(117);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FICUtils = function FICUtils() {
  _classCallCheck(this, FICUtils);
};

FICUtils.orderedCompare = function (object1, object2) {
  return JSON.stringify(object1) == JSON.stringify(object2);
};

FICUtils.compare = function (object1, object2) {
  return (0, _deepEqual2.default)(object1, object2);
};

FICUtils.arrayByDeletingItem = function (array, idx) {
  var newArray = array.slice();
  newArray.splice(idx, 1);
  return newArray;
};

FICUtils.arrayByReplacingItem = function (array, idx, newValue) {
  var newArray = array.slice();
  newArray[idx] = newValue;
  return newArray;
};

/* FICUtils.clone = (object) => {
  return Object.assign({}, object)
} */

FICUtils.clone = function (object) {
  return _lodash2.default.cloneDeep(object);
};

FICUtils.setNavigationAddress = function (address) {
  window.history.pushState(null, null, '/' + address);
};

FICUtils.randomBetween = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

FICUtils.selectListFromArray = function (list) {
  if (!list) {
    return [];
  }
  return list.map(function (item) {
    return { value: item, label: item };
  });
};

FICUtils.selectListFromSimpleList = function (list) {
  if (!list) {
    return [];
  }
  return list.map(function (item) {
    return { value: item.id, label: item.nome };
  });
};

FICUtils.engToItDate = function (input) {
  return (0, _moment2.default)(input, 'Y-M-D', true).format('DD/MM/YYYY');
};

FICUtils.itToEngDate = function (input) {
  return (0, _moment2.default)(input, 'D/M/Y', true).format('YYYY-MM-DD');
};

FICUtils.engToItDatetime = function (input) {
  return (0, _moment2.default)(input, 'Y-M-D H:m:s').format('DD/MM/YYYY HH:mm:ss');
};

FICUtils.itToEngDatetime = function (input) {
  return (0, _moment2.default)(input, 'D/M/Y H:m:s').format('YYYY-MM-DD HH:mm:ss');
};

FICUtils.todayEngDate = function () {
  function pad(s) {
    return s < 10 ? '0' + s : s;
  }

  var d = new Date();
  return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
};

FICUtils.todayItDate = function () {
  function pad(s) {
    return s < 10 ? '0' + s : s;
  }

  var d = new Date();
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
};

FICUtils.parseDate = function (text) {
  var date = (0, _moment2.default)(text, 'D/M/Y', true);
  if (date.isValid()) {
    date = (0, _moment2.default)(date.format('DD/MM/YY'), 'DD/MM/YY', true);
    date = date.format('DD/MM/YYYY');
    return date;
  }
  return null;
};

FICUtils.controllaPIVA = function (pi) {
  var validi = void 0,
      i = void 0,
      s = void 0,
      c = void 0;
  if (pi == '') {
    return '';
  }
  if (pi.indexOf('IT') == 0) {
    pi = pi.substring(2);
  }
  if (pi.length != 11) {
    return 'La lunghezza della partita IVA non è\n' + 'corretta: la partita IVA dovrebbe essere lunga\n' + 'esattamente 11 caratteri.\n';
  }
  validi = '0123456789';
  for (i = 0; i < 11; i++) {
    if (validi.indexOf(pi.charAt(i)) == -1) {
      return 'La partita IVA contiene il carattere non valido \'' + pi.charAt(i) + '\'.\nI caratteri validi sono le cifre.\n';
    }
  }
  s = 0;
  for (i = 0; i <= 9; i += 2) {
    s += pi.charCodeAt(i) - '0'.charCodeAt(0);
  }
  for (i = 1; i <= 9; i += 2) {
    c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
    if (c > 9) {
      c = c - 9;
    }
    s += c;
  }
  if ((10 - s % 10) % 10 != pi.charCodeAt(10) - '0'.charCodeAt(0)) {
    return 'La partita IVA non è valida:\n' + 'il codice di controllo non corrisponde.\n';
  }
  return '';
};

FICUtils.controllaCF = function (cf) {
  var validi = void 0,
      i = void 0,
      s = void 0,
      set1 = void 0,
      set2 = void 0,
      setpari = void 0,
      setdisp = void 0;
  if (cf == '') {
    return '';
  }
  cf = cf.toUpperCase();
  if (cf.length !== 16) {
    return 'La lunghezza del codice fiscale non è\n' + 'corretta: il codice fiscale dovrebbe essere lungo\n' + 'esattamente 16 caratteri.\n';
  }
  validi = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  for (i = 0; i < 16; i++) {
    if (validi.indexOf(cf.charAt(i)) === -1) {
      return 'Il codice fiscale contiene il carattere non valido \'' + cf.charAt(i) + '\'.\nI caratteri validi sono le lettere non accentate e le cifre.\n';
    }
  }
  set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
  setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
  s = 0;
  for (i = 1; i <= 13; i += 2) {
    s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }
  for (i = 0; i <= 14; i += 2) {
    s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }
  if (s % 26 !== cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
    return 'Il codice fiscale non è corretto:\n' + 'il codice di controllo non corrisponde.\n';
  }
  return '';
};

FICUtils.qtyPrecision = 6;

FICUtils.roundToDigit = function (num, digits) {
  if (num < 1.0e-6 && num > -1.0e-6) {
    return 0;
  }
  return +(Math.round(num * FICUtils.nSign(num) + 'e+' + digits) + 'e-' + digits) * FICUtils.nSign(num);
};

FICUtils.nSign = function (num) {
  if (num > 0) {
    return 1;
  }
  if (num < 0) {
    return -1;
  }
  return 0;
};

FICUtils.roundSignificative = function (n) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FICUtils.qtyPrecision;

  if (digits === undefined) {
    digits = 0;
  }
  var point = 0;
  var sign = FICUtils.nSign(n);
  n *= sign;
  if (n >= 1) {
    for (var i = 1; i < 15; i++) {
      if (n / Math.pow(10, i) < 1) {
        point = -i + digits;
        break;
      }
    }
  } else {
    for (var _i = 1; _i < 15; _i++) {
      if (n * Math.pow(10, _i) > 1) {
        point = _i + digits - 1;
        break;
      }
    }
  }
  if (point < 0) {
    return sign * FICUtils.roundToDigit(n / Math.pow(10, -point), 0) * Math.pow(10, -point);
  }
  return sign * FICUtils.roundToDigit(n, point);
};

FICUtils.dotsToCommas = function (txt) {
  if (txt === undefined) {
    return '';
  }
  return String(txt).replace('.', ',');
};

FICUtils.commasToDots = function (txt) {
  if (txt === undefined) {
    return '';
  }
  return String(txt).replace(',', '.');
};

FICUtils.getLanguageForCountry = function (country) {
  if (['Italia', 'San Marino', 'Svizzera', 'Città del Vaticano'].includes(country)) {
    return 'it';
  }
  if (['Germania', 'Austria'].includes(country)) {
    return 'de';
  }
  if (['Francia'].includes(country)) {
    return 'fr';
  }
  if (['Spagna'].includes(country)) {
    return 'es';
  }
  if (['Grecia'].includes(country)) {
    return 'el';
  }
  return 'en';
};

/**
 * @param obj
 * @param keyStartsWith
 * @returns object
 */
FICUtils.clearObject = function (obj) {
  var keyStartsWith = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

  for (var k in obj) {
    if (_typeof(obj[k]) === 'object' && obj[k]) {
      FICUtils.clearObject(obj[k]);
    } else if (k.charAt(0) === keyStartsWith) {
      delete obj[k];
    }
  }

  // here we have an object that in the worst case has elements link _keyName: {} || _keyName: [], we need to delete them all cause they are useless
  for (var _k in obj) {
    if (_k.charAt(0) !== keyStartsWith) {
      continue; // not a key that starts with [keyStartsWith]
    }
    // The property is an empty object and the key name starts with [keyStartsWith]
    if (Object.keys(obj[_k]).length === 0 && _k.charAt(0) === keyStartsWith) {
      delete obj[_k]; // delete that property
    }
  }

  return obj;
};

exports.default = FICUtils;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FICLink;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(107);

var _FICIcon = __webpack_require__(8);

var _FICIcon2 = _interopRequireDefault(_FICIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FICLink(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      href = _ref.href,
      target = _ref.target,
      style = _ref.style,
      text = _ref.text,
      inline = _ref.inline,
      disabled = _ref.disabled,
      iconLeft = _ref.iconLeft;

  var linkProps = {
    onClick: onClick,
    href: href,
    target: target
  };
  var innerClassName = className ? className + ' FICLink' : 'FICLink';
  if (disabled) {
    innerClassName += ' FICLink-disabled';
  }
  return _react2.default.createElement(
    'div',
    { className: innerClassName, style: _extends({}, style, {
        display: inline ? 'inline' : style.display
      }) },
    _react2.default.createElement(
      'a',
      linkProps,
      iconLeft && _react2.default.createElement(_FICIcon2.default, { name: iconLeft, style: { marginRight: text ? 4 : 0 } }),
      text
    )
  );
}

FICLink.propTypes = {
  target: _propTypes2.default.string,
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  disabled: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  inline: _propTypes2.default.bool,
  iconLeft: _propTypes2.default.string,
  className: _propTypes2.default.string
};

FICLink.defaultProps = {
  target: '_self',
  href: undefined,
  onClick: undefined,
  text: undefined,
  disabled: undefined,
  style: {},
  inline: false,
  iconLeft: null,
  className: null
};

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FAIcon = __webpack_require__(6);

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(104);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

PROPS:
- size: (default medium)
- icon: (default null)
- style
- onClick
- href

*/

function FICActionButton(props) {
  var className = 'fic-action-button fic-' + props.color + ' ' + props.size + (props.disabled ? ' fic-action-button-disabled' : '');
  return _react2.default.createElement(
    'a',
    {
      onClick: function onClick(event) {
        if (props.onClick && !props.disabled) {
          props.onClick(event);
        }
        event.stopPropagation();
      },
      onMouseOver: function onMouseOver(event) {
        if (props.onMouseOver) {
          props.onMouseOver(event);
        }
      },
      onMouseOut: function onMouseOut(event) {
        if (props.onMouseOut) {
          props.onMouseOut(event);
        }
      },
      href: props.href,
      target: props.target,
      title: props.title
    },
    _react2.default.createElement(_FAIcon2.default, {
      name: props.icon,
      className: className,
      style: props.style,
      fixedWidth: props.fixedWidth
    })
  );
}

FICActionButton.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  title: _propTypes2.default.string,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  style: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onMouseOut: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};

FICActionButton.defaultProps = {
  color: 'gray',
  size: 'large',
  href: undefined,
  target: undefined,
  icon: undefined,
  title: undefined,
  fixedWidth: false,
  disabled: false
};

exports.default = FICActionButton;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(98);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./FICTooltip.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./FICTooltip.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fic-tooltip{z-index:4000}.fic-tooltip-invisible{display:none}", ""]);

// exports


/***/ })

},[2402]);


// WEBPACK FOOTER //
// help-external.js